webpackJsonp([1],{

/***/ "+jyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__("GH5M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba63a258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__("5+DP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba63a258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/9kV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/B7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppCard_vue__ = __webpack_require__("kG5X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d2e3ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppCard_vue__ = __webpack_require__("b5BU");
function injectStyle (ssrContext) {
  __webpack_require__("w4Gt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78d2e3ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d2e3ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/KFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("AHJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c78745_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("COaz");
function injectStyle (ssrContext) {
  __webpack_require__("4Kk7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c78745_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0QUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapActions(['logout']))
});

/***/ }),

/***/ "0qad":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Vsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FooterSubscribe",
  data: function data() {
    return {
      email: null,
      message: {}
    };
  },

  methods: {
    showMessage: function showMessage(message) {
      this.message = message;
    },
    subscribe: function subscribe() {
      var _this = this;

      this.message = {};
      this.$http.post("subscription/subscribe", { email: this.email }).then(function (response) {
        _this.showMessage({
          text: "Thank you for subscribing!",
          alert: "alert-success"
        });
        _this.email = null;
      }, function (err) {
        // error callback
        if (err.body && err.body.message === "subscription.email.alreadysubscribed") {
          _this.showMessage({
            text: "Sorry, this email is already subscribed",
            alert: "alert-danger"
          });
        } else {
          _this.showMessage({
            text: "Sorry, your email is not valid",
            alert: "alert-danger"
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "1h55":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1juY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Purchases_vue__ = __webpack_require__("olDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90551c3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Purchases_vue__ = __webpack_require__("go7E");
function injectStyle (ssrContext) {
  __webpack_require__("hcUC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Purchases_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90551c3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Purchases_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1pnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-filter"},_vm._l((_vm.filterSections),function(label,section){return _c('div',{key:section,staticClass:"filter-group"},[_c('button',{staticClass:"filter-button",on:{"click":function($event){_vm.toggleSection(section)}}},[_vm._v("\n      "+_vm._s(label)+"\n      "),_c('span',{class:{'arrow-up': _vm.isSectionVisible(section), 'arrow-down': !_vm.isSectionVisible(section)}})]),_vm._v(" "),_c('transition',{attrs:{"name":"accordion"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSectionVisible(section)),expression:"isSectionVisible(section)"}],staticClass:"filter-content"},_vm._l((_vm.getItems(section)),function(item){return _c('div',{key:item,staticClass:"form-check"},[_c('div',{staticClass:"checkbox checkbox-css checkbox-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.categories),expression:"categories"}],attrs:{"type":"checkbox","id":("cssCheckbox_" + item)},domProps:{"value":item,"checked":Array.isArray(_vm.categories)?_vm._i(_vm.categories,item)>-1:(_vm.categories)},on:{"change":function($event){var $$a=_vm.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.categories=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"text-capitalize",attrs:{"for":("cssCheckbox_" + item)}},[_vm._v(_vm._s(item))])])])}))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1ui3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2+Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("aZuQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5147a8b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("5xyW");
function injectStyle (ssrContext) {
  __webpack_require__("atJ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5147a8b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5147a8b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "27dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n      List of customers\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.isLoading)?_c('span',[_vm._v("Loading..")]):_vm._e(),_vm._v(" "),((!_vm.customers || _vm.customers.length === 0) && !_vm.isLoading)?_c('span',[_vm._v("No customers")]):_vm._e(),_vm._v(" "),(_vm.customers && _vm.customers.length)?_c('table',{staticClass:"table table-hover table-bordered"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.customers),function(customer,index){return _c('tr',{key:customer._id},[_c('td',[_vm._v(_vm._s(customer.user.nickname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(customer.user.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(customer.product && customer.product.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(customer.created,'YYYY-MM-DD')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(customer.status))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'Edit customer', params: { _id: customer._id }}}},[_c('span',{staticClass:"fa fa-eye mr-2"})]),_vm._v(" "),_c('a',{attrs:{"href":"#delete"},on:{"click":function($event){_vm.deleteAction = { showModal: true, customer: customer}}}},[_c('span',{staticClass:"fa fa-minus-circle text-danger"})])],1)])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"confirm-customer-modal"},[(_vm.deleteAction.showModal)?_c('modal',{on:{"close":function($event){_vm.deleteAction.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirm delete customer")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Are you sure you want to delete the selected customer?")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('a',{staticClass:"btn btn-outline-info",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteAction.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"btn orange-btn-custom",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deletecustomer(_vm.deleteAction.customer)}}},[_vm._v("Delete customer")])])]):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Customer Nickname")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Customer Email")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Product")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Purchase Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Confirmed Demo")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Z9n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flash_vue__ = __webpack_require__("weFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f5f0a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flash_vue__ = __webpack_require__("P7ej");
function injectStyle (ssrContext) {
  __webpack_require__("dv7q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24f5f0a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f5f0a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2kSP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2saJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3djO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "49Cm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-2"},[_vm._v("Withdraw")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"content"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Kk7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4LUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-2"},[_vm._v("Dashboard")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('div',{staticClass:"widget widget-stats bg-gradient-green"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"stats-content"},[_c('div',{staticClass:"stats-title"},[_vm._v("PAGE VIEWS")]),_vm._v(" "),_c('div',{staticClass:"stats-number"},[_vm._v(_vm._s(_vm.stats.pageViews))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('div',{staticClass:"widget widget-stats bg-gradient-blue bg-gradient-blue-custom"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"stats-content"},[_c('div',{staticClass:"stats-title"},[_vm._v("CUSTOMERS")]),_vm._v(" "),_c('div',{staticClass:"stats-number"},[_vm._v(_vm._s(_vm.stats.customers))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('div',{staticClass:"widget widget-stats bg-gradient-purple"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"stats-content"},[_c('div',{staticClass:"stats-title"},[_vm._v("DOWNLOADS")]),_vm._v(" "),_c('div',{staticClass:"stats-number"},[_vm._v(_vm._s(_vm.stats.downloads))])])])])]),_vm._v(" "),_c('div',{staticClass:"row m-0 p-0"},[(!_vm.products.length&&!_vm.isLoading)?_c('div',{staticClass:"note note-purple m-b-15"},[_c('p',{staticClass:"p-0 m-0"},[_vm._v("You don't have an approved catalogs yet.")])]):_vm._e(),_vm._v(" "),(_vm.products.length)?_c('div',{staticClass:"panel"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"panel-body p-t-0"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-b-0 table-valign-middle"},[_vm._m(4,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product._id},[_c('td',[_c('p',[_vm._v(_vm._s(product.name))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(product.stats.pageViews))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(product.stats.users))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(product.stats.downloads))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"btn btn-sm orange-btn-custom-no-bg rounded-pill",staticStyle:{"width":"max-content"},attrs:{"to":{ name: 'Product', params: { slug: product.slug }}}},[_vm._v(" catalog")])],1)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"btn btn-sm orange-btn-custom-no-bg rounded-pill view-review",attrs:{"to":{ name: 'DashboardReview', params: { slug: product.slug }}}},[_vm._v("Reviews")])],1)])])}))])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-icon stats-icon-lg"},[_c('i',{staticClass:"fa fa-globe fa-fw"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-icon stats-icon-lg"},[_c('i',{staticClass:"fa fa-users fa-fw"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-icon stats-icon-lg"},[_c('i',{staticClass:"fa fa-cloud-download fa-fw"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading bg-light"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Catalogs Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"label"},[_vm._v(" Catalog Name")])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('span',{staticClass:"label bg-gradient-green"},[_vm._v("Total Page Views")])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('span',{staticClass:"label bg-gradient-blue bg-gradient-blue-custom"},[_vm._v("Total Customers")])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('span',{staticClass:"label bg-gradient-purple"},[_vm._v("Total Downloads")])]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4b9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__ = __webpack_require__("5kCF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328efd94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__ = __webpack_require__("ZbTt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_328efd94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4gdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicLayout_vue__ = __webpack_require__("S8ER");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06316f78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicLayout_vue__ = __webpack_require__("lTTr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06316f78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4k3W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4unu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AcceptTermsConditions_vue__ = __webpack_require__("i3MX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ffa17d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AcceptTermsConditions_vue__ = __webpack_require__("H0PP");
function injectStyle (ssrContext) {
  __webpack_require__("lYGf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AcceptTermsConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ffa17d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AcceptTermsConditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4zFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var BASE_AUTH_URL = 'auth';
var BASE_USER_URL = 'user';

/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(email, password) {
    var action = 'login';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(BASE_AUTH_URL + '/' + action, { email: email, password: password }).then(function (response) {
      return response.body.token;
    }).catch(function (error) {
      console.log(error);
      throw error;
    });
  },
  signUp: function signUp(payload) {
    var action = 'signup';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(BASE_AUTH_URL + '/' + action, payload).then(function (response) {
      return response.body.token;
    }).catch(function (error) {
      console.log(error);
      throw error;
    });
  },
  getCurrentUser: function getCurrentUser() {
    var action = 'me';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(BASE_USER_URL + '/' + action).then(function (response) {
      return response.body;
    }).catch(function (error) {
      console.log(error);
      throw error;
    });
  },
  renewPassword: function renewPassword(email) {
    var action = 'renewpassword';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(BASE_AUTH_URL + '/' + action, { email: email }).then(function (response) {
      return response.body;
    }).catch(function (error) {
      console.log(error);
      throw error;
    });
  },
  confirmEmail: function confirmEmail(email) {
    var action = 'confirmemail';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(BASE_AUTH_URL + '/' + action, { email: email }).then(function (response) {
      return response.body;
    }).catch(function (error) {
      console.log(error);
      throw error;
    });
  },
  acceptTermsConditions: function acceptTermsConditions(accept) {
    var action = 'me/firstconnection';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(BASE_USER_URL + '/' + action, { accept: accept }).then(function (response) {
      return response.body;
    }).catch(function (error) {
      console.log(error);
      throw error;
    });
  }
});

/***/ }),

/***/ "5+DP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid mr-2",class:{ spinner: _vm.isLoading},staticStyle:{"width":"32px","height":"32px"},attrs:{"src":"/beta/static/logo-64x64.png","alt":"womia"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5VP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light",class:{ 'sidebar-open': _vm.isOpen, 'expanded': _vm.isExpanded },attrs:{"id":"sidebar"},on:{"mouseover":_vm.showFullSidebar,"mouseleave":_vm.hideFullSidebar}},[_c('div',{staticClass:"header-logo"}),_vm._v(" "),_c('ul',_vm._l((_vm.navItems),function(item,index){return _c('li',{key:index,class:{ 'selected': _vm.selectedIndex === index },on:{"click":function($event){_vm.selectItem(index)}}},[_c('div',{staticClass:"icon-container"},[_c('i',{class:item.icon,staticStyle:{"background-color":"#E95913","border-radius":"100%","padding":"13px","color":"white"}})]),_vm._v(" "),_c('span',{staticClass:"fw-bolder fs-16px mb-2 title",class:{ 'visible': _vm.isTitleVisible }},[_vm._v(_vm._s(item.name))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5X3c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5cG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n      List of Subscribers\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.isLoading)?_c('span',[_vm._v("Loading..")]):_vm._e(),_vm._v(" "),((!_vm.subscribers || _vm.subscribers.length === 0) && !_vm.isLoading)?_c('span',[_vm._v("No Subscribers")]):_vm._e(),_vm._v(" "),(_vm.subscribers && _vm.subscribers.length)?_c('table',{staticClass:"table table-hover table-bordered"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.subscribers),function(subscriber,index){return _c('tr',{key:subscriber._id},[_c('td',[_c('span',[_vm._v(_vm._s(subscriber.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(subscriber.email))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge",class:{'badge-success rounded-pill': subscriber.active, 'badge-warning rounded-pill': !subscriber.active}},[_vm._v(_vm._s((subscriber.active) ? 'active' : 'inactive'))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(subscriber.created,'YYYY-MM-DD')))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'Edit subscriber', params: { _id: subscriber._id }}}},[_c('span',{staticClass:"fa fa-eye mr-2"})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Edit subscriber', params: { _id: subscriber._id }}}},[_c('span',{staticClass:"fa fa-edit mr-2"})]),_vm._v(" "),_c('a',{attrs:{"href":"#delete"},on:{"click":function($event){_vm.deleteAction = { showModal: true, subscriber: subscriber}}}},[_c('span',{staticClass:"fa fa-minus-circle text-danger"})])],1)])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"confirm-subscriber-modal"},[(_vm.deleteAction.showModal)?_c('modal',{on:{"close":function($event){_vm.deleteAction.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirm delete Subscriber")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Are you sure you want to delete the selected subscriber?")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('a',{staticClass:"btn btn-outline-info",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteAction.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"btn orange-btn-custom",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteSubscriber(_vm.deleteAction.subscriber)}}},[_vm._v("Delete Subscriber")])])]):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5h2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"section pt-0"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row gx-0 align-items-center"},[_c('div',{staticClass:"col-lg-6 mb-4 mb-lg-0"},[_c('img',{staticClass:"mw-100",staticStyle:{"height":"431px","width":"575px"},attrs:{"src":_vm.$options.filters.media(_vm.product.logo.slug),"alt":"Product Image"}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 px-lg-5"},[_c('div',{staticClass:"display-5 fw-bolder mb-2"},[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('div',{staticClass:"fs-20px fw-bold text-gray-600 mb-3 mb-lg-5 textgray",domProps:{"innerHTML":_vm._s(_vm.product.description)}})])])])]),_vm._v(" "),_c('div',{staticClass:"section pt-0 mt-n5 mt-lg-0"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"fw-bolder display-4"},[_vm._v(_vm._s(_vm._f("moment")(_vm.product.created,'YYYY')))]),_vm._v(" "),_c('div',{staticClass:"fw-bolder h4 text-gray-500 mb-lg-0"},[_vm._v("created since")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"fw-bolder display-4 "},[_vm._v(_vm._s(_vm.product.patient))]),_vm._v(" "),_c('div',{staticClass:"fw-bolder h4 text-gray-500 mb-lg-0"},[_vm._v("Number of studies")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"fw-bolder display-4 text-capitalize"},[_vm._v(_vm._s(_vm.product.annotated))]),_vm._v(" "),_c('div',{staticClass:"fw-bolder h4 text-gray-500 mb-lg-0 "},[_vm._v("Annotated")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"fw-bolder display-4 "},[_vm._v(_vm._s(_vm.product.age))]),_vm._v(" "),_c('div',{staticClass:"fw-bolder h4 text-gray-500 mb-lg-0"},[_vm._v("Age")])])])])]),_vm._v(" "),_c('div',{staticClass:"footer section bg-light"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row gx-lg-5 "},[_vm._l((_vm.filteredCategories),function(categoryItems,categoryKey,index){return (categoryItems.length > 0)?_c('div',{key:categoryKey,staticClass:"col-lg-2   row-spacing"},[_c('h4',{staticClass:"footer-title text-capitalize"},[_vm._v(_vm._s(_vm.formatCategoryTitle(categoryKey))+"\n            ")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list "},_vm._l((categoryItems),function(item,index){return _c('li',{key:index},[_c('a',{staticClass:" category-tags",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.formatCategoryItem(categoryKey, item)))])])}))]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"col-lg-2 row-spacing"},[_c('h4',{staticClass:"footer-title  "},[_vm._v("Device")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{staticClass:" category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.device[0]))])]),_vm._v(" "),(_vm.product.device.length > 1)?_c('li',[_c('a',{staticClass:" category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.device[1]))])]):_vm._e(),_vm._v(" "),(_vm.product.device.length > 2)?_c('li',[_c('a',{staticClass:" category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.device[2]))])]):_vm._e(),_vm._v(" "),(_vm.product.device.length > 3)?_c('li',[_c('a',{staticClass:"category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.device[3]))])]):_vm._e()])]),_vm._v(" "),(_vm.product.formats && _vm.product.formats.length)?_c('div',{staticClass:"col-lg-2 row-spacing "},[_c('h4',{staticClass:"footer-title "},[_vm._v("Format")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{staticClass:"category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.formats[0]))])]),_vm._v(" "),(_vm.product.formats.length > 1)?_c('li',[_c('a',{staticClass:"category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.formats[1]))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.product.outcomes && _vm.product.outcomes.length)?_c('div',{staticClass:"col-lg-2 mg-lg-0 "},[_c('h4',{staticClass:"footer-title  "},[_vm._v("Outcomes")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{staticClass:" category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.outcomes))])])])]):_vm._e(),_vm._v(" "),(_vm.product.multiCentric && _vm.product.multiCentric.length)?_c('div',{staticClass:"col-lg-2 mg-lg-0 "},[_c('h4',{staticClass:"footer-title "},[_vm._v("Multi Centric")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{staticClass:" category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.multiCentric))])])])]):_vm._e(),_vm._v(" "),(_vm.product.contrastEnhanced && _vm.product.contrastEnhanced.length)?_c('div',{staticClass:"col-lg-2 mg-lg-0 "},[_c('h4',{staticClass:"footer-title "},[_vm._v("Contrast Enhanced")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{staticClass:" category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.contrastEnhanced))])])])]):_vm._e(),_vm._v(" "),(_vm.product.multiDevice && _vm.product.multiDevice.length)?_c('div',{staticClass:"col-lg-2 mg-lg-0"},[_c('h4',{staticClass:"footer-title "},[_vm._v("Multi Device")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{staticClass:" category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.multiDevice))])])])]):_vm._e(),_vm._v(" "),(_vm.product.followUp && _vm.product.followUp.length)?_c('div',{staticClass:"col-lg-2 mg-lg-0"},[_c('h4',{staticClass:"footer-title "},[_vm._v("Follow Up")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{staticClass:" category-tags  text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.followUp))])])])]):_vm._e(),_vm._v(" "),(_vm.product.gender && _vm.product.gender.length)?_c('div',{staticClass:"col-lg-2 mg-lg-0 "},[_c('h4',{staticClass:"footer-title "},[_vm._v("Gender")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{staticClass:" category-tags text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.product.gender))])])])]):_vm._e(),_vm._v(" "),(_vm.product.country && _vm.product.country.length)?_c('div',{staticClass:"col-lg-2 mg-lg-0"},[_c('h4',{staticClass:"footer-title"},[_vm._v("Country")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},_vm._l((_vm.splitCountries),function(country,index){return _c('li',{key:index},[_c('a',{staticClass:"category-tags text-capitalize",attrs:{"href":"#"}},[_vm._v(_vm._s(country))])])}))]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"section with-logo p-0 "},[_c('div',{staticClass:"section  "},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-lg-12 ",attrs:{"data-v-49f1c9d8":""}},[_c('div',{staticClass:"news ask-demo bg-light rounded-3 overflow-hidden shadow-lg mb-5 mb-lg-0",attrs:{"data-v-49f1c9d8":""}},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-10"},[_c('div',{staticClass:"row gx-lg-5 "},[_c('div',{staticClass:"col-lg-3"}),_vm._v(" "),_c('div',{staticClass:"col-lg-6 pb-lg-5"},[(!_vm.purchase)?_c('button',{staticClass:"btn btn-lg d-flex w-100 btn-primary get-started  rounded-2 fw-bold fs-16px py-3  justify-content-center",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.install($event)}}},[_vm._v("\n                        Ask access\n                      ")]):_vm._e(),_vm._v(" "),(_vm.purchase)?_c('div',{staticClass:"fs-14px mb-3 d-flex align-items-center justify-content-center"},[_vm._v("\n                        You asked an access of "+_vm._s(_vm.product.name)+" on\n                        "+_vm._s(_vm._f("moment")(_vm.purchase.created,"YYYY-MM-DD"))+"\n                      ")]):_vm._e(),_vm._v(" "),(_vm.purchase)?_c('router-link',{staticClass:"btn btn-lg d-flex w-100 btn-primary get-started  rounded-2 fw-bold fs-16px py-3  justify-content-center",attrs:{"to":{ name: 'Install', params: { id: _vm.purchase._id } }}},[_vm._v("\n                        Access Asked\n                      ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3"})])])])])])])])]),_vm._v(" "),(_vm.product.publications && _vm.product.publications.length)?_c('div',{staticClass:"section pt-0"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section-subtitle"},[_vm._v("\n        Catalog related to the same studies\n      ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"align-items-center"},[_c('ul',{staticClass:"list-unstyled mb-0"},_vm._l((_vm.product.publications),function(pub){return _c('div',{key:pub.link,staticClass:"p-4 bg-light position-relative border-start border-5 border-warning mb-2 pub.link pub-custom-hover",on:{"mouseover":function($event){_vm.setHovered(pub.link, true)},"mouseout":function($event){_vm.setHovered(pub.link, false)}}},[_c('div',{key:pub.link,staticClass:"d-flex align-items-center custom"},[_c('div',[_c('a',{staticStyle:{"color":"#2d353c"},attrs:{"href":pub.link,"target":"_new"}},[_c('strong',[_vm._v(_vm._s(pub.title))])])])])])}))])])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section pt-4 pb-0"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex mb-5"},[_c('div',{staticClass:"mb-0"},[_c('a',{staticClass:"hero-btn fw-bold  text-decoration-none d-inline-flex align-items-center back-home",staticStyle:{"position":"relative","color":"black"},attrs:{"href":"/beta"}},[_c('span',[_c('i',{staticClass:"fa fa-fw fa-arrow-left "})]),_vm._v("\n              Back\n            ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container "},[_c('div',{staticClass:"pt-lg-5 pb-lg-3 text-center"},[_c('b',[_c('div',{staticClass:"display-6 fw-bolder mb-3 d-flex align-items-center justify-content-center"},[_vm._v("\n                    Start discovering the data\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"sparator",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.2)","margin":"0 280px 17px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5kCF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Edit user'
});

/***/ }),

/***/ "5xKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__("DAIf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1febee05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__("ynBv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1febee05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "5xyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-space-30"},[_c('div',{staticClass:"col-lg-12"},[_c('h4',[_vm._v("Have a question?")]),_vm._v(" "),_c('p',[_vm._v("Contact us ")]),_vm._v(" "),(_vm.message.text)?_c('div',{staticClass:"alert text-center",class:_vm.message.alert,attrs:{"role":"alert"}},[_vm._v("\n                        "+_vm._s(_vm.message.text)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"row gx-2"},[_c('div',{staticClass:"col-lg-6 mb-2"},[_c('div',{staticClass:"input-group"},[_vm._m(1,false,false),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.youare),expression:"userContact.youare"}],staticClass:"form-select form-select-lg",class:{ 'text-muted': !_vm.userContact.youare },attrs:{"required":"","aria-label":"You Are *"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userContact, "youare", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("You Are *")]),_vm._v(" "),_c('option',{attrs:{"value":"Clinician"}},[_vm._v("Clinician")]),_vm._v(" "),_c('option',{attrs:{"value":"Healthcare institution"}},[_vm._v("Healthcare institution")]),_vm._v(" "),_c('option',{attrs:{"value":"University"}},[_vm._v("University")]),_vm._v(" "),_c('option',{attrs:{"value":"Developer"}},[_vm._v("Developer")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 mb-2"},[_c('div',{staticClass:"input-group"},[_vm._m(2,false,false),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.ineedto),expression:"userContact.ineedto"}],staticClass:"form-select form-select-lg",class:{ 'text-muted': !_vm.userContact.ineedto },attrs:{"required":"","aria-label":"You Need To *"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userContact, "ineedto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("You Need To *")]),_vm._v(" "),_c('option',{attrs:{"value":"Get more informations"}},[_vm._v("Get more informations")]),_vm._v(" "),_c('option',{attrs:{"value":"Create your Data catalog"}},[_vm._v("Create your Data catalog")]),_vm._v(" "),_c('option',{attrs:{"value":"Distribute your  Data catalog"}},[_vm._v("Distribute your  Data catalog")]),_vm._v(" "),_c('option',{attrs:{"value":"Annotate your Data catalog"}},[_vm._v("Annotate your Data catalog")])])])])]),_vm._v(" "),_c('div',{staticClass:"row gx-2"},[_c('div',{staticClass:"col-lg-6 mb-2"},[_c('div',{staticClass:"input-group"},[_vm._m(3,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.fullname),expression:"userContact.fullname"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Full Name *","required":""},domProps:{"value":(_vm.userContact.fullname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userContact, "fullname", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 mb-2"},[_c('div',{staticClass:"input-group"},[_vm._m(4,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.email),expression:"userContact.email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","placeholder":"Professionnal Email *","required":""},domProps:{"value":(_vm.userContact.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userContact, "email", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row gx-2"},[_c('div',{staticClass:"col-lg-6 mb-2"},[_c('div',{staticClass:"input-group"},[_vm._m(5,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.institution),expression:"userContact.institution"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Institution Name *","required":""},domProps:{"value":(_vm.userContact.institution)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userContact, "institution", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 mb-2"},[_c('div',{staticClass:"input-group"},[_vm._m(6,false,false),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.country),expression:"userContact.country"}],staticClass:"form-select form-select-lg",class:{ 'text-muted': !_vm.userContact.country },attrs:{"required":"","aria-label":"Country *"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userContact, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Country *")]),_vm._v(" "),_vm._l((_vm.countries),function(country){return _c('option',{key:country.value,domProps:{"value":country.value}},[_vm._v("\n                                            "+_vm._s(country.name)+"\n                                        ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"mb-2 pb-2px"},[_c('div',{staticClass:"input-group"},[_vm._m(7,false,false),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.message),expression:"userContact.message"}],staticClass:"form-control form-control-lg",attrs:{"rows":"6","placeholder":"Message *","required":""},domProps:{"value":(_vm.userContact.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userContact, "message", $event.target.value)}}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary get-started rounded-pill",on:{"click":function($event){$event.preventDefault();_vm.sendContactUsMsg($event)}}},[_vm._v("Send Message")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section py-5"},[_c('div',{staticClass:"section-bg",staticStyle:{"background-image":"url(/beta/static/img/contact-bg/contact-paris.jpg)"}}),_vm._v(" "),_c('div',{staticClass:"section-bg bg-gray-800 opacity-50"}),_vm._v(" "),_c('div',{staticClass:"container position-relative text-white text-center"},[_c('div',{staticClass:"display-6 fw-bolder"},[_vm._v("Let's Work Together")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-vcard-o"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-handshake-o"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-user-o"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-at"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-building-o"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-globe"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-text",staticStyle:{"align-items":"flex-start"}},[_c('i',{staticClass:"fa fa-envelope-o"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "606M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppsDev_vue__ = __webpack_require__("tihL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58554eec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppsDev_vue__ = __webpack_require__("d5Qi");
function injectStyle (ssrContext) {
  __webpack_require__("Ud8+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58554eec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppsDev_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58554eec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppsDev_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6RSC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6S//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6hd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 bg-light position-relative border-start border-5 border-warning mb-2",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"fs-16px mb-3 fw-bolder line-h-11 d-flex",staticStyle:{"position":"relative"}},[_vm._v(_vm._s(_vm._f("`${item.author.firstName} ${item.author.lastName}`")(_vm.item.author.nickname))+"\n    "),_c('rating',{staticClass:"review-star ",staticStyle:{"margin-left":"10px","position":"relative"},attrs:{"rate":_vm.item.rate}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',[_c('div',{staticClass:"fw-bold text-gray-600 fs-12px line-h-12",staticStyle:{"position":"relative"}},[(_vm.item.comment.length > 150)?_c('span',[_vm._v("\n              "+_vm._s(_vm.showFullComment ? _vm.item.comment : _vm.truncatedComment)+"\n              "),_c('span',{staticStyle:{"cursor":"pointer","font-size":"10px"},on:{"click":_vm.toggleFullComment}},[_vm._v("\n                "+_vm._s(_vm.showFullComment ? " ..Show less" : "...")+"\n              ")])]):_c('span',[_vm._v("\n              "+_vm._s(_vm.item.comment)+"\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6yNC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__("dMBU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__("92/6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__("5xKQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__("HFPF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__("7XYw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__("xhzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__("LAbd");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),

/***/ "7+SM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n      List of users\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.isLoading)?_c('span',[_vm._v("Loading..")]):_vm._e(),_vm._v(" "),((!_vm.users || _vm.users.length === 0) && !_vm.isLoading)?_c('span',[_vm._v("No users")]):_vm._e(),_vm._v(" "),(_vm.users && _vm.users.length)?_c('table',{staticClass:"table table-hover table-bordered"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user,index){return _c('tr',{key:user._id},[_c('td',[_c('span',[_vm._v(_vm._s(user.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.nickname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',_vm._l((user.roles),function(role){return _c('span',[_vm._v(_vm._s(role)+",")])})),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge",class:{'badge-success rounded-pill': user.active, 'badge-warning rounded-pill': !user.active}},[_vm._v(_vm._s((user.active) ? 'active' : 'inactive'))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(user.created,'YYYY-MM-DD')))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'Edit user', params: { _id: user._id }}}},[_c('span',{staticClass:"fa fa-eye mr-2"})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Edit user', params: { _id: user._id }}}},[_c('span',{staticClass:"fa fa-edit mr-2"})]),_vm._v(" "),_c('a',{attrs:{"href":"#delete"},on:{"click":function($event){_vm.deleteAction = { showModal: true, user: user}}}},[_c('span',{staticClass:"fa fa-minus-circle text-danger"})])],1)])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"confirm-user-modal"},[(_vm.deleteAction.showModal)?_c('modal',{on:{"close":function($event){_vm.deleteAction.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirm delete User")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Are you sure you want to delete the selected user?")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('a',{staticClass:"btn btn-outline-info",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteAction.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"btn orange-btn-custom",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteUser(_vm.deleteAction.user)}}},[_vm._v("Delete User")])])]):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Username")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Roles")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("SignUp Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7FLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Auth',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(['isLoading']))
});

/***/ }),

/***/ "7FLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dialog__ = __webpack_require__("deIM");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListSubscribersAdmin',
  components: { 'modal': __WEBPACK_IMPORTED_MODULE_2__components_Dialog__["a" /* default */] },
  data: function data() {
    return {
      isLoading: true,
      subscribers: null,
      deleteAction: {
        showModal: false,
        subscriber: null
      }
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (subscribers) {
      return _this.subscribers = _this.populateSubscribers(subscribers);
    });
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(['currentSubscriber'])),
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      return this.$http.get('subscription/admin').then(function (response) {
        _this2.isLoading = false;
        return response.data;
      }, function () {
        _this2.isLoading = false;
      });
    },
    populateSubscribers: function populateSubscribers(subscribers) {
      // Prepare data for each subscriber update set
      return subscribers;
    },
    deleteSubscriber: function deleteSubscriber(subscriber) {
      var _this3 = this;

      // Hide Modal
      console.log(subscriber._id);
      this.deleteAction.showModal = false;
      this.$http.delete('subscription/admin/' + subscriber._id).then(function (response) {
        _this3.fetchData().then(function (subscribers) {
          return _this3.subscribers = _this3.populateSubscribers(subscribers);
        });
      }, function () {
        // error callback
        _this3.showErrorMessage('Sorry but an error occurred when submitting form');
      });
    }
  }
});

/***/ }),

/***/ "7XYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("vUmB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aca681_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("p68w");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aca681_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7hBx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "85L4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"margin-bottom-0",attrs:{"method":"post","action":"#"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.success),expression:"message.success"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.message.success)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.success),expression:"message.success"}],staticClass:"text-center m-t-2"},[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":{ name: 'Login'}}},[_vm._v("Go to Login")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.message.success),expression:"!message.success"}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.error),expression:"message.error"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.message.error)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-group m-b-15"},[_c('label',{attrs:{"for":"password-input"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.$v.password.$error},attrs:{"type":"password","id":"password-input"},domProps:{"value":(_vm.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},function($event){_vm.$v.password.$touch()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.save()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.password.$error)?_c('div',{class:{'invalid-feedback': !_vm.$v.password.minLength}},[_vm._v("Password min length is 6")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group m-b-15"},[_c('label',{attrs:{"for":"confirm-password-input"}},[_vm._v("Confirm password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.confirmPassword),expression:"confirmPassword",modifiers:{"trim":true}}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.$v.confirmPassword.$error},attrs:{"type":"password","id":"confirm-password-input"},domProps:{"value":(_vm.confirmPassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value.trim()},function($event){_vm.$v.confirmPassword.$touch()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.save()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.confirmPassword.$error)?_c('div',{class:{'invalid-feedback': !_vm.$v.confirmPassword.sameAsPassword}},[_vm._v("Passwords must be identical.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"login-buttons mt-2"},[_c('button',{staticClass:"btn btn-primary get-started rounded-pill btn-block mb-2",staticStyle:{"width":"100%","padding":"10px 16px","font-size":"18px"},attrs:{"type":"submit"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.save()}}},[_vm._v("Change password")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-white rounded-pill btn-block",staticStyle:{"width":"100%","padding":"10px 16px","font-size":"18px"},attrs:{"role":"button","type":"cancel","to":{ name: 'Profile'}}},[_vm._v("Cancel")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8922":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8O9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListCustomer_vue__ = __webpack_require__("KuFQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d037f952_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListCustomer_vue__ = __webpack_require__("27dw");
function injectStyle (ssrContext) {
  __webpack_require__("nZbe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d037f952"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d037f952_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8ZpE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RatingStats_vue__ = __webpack_require__("qUbB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cac94000_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RatingStats_vue__ = __webpack_require__("yLAr");
function injectStyle (ssrContext) {
  __webpack_require__("vHAx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RatingStats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cac94000_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RatingStats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8isX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8jHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawDeveloper_vue__ = __webpack_require__("ASgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63637a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawDeveloper_vue__ = __webpack_require__("49Cm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawDeveloper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b63637a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawDeveloper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8l7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsProfile_vue__ = __webpack_require__("o2wI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83418c32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsProfile_vue__ = __webpack_require__("Ek3L");
function injectStyle (ssrContext) {
  __webpack_require__("w7bK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83418c32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83418c32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8vMr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dialog__ = __webpack_require__("deIM");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListUsersAdmin',
  components: { 'modal': __WEBPACK_IMPORTED_MODULE_2__components_Dialog__["a" /* default */] },
  data: function data() {
    return {
      isLoading: true,
      users: null,
      deleteAction: {
        showModal: false,
        user: null
      }
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (users) {
      return _this.users = _this.populateUsers(users);
    });
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(['currentUser'])),
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      return this.$http.get('user/admin').then(function (response) {
        _this2.isLoading = false;
        return response.data;
      }, function () {
        _this2.isLoading = false;
      });
    },
    populateUsers: function populateUsers(users) {
      // Prepare data for each user update set
      return users;
    },
    deleteUser: function deleteUser(user) {
      var _this3 = this;

      // Hide Modal
      console.log(user._id);
      this.deleteAction.showModal = false;
      this.$http.delete('user/admin/' + user._id).then(function (response) {
        _this3.fetchData().then(function (users) {
          return _this3.users = _this3.populateUsers(users);
        });
      }, function () {
        // error callback
        _this3.showErrorMessage('Sorry but an error occurred when submitting form');
      });
    }
  }
});

/***/ }),

/***/ "92/6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__("tR2v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d698d5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__("TWxd");
function injectStyle (ssrContext) {
  __webpack_require__("6S//")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d698d5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d698d5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "98WO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__ = __webpack_require__("rKME");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4d67ad8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__ = __webpack_require__("NxHG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4d67ad8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "99X2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "99g6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9PtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Install_vue__ = __webpack_require__("kTk6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed430f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Install_vue__ = __webpack_require__("TQxC");
function injectStyle (ssrContext) {
  __webpack_require__("pzqv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Install_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed430f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Install_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9RSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section",attrs:{"id":"subscribe"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-md-12 justify-content-center mb-3",staticStyle:{"display":"flex"}},[_c('h3',[_vm._v("\n            Unleach the power of your medical data with womia "),_c('br'),_vm._v(" "),_c('div',{staticClass:"sparator mt-4",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.2)","margin":"0 -80px"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 justify-content-center",staticStyle:{"display":"flex","font-size":"20px"}},[_c('div',{staticClass:"social subscription"},[_c('div',{staticClass:"social-list"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-facebook"})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-twitter"})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/company/womia-io/"}},[_c('i',{staticClass:"fa fa-linkedin"})])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9XK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'DashboardDeveloper',
  data: function data() {
    return {
      isLoading: true,
      stats: {
        pageViews: 0,
        customers: 0,
        downloads: 0
      },
      products: []
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (products) {
      var productsWithUpdateVersion = _this.populateProducts(products);
      productsWithUpdateVersion.forEach(function (productsUpdateSet) {
        productsUpdateSet[1].forEach(function (product, index) {
          if (index === 0) _this.products.push(product);
        });
      });
      _this.getStatsAllApps(_this.products);
      _this.isLoading = false;
    }, function () {
      _this.isLoading = false;
    });
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].mapGetters(['currentUser'])),
  methods: {
    fetchData: function fetchData() {
      return this.$http.get('product/dev-approved-apps/').then(function (resp) {
        return resp.data;
      });
    },
    populateProducts: function populateProducts(products) {
      // TODO: change this groupBy by lodash way
      products = products.reduce(function (groups, item) {
        var val = item['slugRef'];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
      }, {});
      // Convert Object To Array and sort it by last update
      products = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(products).map(function (key) {
        products[key] = _.orderBy(products[key], 'technicalDetails.update', 'desc');
        return [key, products[key]];
      });
      return products;
    },
    getStatsAllApps: function getStatsAllApps(products) {
      var _this2 = this;

      products.forEach(function (product) {
        _this2.stats.pageViews += product.stats.pageViews;
        _this2.stats.customers += product.stats.users;
        _this2.stats.downloads += product.stats.downloads;
      });
    }
  }
});

/***/ }),

/***/ "9o0M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9yGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/beta/admin/dashboard',
    icon: 'fa fa-th-large'
  }, {
    name: 'Catalog Management',
    url: '/beta/admin/product',
    icon: 'fa fa-inbox'
  }, {
    name: 'Users',
    url: '/beta/admin/user',
    icon: 'fa fa-user'
  }, {
    name: 'Customers',
    url: '/beta/admin/customer',
    icon: 'fa fa-address-book'
  }, {
    name: 'Subscribers',
    url: '/beta/admin/subscribers',
    icon: 'fa fa-feed'
  }]
});

/***/ }),

/***/ "9z4z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),

/***/ "AHJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  data: function data() {
    return {
      searchInput: null
    };
  },

  watch: {
    searchInput: function searchInput(val) {
      this.$emit('searchText', val.trim()); // Emit the searchText event with trimmed value
    }
  }
});

/***/ }),

/***/ "AR0e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ASgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'DashboardDeveloper',
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),

/***/ "Av2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"]
    },
    password: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      message: null,
      email: null,
      password: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapActions(['login', 'startLoading', 'endLoading', 'flash']), {
    hideErrorMessage: function hideErrorMessage() {
      this.message = null;
    },
    showErrorMessage: function showErrorMessage(message) {
      this.message = message;
    },
    sendLogin: function sendLogin() {
      var _this = this;

      this.hideErrorMessage();
      if (!this.$v.email.$invalid && !this.$v.password.$invalid) {
        this.startLoading();
        this.login({ email: this.email, password: this.password }).then(function () {
          _this.flash({
            message: 'You are successfully authenticated',
            type: 'success'
          });
          if (_this.$route.query && _this.$route.query.redirect) {
            _this.$router.push({ path: _this.$route.query.redirect });
          } else {
            _this.$router.push('Home');
          }
        }).catch(function (err) {
          _this.showErrorMessage('Login/Password is not valid, please try again');
          console.log('Failed when login', err);
        }).finally(function () {
          return _this.endLoading();
        });
      } else {
        this.showErrorMessage('Login/Password must not be empty, please fill all fields and try again');
      }
    }
  })
});

/***/ }),

/***/ "B9yL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BekM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__("yERT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b408bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__("pjTg");
function injectStyle (ssrContext) {
  __webpack_require__("2saJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b408bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BmoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.purchase)?_c('form',{attrs:{"novalidate":""}},[_c('h3',{staticClass:"mb-2"},[_vm._v("Create review on Catalog '"+_vm._s(_vm.purchase.product.name)+"'")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.successfeedback)?_c('div',{staticClass:"alert alert-success"},[_vm._v("Thank you for your review!")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"rate"}},[_vm._v("Rate")]),_vm._v(" "),_c('star-rating',{class:{'is-invalid': _vm.$v.review.comment.$invalid},attrs:{"id":"rate","read-only":_vm.isDisabled},model:{value:(_vm.review.rate),callback:function ($$v) {_vm.$set(_vm.review, "rate", $$v)},expression:"review.rate"}}),_vm._v(" "),(_vm.$v.review.rate.$invalid)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please fill stars")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group mt-3 mb-3"},[_c('label',{staticClass:"mb-2",attrs:{"for":"comment"}},[_vm._v("Comment:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.review.comment),expression:"review.comment"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.review.comment.$error},attrs:{"id":"comment","rows":"3"},domProps:{"value":(_vm.review.comment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.review, "comment", $event.target.value)},function($event){_vm.$v.review.comment.$touch()}]}}),_vm._v(" "),(_vm.$v.review.comment.$error)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please fill the comment. We appreciate all feedback we receive.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group text-center "},[_c('button',{staticClass:"btn btn-primary get-started mr-2 rounded-pill",attrs:{"type":"submit"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.save()}}},[_vm._v("Send review")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-white rounded-pill",attrs:{"role":"button","type":"cancel","to":{ name: 'MyPurchases'}}},[_vm._v("Cancel")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C+oc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardReview_vue__ = __webpack_require__("enFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cda4fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardReview_vue__ = __webpack_require__("p3FZ");
function injectStyle (ssrContext) {
  __webpack_require__("SZ+K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21cda4fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardReview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cda4fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardReview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C3za":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logout',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapActions(['logout'])),
  created: function created() {
    this.logout();
    this.$router.push({ path: '/beta/auth' });
  }
});

/***/ }),

/***/ "COaz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative p-1 mt-3 search-width"},[_vm._m(0,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control ps-5 rounded-2 fw-normal",attrs:{"type":"text","placeholder":"Search...","aria-label":"Search..."},domProps:{"value":(_vm.searchInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default position-absolute start-0 bg-none border-0",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search fa-fw"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CtQy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__("4zFs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");



var _mutations;




var state = {
  isAuthenticated: !!localStorage.getItem('authToken'),
  authToken: localStorage.getItem('authToken'),
  currentUser: null
};

var getters = {
  authToken: function authToken(state) {
    return state.authToken;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.isAuthenticated;
  },
  hasRole: function hasRole(state) {
    return function (roles) {
      if (!state.currentUser || !state.currentUser.roles) return false;
      var hasRole = false;
      roles.forEach(function (role) {
        if (state.currentUser.roles.includes(role)) {
          hasRole = true;
        }
      });
      return hasRole;
    };
  },
  currentUser: function currentUser(state) {
    return state.currentUser;
  }
};

var actions = {
  acceptTermsConditions: function acceptTermsConditions(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].acceptTermsConditions(payload.accept).then(function () {
      return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getCurrentUser();
    }).then(function (user) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].USER_LOADED, user);
    }).catch(function (err) {
      throw new Error(err.bodyText);
    });
  },
  renewPassword: function renewPassword(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].renewPassword(payload.email).then(function () {}).catch(function (err) {
      throw new Error(err.bodyText);
    });
  },
  checkAuth: function checkAuth(_ref3, payload) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if (state.authToken) {
      return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getCurrentUser().then(function (user) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].USER_LOADED, user);
      }).catch(function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].AUTHENTICATE_FAILURE, err);
        throw new Error('Error when login', err);
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    }
  },
  login: function login(_ref4, payload) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var email = payload.email;
    var password = payload.password;
    return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].login(email, password).then(function (token) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].AUTHENTICATE_SUCCESS, token);
    }).then(function () {
      return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getCurrentUser();
    }).then(function (user) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].USER_LOADED, user);
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].AUTHENTICATE_FAILURE, err);
      throw new Error('Error when login');
    });
  },
  signUp: function signUp(_ref5, payload) {
    var commit = _ref5.commit,
        state = _ref5.state;

    return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].signUp(payload).then(function () {
      return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].confirmEmail(payload.email);
    }).catch(function (err) {
      throw new Error(err.bodyText);
    });
  },
  logout: function logout(_ref6, payload) {
    var commit = _ref6.commit,
        state = _ref6.state;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].AUTHENTICATE_FAILURE, new Error('logout'));
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].AUTHENTICATE_SUCCESS, function (state, payload) {
  localStorage.setItem('authToken', payload);
  state.authToken = payload;
  state.isAuthenticated = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].AUTHENTICATE_FAILURE, function (state, err) {
  localStorage.removeItem('authToken');
  localStorage.removeItem('currentUser');
  state.isAuthenticated = false;
  state.currentUser = null;
  state.authToken = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].USER_LOADED, function (state, user) {
  localStorage.setItem('currentUser', user);
  state.currentUser = user;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "D1Wx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__ = __webpack_require__("mNxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2ad400_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__ = __webpack_require__("N4ae");
function injectStyle (ssrContext) {
  __webpack_require__("FpKu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2ad400_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DAIf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),

/***/ "DMRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card"},[(_vm.product._id)?_c('div',{staticClass:"card-header"},[_vm._v("\n      Editing Catalog \""+_vm._s(_vm.product.slotGeneral.name)+"\"\n      "),_c('span',{staticClass:"badge",class:_vm.product.status.class,attrs:{"title":"Status of catalog"}},[_vm._v(_vm._s(_vm.product.status.label))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.product)?_c('form',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n          "+_vm._s(_vm.message)+"\n        ")]),_vm._v(" "),_c('wizard',{ref:"wizard",attrs:{"steps":_vm.steps,"onSave":_vm.saveWizard,"modeWizard":_vm.modeWizard}},[_c('div',{attrs:{"slot":"page-details"},slot:"page-details"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group m-3"},[_c('label',{attrs:{"for":"name-input"}},[_vm._v("Catalog name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.name),expression:"product.slotGeneral.name"}],staticClass:"form-control",attrs:{"disabled":"disabled","type":"text","id":"name-input"},domProps:{"value":(_vm.product.slotGeneral.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotGeneral, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{staticClass:"mr-4",attrs:{"for":"viewer-check-input"}},[_vm._v("Catalog price")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.price),expression:"product.slotGeneral.price"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"radio","name":"appPrice","value":"0"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.price,"0")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "price", "0")}}}),_vm._v(" Free Catalog\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{staticClass:"mr-4",attrs:{"for":"certifications-check-input"}},[_vm._v("Format")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.formats),expression:"product.slotGeneral.formats"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox","value":"dicom"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.formats)?_vm._i(_vm.product.slotGeneral.formats,"dicom")>-1:(_vm.product.slotGeneral.formats)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.formats,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="dicom",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.formats=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.formats=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "formats", $$c)}}}}),_vm._v(" Dicom\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.formats),expression:"product.slotGeneral.formats"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox","value":"json"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.formats)?_vm._i(_vm.product.slotGeneral.formats,"json")>-1:(_vm.product.slotGeneral.formats)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.formats,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="json",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.formats=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.formats=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "formats", $$c)}}}}),_vm._v(" JSON\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"description-textarea"}},[_c('h4',[_vm._v("Categories")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("Modality")]),_vm._v(" "),_vm._l((_vm.modalities),function(mod){return _c('div',{key:mod,staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox"},domProps:{"value":mod,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,mod)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=mod,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "+_vm._s(mod)+"\n                        ")])])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("Body Region")]),_vm._v(" "),_vm._l((_vm.bodyRegions),function(bodyRegion){return _c('div',{key:bodyRegion,staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox"},domProps:{"value":bodyRegion,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,bodyRegion)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=bodyRegion,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "+_vm._s(_vm._f("capita")(bodyRegion))+"\n                        ")])])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("Organ")]),_vm._v(" "),_vm._l((_vm.organs),function(or){return _c('div',{key:or,staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox"},domProps:{"value":or,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,or)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=or,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "+_vm._s(or)+"\n                        ")])])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("pathology")]),_vm._v(" "),_vm._l((_vm.pathologies),function(pathology){return _c('div',{key:pathology,staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox"},domProps:{"value":pathology,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,pathology)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=pathology,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "+_vm._s(pathology)+"\n                        ")])])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("Type")]),_vm._v(" "),_vm._l((_vm.types),function(tp){return _c('div',{key:tp,staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox"},domProps:{"value":tp,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,tp)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=tp,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "+_vm._s(tp)+"\n                        ")])])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("Orientation")]),_vm._v(" "),_vm._l((_vm.orientation),function(ori){return _c('div',{key:ori,staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox"},domProps:{"value":ori,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,ori)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=ori,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "+_vm._s(ori)+"\n                        ")])])})],2),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-3 m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label"},[_vm._v("Device")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('div',[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.device),expression:"product.slotGeneral.device"}],staticClass:"form-check-input",attrs:{"id":"GE","disabled":"disabled","type":"checkbox","value":"GE"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.device)?_vm._i(_vm.product.slotGeneral.device,"GE")>-1:(_vm.product.slotGeneral.device)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.device,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="GE",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.device=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.device=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "device", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"GE"}},[_vm._v("GE")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.device),expression:"product.slotGeneral.device"}],staticClass:"form-check-input disabled",attrs:{"id":"philips","disabled":"disabled","type":"checkbox","value":"philips"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.device)?_vm._i(_vm.product.slotGeneral.device,"philips")>-1:(_vm.product.slotGeneral.device)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.device,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="philips",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.device=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.device=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "device", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"philips"}},[_vm._v("Philips")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.device),expression:"product.slotGeneral.device"}],staticClass:"form-check-input",attrs:{"id":"siemens","disabled":"disabled","type":"checkbox","value":"siemens"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.device)?_vm._i(_vm.product.slotGeneral.device,"siemens")>-1:(_vm.product.slotGeneral.device)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.device,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="siemens",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.device=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.device=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "device", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"siemens"}},[_vm._v("Siemens")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.device),expression:"product.slotGeneral.device"}],staticClass:"form-check-input",attrs:{"id":"canon","disabled":"disabled","type":"checkbox","value":"canon"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.device)?_vm._i(_vm.product.slotGeneral.device,"canon")>-1:(_vm.product.slotGeneral.device)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.device,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="canon",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.device=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.device=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "device", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"canon"}},[_vm._v("Canon")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("Number of studies\n                        ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.product.slotDetails.patient)}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("Protocol CT")]),_vm._v(" "),_vm._l((_vm.protocolCT),function(protct){return _c('div',{key:protct,staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox"},domProps:{"value":protct,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,protct)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=protct,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "+_vm._s(protct)+"\n                        ")])])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-3 "},[_c('label',{staticClass:"fw-bold mb-2"},[_vm._v("Protocol MRI")]),_vm._v(" "),_vm._l((_vm.protocolMri),function(protmri){return _c('div',{key:protmri,staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"checkbox"},domProps:{"value":protmri,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,protmri)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=protmri,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "+_vm._s(protmri)+"\n                        ")])])})],2),_vm._v(" "),_c('div',{staticClass:"col-lg-3"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"gender-input"}},[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"radio m-1 pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.gender),expression:"product.slotGeneral.gender"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_m","type":"radio","name":"gender","value":"M"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.gender,"M")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "gender", "M")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_m"}},[_vm._v("M")])]),_vm._v(" "),_c('div',{staticClass:"radio m-1 "},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.gender),expression:"product.slotGeneral.gender"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_f","type":"radio","name":"gender","value":"F"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.gender,"F")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "gender", "F")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_f"}},[_vm._v("F")])]),_vm._v(" "),_c('div',{staticClass:"radio m-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.gender),expression:"product.slotGeneral.gender"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_all","type":"radio","name":"gender","value":"All inclusive"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.gender,"All inclusive")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "gender", "All inclusive")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_all"}},[_vm._v("All inclusive")])])]),_vm._v(" "),_c('div',{staticClass:"form-group "},[_c('h6',[_c('label',{attrs:{"for":"description-textarea"}},[_vm._v("Country")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.country),expression:"product.slotDetails.country"}],staticClass:"form-control",attrs:{"disabled":"disabled","type":"text","id":"name-input"},domProps:{"value":(_vm.product.slotDetails.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotDetails, "country", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('h6',[_c('label',{attrs:{"for":"description-textarea"}},[_vm._v("Age")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.age),expression:"product.slotDetails.age"}],staticClass:"form-control",attrs:{"disabled":"disabled","type":"text","id":"name-input"},domProps:{"value":(_vm.product.slotDetails.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotDetails, "age", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"outcomes-input"}},[_vm._v("Outcomes")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 d-flex align-items-center"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.outcomes),expression:"product.slotGeneral.outcomes"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_y-outcomes","type":"radio","name":"outcomes","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.outcomes,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "outcomes", "yes")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_y-outcomes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.outcomes),expression:"product.slotGeneral.outcomes"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_n-outcomes","type":"radio","name":"outcomes","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.outcomes,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "outcomes", "no")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_n-outcomes"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"multi-device-input"}},[_vm._v("Multi Device?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 d-flex align-items-center"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.multiDevice),expression:"product.slotGeneral.multiDevice"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_y-device","type":"radio","name":"multiDevice","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.multiDevice,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "multiDevice", "yes")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_y-device"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.multiDevice),expression:"product.slotGeneral.multiDevice"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_n-device","type":"radio","name":"multiDevice","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.multiDevice,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "multiDevice", "no")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_n-device"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"multi-centric-input"}},[_vm._v("Multi Centric?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 d-flex align-items-center"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.multiCentric),expression:"product.slotGeneral.multiCentric"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_y-centric","type":"radio","name":"multiCentric","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.multiCentric,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "multiCentric", "yes")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_y-centric"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.multiCentric),expression:"product.slotGeneral.multiCentric"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_n-centric","type":"radio","name":"multiCentric","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.multiCentric,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "multiCentric", "no")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_n-centric"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"annotated-input"}},[_vm._v("Annotated?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 d-flex align-items-center"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.annotated),expression:"product.slotGeneral.annotated"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_y-annotated","type":"radio","name":"annotated","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.annotated,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "annotated", "yes")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_y-annotated"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.annotated),expression:"product.slotGeneral.annotated"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_n-annotated","type":"radio","name":"annotated","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.annotated,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "annotated", "no")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_n-annotated"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"follow-up-input"}},[_vm._v("Follow Up?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 d-flex align-items-center"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.followUp),expression:"product.slotGeneral.followUp"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_y-follow","type":"radio","name":"followUp","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.followUp,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "followUp", "yes")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_y-follow"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.followUp),expression:"product.slotGeneral.followUp"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_n-follow","type":"radio","name":"followUp","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.followUp,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "followUp", "no")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_n-follow"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"contrast-enhanced-input"}},[_vm._v("Contrast Enhanced?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 d-flex align-items-center"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.contrastEnhanced),expression:"product.slotGeneral.contrastEnhanced"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_y-contrast","type":"radio","name":"contrastEnhanced","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.contrastEnhanced,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "contrastEnhanced", "yes")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_y-contrast"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.contrastEnhanced),expression:"product.slotGeneral.contrastEnhanced"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","id":"radio_n-contrast","type":"radio","name":"contrastEnhanced","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.contrastEnhanced,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "contrastEnhanced", "no")}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"radio_n-contrast"}},[_vm._v("No")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{attrs:{"for":"overview-textarea"}},[_c('h4',[_vm._v("Overview")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.slotDetails.overview))])]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{attrs:{"for":"description-textarea"}},[_c('h4',[_vm._v("Product description")])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.product.slotDetails.description)}})]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{attrs:{"for":"systemrequirement-textarea"}},[_c('h4',[_vm._v("System requirement")])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.product.slotDetails.systemRequirement)}})]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{attrs:{"for":"lastupdates-textarea"}},[_c('h4',[_vm._v("Last updates")])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.product.slotDetails.lastUpdates)}})]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{attrs:{"for":"publications-textarea"}},[_c('h4',[_vm._v("Publications")]),_vm._v(" "),(_vm.product.slotPublications.publications && !_vm.product.slotPublications.publications)?_c('p',[_vm._v("No publications")]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.product.slotPublications.publications),function(pub){return _c('li',{key:pub.link},[_c('a',{attrs:{"href":pub.link,"target":"_new"}},[_c('strong',[_vm._v(_vm._s(pub.title))])])])}))])]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{attrs:{"for":"video-textarea"}},[_c('h4',[_vm._v("Youtube video")]),_vm._v(" "),_c('p',_vm._l((_vm.product.slotDetails.videos),function(video,videoIndex){return _c('iframe',{key:videoIndex,staticClass:"mr-2",attrs:{"width":"300","height":"200","src":video.src}})}))])]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{attrs:{"for":"logo-file-input"}},[_vm._v("Userguide")])]),_vm._v(" "),_c('div',{staticClass:"form-group m-3"},[_c('label',{staticClass:"mr-4",attrs:{"for":"link-external-distributed-input"}},[_vm._v("Is your catalog already distributed online?")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.externalLinkDist),expression:"product.slotGeneral.externalLinkDist"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"radio","name":"externaldistributed"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.externalLinkDist,null)},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "externalLinkDist", null)}}}),_vm._v(" Yes\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.externalLinkDist),expression:"product.slotGeneral.externalLinkDist"}],staticClass:"form-check-input",attrs:{"disabled":"disabled","type":"radio","name":"externaldistributed"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.externalLinkDist,null)},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "externalLinkDist", null)}}}),_vm._v(" No\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.externalLinkDist),expression:"product.slotGeneral.externalLinkDist"}],staticClass:"form-control",attrs:{"disabled":"disabled","id":"is-already-distributed-input","placeholder":"","type":"url"},domProps:{"value":(_vm.product.slotGeneral.externalLinkDist)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotGeneral, "externalLinkDist", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"page-digit-content"},slot:"page-digit-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(!_vm.product.slotGeneral.app.name)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("No file uploaded for this catalog")]):_vm._e(),_vm._v(" "),(_vm.product.slotGeneral.app.name)?_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("File Name")]),_vm._v(" "),_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Size")]),_vm._v(" "),_c('th',[_vm._v(" ")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(_vm.product.slotGeneral.app.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.product.slotGeneral.app.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.displaySize))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"link-download",attrs:{"href":("https://api.womia.io/media/" + (_vm.product.slotGeneral.app.slug))}},[_vm._v("Download")])])])])]):_vm._e()])])]),_vm._v(" "),_c('div',{attrs:{"slot":"page-images"},slot:"page-images"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"logo-file-input"}},[_vm._v("Catalog logo")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row flex-wrap"},[_c('img',{staticClass:"d-block logo-app",attrs:{"src":_vm._f("media")(_vm.product.slotImages.logo.slug)}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"screenshots-file-input"}},[_vm._v("Screenshots")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row flex-wrap"},_vm._l((_vm.product.slotImages.screenshots),function(image,imageIndex){return _c('div',{key:image.slug,staticClass:"screenshots mr-2"},[_c('img',{staticClass:"d-block",style:({ width: '100px', height: '70px' }),attrs:{"src":_vm._f("media")(image.slug)}})])}))])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"page-notifications","id":"page-notifications"},slot:"page-notifications"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 py-3"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"approvalSelect"}},[_vm._v("Approval")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.newStatus),expression:"product.newStatus"}],staticClass:"form-control",attrs:{"id":"approvalSelect"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.product, "newStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"approved"}},[_vm._v("Approved")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("Waiting for approval")]),_vm._v(" "),_c('option',{attrs:{"value":"declined"}},[_vm._v("Declined")]),_vm._v(" "),_c('option',{attrs:{"value":"closed"}},[_vm._v("Closed")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-3"},[_vm._v("Kindly check if you need to send mail to user about this product update")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 mb-2"},[_c('div',{staticClass:"form-check"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox"}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"inputRecipient"}},[_vm._v("Recipient")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"inputRecipient","placeholder":"Email"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"notifToUser"}},[_vm._v("Subject")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"notifToUser","placeholder":"Notification to user"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label",attrs:{"for":"notifToUser"}},[_vm._v("Message")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 mt-2"},[_c('vue-editor',{attrs:{"id":"message","editorToolbar":_vm.customToolbar}})],1)])])])])])],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DfNA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFileInput_vue__ = __webpack_require__("tLSc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b92c705_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFileInput_vue__ = __webpack_require__("If1E");
function injectStyle (ssrContext) {
  __webpack_require__("jqmd")
  __webpack_require__("cSzW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b92c705"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFileInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b92c705_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFileInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DjJ3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "navbar",
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapActions(["login", "logout"]), {
    logoutGoHome: function logoutGoHome() {
      this.logout();
      this.$router.push({ path: "/" });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(["isAuthenticated", "currentUser", "isLoading", "hasRole"]))
});

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  AUTHENTICATE_SUCCESS: 'AUTHENTICATE_SUCCESS',
  AUTHENTICATE_FAILURE: 'AUTHENTICATE_FAILURE',
  USER_LOADED: 'USER_LOADED',
  FLASH: 'FLASH',
  UNFLASH: 'UNFLASH'
});

/***/ }),

/***/ "E67x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UploadFileInput__ = __webpack_require__("DfNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_image_crop_upload__ = __webpack_require__("uUvf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Wizard__ = __webpack_require__("D1Wx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dialog__ = __webpack_require__("deIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_editor__ = __webpack_require__("+qPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProductDeveloper',
  components: { 'app-file-input': __WEBPACK_IMPORTED_MODULE_3__components_UploadFileInput__["a" /* default */], 'media-file-input': __WEBPACK_IMPORTED_MODULE_4_vue_image_crop_upload__["a" /* default */], 'vue-editor': __WEBPACK_IMPORTED_MODULE_7_vue2_editor__["a" /* VueEditor */], 'wizard': __WEBPACK_IMPORTED_MODULE_5__components_Wizard__["a" /* default */], 'modal': __WEBPACK_IMPORTED_MODULE_6__components_Dialog__["a" /* default */] },
  data: function data() {
    return {
      message: null,
      showModal: false,
      showModalInfo: false,
      steps: [{
        label: 'General',
        description: '',
        slot: 'slotGeneral'
      }, {
        label: 'Images',
        description: '',
        slot: 'slotImages'
      }, {
        label: 'Details',
        description: '',
        slot: 'slotDetails'
      }, {
        label: 'Publications',
        description: '',
        slot: 'slotPublications'
      }, {
        label: 'Submit Catalog',
        description: '',
        slot: 'slotSubmit'
      }],
      publication: {},
      video: {},
      customToolbar: [['bold', 'italic', 'underline', 'strike'], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], [{ header: [4, 5, 6, false] }], [{ align: [] }], ['clean']],
      product: {
        slotGeneral: {
          technicalDetails: {}
        },
        slotImages: {
          logo: {}
        },
        slotDetails: {},
        slotPublications: {}
      },
      modalities: ["mri", "xray", "ct", "eeg", "ecg"],
      organs: ["lung", "heart", "liver", "arteries", "trachea", "spine", "pancreas", "spleen", "kidneys", "intestines", "bone", "breast", "teeth", "other"],
      bodyRegions: ["chest", "abdominal", "pelvic", "head", "cervical", "whole body", "chest abdominal", "chest abdominal pelvic", "cervical chest abdominal pelvic", "chest abdominal pelvic head"],
      pathologies: ["healthy", "covid", "nodule", "masse", "fibrosis", "emphysma", "pulmonary interstitial disease", "dilated heart", "thormbus", "atheroma", "dissection", "aneurysm", "pulmonary disease", "arterial disease", "heart disease"],
      orientation: ["axial", "coronal", "sagittal", "short-axis", "long-axis-2-cavities", "long-axis-3-cavities", "long-axis-4-cavities", "multiplanar", "multiplanar-radial", "multiplanar-short-axis"],
      types: ["2D", "2D+T", "2D+t", "3D", "3D+T", "3D+t", "none"],
      age: ["20-30", "30-40", "40-50", "50-60", "60-70", "70-80"],
      protocolMri: ["flow-2D", "flow-3D", "cine SSFP", "cardiac-function", "anatomy", "perfusion", "enhancement", "tagging", "angiography", "t1-mapping", "t2-mapping", "t2* mapping", "dixon"],
      protocolCT: ["chest-", "abdominal-", "pelvic-", "cerebral", "cervical-", "whole-body", "chest-abdominal", "chest-abdominal-pelvic", "cervical-chest-abdominal-pelvic", "chest-abdominal-pelvic-cerebral", "abdominal-pelvic", "cervical spine", "Aortic-Angiography", "thoracic-angiography", "supra-aortic-trunks-angiography", "lower-extremity-angiography", "cerebral-angiography", "abdominal-angiography", "thoracic-spine", "lumbar-spine", "coronary"],

      showLogoInput: false,
      showScreensInput: false,
      headers: {
        smail: '*_~'
      },
      uploadUrl: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root + '/media',
      imgLogoData: {
        src: '/beta/static/app-logo-default-300x300.png',
        hasImg: false
      },
      countries: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  validations: {
    product: {
      slotGeneral: {
        name: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
          minLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["minLength"])(2),
          maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(22)
        },
        app: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
          zipFile: function zipFile(appModel) {
            if (appModel && appModel.type === 'application/zip') {
              return true;
            }
            return false;
          }
        },
        technicalDetails: {
          version: {
            required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
          }
        },
        formats: {},
        device: {},

        multiCentric: {},
        multiDevice: {},
        followUp: {},
        annotated: {},
        externaldistributed: {},
        patient: {},
        age: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
        },

        country: {},
        gender: {},

        externalLinkDist: {
          required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
            if (this.externaldistributed === 'yes') {
              return true;
            }
            return false;
          })
        }
      },
      slotImages: {
        logo: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
        },
        screenshots: {}
      },
      slotDetails: {
        overview: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
          minLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["minLength"])(20),
          maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(600)
        },
        description: {
          required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
          minLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["minLength"])(20)
        },
        contrastEnhanced: {}
      }
    }
  },
  /*computed: {
    protocolGroups() {
      let groups = [];
      for (let i = 0; i < this.protocolCT.length; i += 11) {
        groups.push(this.protocolCT.slice(i, i + 11));
      }
      return groups;
    }
  },*/
  created: function created() {
    if (this.$route.params.slug) {
      this.fetchData();
    } else {
      this.showModalInfo = false;
      this.product = {
        slotGeneral: {
          formats: [],
          device: [],
          technicalDetails: {
            size: null,
            version: null,
            createdDate: null,
            updatedDate: null
          }
        },
        slotImages: {
          screenshots: []
        },
        slotDetails: {
          categories: [],
          videos: []
        },
        slotPublications: {
          publications: []
        }
      };
    }
  },
  methods: {
    hideMessages: function hideMessages() {
      this.message = null;
    },
    showErrorMessage: function showErrorMessage(message) {
      this.message = message;
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$http.get('product/dev/' + this.$route.params.slug).then(function (response) {
        _this.populateProduct(response.data);
      }, function (err) {
        // error callback
        console.log(err);
      });
    },
    populateProduct: function populateProduct(product) {
      /* set general params */
      this.product._id = product._id;
      this.product.slug = product.slug;
      this.product.slugRef = product.slugRef;
      this.product.slotGeneral = {
        name: product.name,
        app: product.app,
        technicalDetails: product.technicalDetails || {},
        formats: product.formats,
        device: product.device,
        gender: product.gender,
        viewer: product.viewer,
        externaldistributed: product.externaldistributed,
        outcomes: product.outcomes,
        multiCentric: product.multiCentric,
        multiDevice: product.multiDevice,
        followUp: product.followUp,
        annotated: product.annotated,
        country: product.country,
        age: product.age,
        patient: product.patient,
        data: product.data,
        externalLinkDist: product.externalLinkDist
        /* set images params */
      };this.product.slotImages = {
        logo: product.logo,
        screenshots: product.screenshots
      };
      if (product.logo) this.imgLogoData = { src: this.$options.filters.media(product.logo.slug, { width: '250' }), hasImg: true
        /* set details params */
      };this.product.slotDetails = {
        overview: product.overview,
        categories: product.categories,
        description: product.description,
        contrastEnhanced: product.contrastEnhanced,
        systemRequirement: product.systemRequirement,
        lastUpdates: product.lastUpdates,
        videos: product.videos || [],
        userGuide: product.userGuide
        /* set publications params */
      };this.product.slotPublications = {
        publications: product.publications || []
      };
    },
    isModified: function isModified() {
      var updateProduct = this.prepareProduct(this.product);
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(updateProduct), function (key) {
        if (!updateProduct[key]) updateProduct = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(updateProduct, key);
      });
      updateProduct.technicalDetails = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(updateProduct.technicalDetails, 'version');
      return this.$http.get('product/dev/' + this.product.slug).then(function (resp) {
        var oldProduct = resp.data;
        oldProduct.technicalDetails = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(oldProduct.technicalDetails, 'version');
        oldProduct = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(oldProduct, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(updateProduct));
        return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(oldProduct, updateProduct);
      });
    },
    prepareProduct: function prepareProduct(product) {
      return {
        _id: product._id,
        slugRef: product.slugRef,
        name: product.slotGeneral.name,
        app: product.slotGeneral.app,
        technicalDetails: {
          size: product.slotGeneral.app.binSize,
          version: product.slotGeneral.technicalDetails.version
        },
        formats: product.slotGeneral.formats,
        device: product.slotGeneral.device,
        externaldistributed: product.slotGeneral.externaldistributed,
        outcomes: product.slotGeneral.outcomes,
        multiCentric: product.slotGeneral.multiCentric,
        multiDevice: product.slotGeneral.multiDevice,
        gender: product.slotGeneral.gender,
        followUp: product.slotGeneral.followUp,
        annotated: product.slotGeneral.annotated,
        country: product.slotGeneral.country,
        age: product.slotGeneral.age,
        patient: product.slotGeneral.patient,
        data: product.slotGeneral.data,
        externalLinkDist: product.slotGeneral.externalLinkDist,
        logo: product.slotImages.logo,
        screenshots: product.slotImages.screenshots,
        overview: product.slotDetails.overview,
        categories: product.slotDetails.categories,
        contrastEnhanced: product.slotDetails.contrastEnhanced,
        description: product.slotDetails.description,
        systemRequirement: product.slotDetails.systemRequirement,
        lastUpdates: product.slotDetails.lastUpdates,
        videos: product.slotDetails.videos,
        publications: product.slotPublications.publications
      };
    },
    action: function action(promise) {
      var _this2 = this;

      this.hideMessages();
      promise.then(function (response) {
        var redirectToMyApps = {
          name: 'ListProductDeveloper'
        };
        _this2.$router.push(redirectToMyApps);
      }, function () {
        // error callback
        _this2.showErrorMessage('Sorry but an error occurred when submitting form');
      });
    },
    create: function create() {
      return this.$http.put('product/dev', this.prepareProduct(this.product));
    },
    update: function update() {
      var updateProduct = this.prepareProduct(this.product);
      console.log('updateProduct', updateProduct);
      updateProduct.technicalDetails.updatedDate = new Date();
      return this.$http.post('product/dev/' + this.product.slug, updateProduct);
    },
    submit: function submit() {
      var _this3 = this;

      // use popup for confirmation
      var promise = void 0;
      if (!this.product._id) {
        promise = this.$http.put('product/dev', this.prepareProduct(this.product));
      } else {
        promise = this.$http.post('product/dev/' + this.product.slug, this.prepareProduct(this.product));
      }

      promise.then(function (response) {
        _this3.action(_this3.$http.post('product/dev/' + response.body.slug + '/submit-my-app', { '_id': response.body._id }));
      }, function () {
        // error callback
        _this3.showErrorMessage('Sorry but an error occurred when submitting form');
      });
      // Hide Modal
      this.showModal = false;
    },
    addVideo: function addVideo() {
      this.product.slotDetails.videos.push(this.video);
      this.video = {};
    },
    addPublication: function addPublication() {
      this.product.slotPublications.publications.push(this.publication);
      this.publication = {};
    },
    nextWizard: function nextWizard(currentPage) {
      var _this4 = this;

      this.hideMessages();
      var currentSlot = this.steps[currentPage].slot;

      if (!this.$v.product[currentSlot] || !this.$v.product[currentSlot].$invalid) {
        if (this.product._id) {
          this.update().then(function (resp) {
            _this4.populateProduct(resp.data);
            _this4.$refs.wizard.goNext(true);
          }, function (err) {
            // Handle error response
            if (err.body.message.indexOf('name.app.already.used') > -1) {
              _this4.showErrorMessage('Sorry, the same name was already used for another App');
            } else {
              _this4.showErrorMessage('Sorry but an error occurred when submitting form');
            }
          });
        } else {
          this.create().then(function (resp) {
            _this4.populateProduct(resp.data);
            _this4.$refs.wizard.goNext(true);
          }, function (err) {
            // Handle error response
            if (err.body.message.indexOf('slug_1 dup key') > -1) {
              _this4.showErrorMessage('Sorry, the same name was already used for another App');
            } else {
              _this4.showErrorMessage('Sorry but an error occurred when submitting form');
            }
          });
        }
      } else {
        // If there are validation errors in other slots, display a general error message
        this.showErrorMessage('Please make sure all required fields are filled out correctly');
        this.$v.product[currentSlot].$touch();
        return false;
      }
    },
    backWizard: function backWizard(currentPage) {
      this.hideMessages();
      return true;
    },
    submitApp: function submitApp(currentPage) {
      this.showModal = true;
      return true;
    },
    showToUploadLogo: function showToUploadLogo() {
      this.showLogoInput = true;
    },
    showToUploadScreens: function showToUploadScreens() {
      this.showScreensInput = true;
    },
    cropLogoSuccess: function cropLogoSuccess(imgDataUrl, field) {
      this.imgLogoData = { src: imgDataUrl, hasImg: true };
    },
    cropLogoUploadSuccess: function cropLogoUploadSuccess(jsonData, field) {
      this.product.slotImages.logo = jsonData;
    },
    cropScreensUploadSuccess: function cropScreensUploadSuccess(jsonData, field) {
      this.product.slotImages.screenshots.push(jsonData);
    }
  }
});

/***/ }),

/***/ "E9BO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('form',[(_vm.product._id)?_c('h3',{staticClass:"mb-2"},[_vm._v("\n    Edit catalog \""+_vm._s(_vm.product.slotGeneral.name)+"\"\n    "),_c('span',{staticClass:"badge badge-warning",attrs:{"title":"Status of catalog"}},[_vm._v("Draft")])]):_vm._e(),_vm._v(" "),(!_vm.product._id)?_c('h3',{staticClass:"mb-2"},[_vm._v("Add Catalog")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('wizard',{ref:"wizard",attrs:{"steps":_vm.steps,"onNext":_vm.nextWizard,"onBack":_vm.backWizard,"onSubmit":_vm.submitApp}},[_c('div',{attrs:{"slot":"slotGeneral"},slot:"slotGeneral"},[_c('div',{staticClass:"row m-0 p-0 b-1"},[_c('div',{staticClass:"col-lg-12 p-20"},[_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"name-input"}},[_vm._v("Catalog name"),_c('i',{staticStyle:{"color":"#ed6666"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.name),expression:"product.slotGeneral.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name-input"},domProps:{"value":(_vm.product.slotGeneral.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotGeneral, "name", $event.target.value)},function($event){_vm.$v.product.slotGeneral.name.$touch()}]}}),_vm._v(" "),(_vm.$v.product.slotGeneral.name.$error)?_c('div',{class:{ 'invalid-feedback': _vm.$v.product.slotGeneral.name.$error }},[_vm._v("This field is required. Please be\n                sure to check.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("What is the name of your data catalog? (required, 2-22 characters)")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"name-input"}},[_vm._v("Catalog file "),_c('i',{staticStyle:{"color":"#ed6666"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('app-file-input',{staticClass:"app-file",attrs:{"id":'file-input-app',"type":'file',"width":'150px',"height":'70px'},model:{value:(_vm.product.slotGeneral.app),callback:function ($$v) {_vm.$set(_vm.product.slotGeneral, "app", $$v)},expression:"product.slotGeneral.app"}}),_vm._v(" "),(_vm.$v.product.slotGeneral.app.$error)?_c('div',{class:{ 'invalid-feedback': _vm.$v.product.slotGeneral.app.$error }},[_vm._v("This field is required (.zip file).\n                Please be sure to check.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Upload an exemple of your catalog (.zip required)")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"version-input"}},[_vm._v("Catalog version "),_c('i',{staticStyle:{"color":"#ed6666"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.technicalDetails.version),expression:"product.slotGeneral.technicalDetails.version"}],staticClass:"form-control",attrs:{"type":"text","id":"version-input"},domProps:{"value":(_vm.product.slotGeneral.technicalDetails.version)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotGeneral.technicalDetails, "version", $event.target.value)},function($event){_vm.$v.product.slotGeneral.technicalDetails.version.$touch()}]}}),_vm._v(" "),(_vm.$v.product.slotGeneral.technicalDetails.version.$error)?_c('div',{class:{ 'invalid-feedback': _vm.$v.product.slotGeneral.technicalDetails.version.$error }},[_vm._v("This field is\n                required. Please be sure to check.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Add the last version (required)")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"multi-centric-input"}},[_vm._v("Multi Centric ?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"radio radio-css radio-success pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.multiCentric),expression:"product.slotGeneral.multiCentric"}],staticClass:"form-check-input",attrs:{"id":"radio_y-centric","type":"radio","name":"multiCentric","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.multiCentric,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "multiCentric", "yes")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_y-centric"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.multiCentric),expression:"product.slotGeneral.multiCentric"}],staticClass:"form-check-input",attrs:{"id":"radio_n-centric","type":"radio","name":"multiCentric","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.multiCentric,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "multiCentric", "no")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_n-centric"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"follow-up-input"}},[_vm._v("Annotated ?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"radio radio-css radio-success pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.annotated),expression:"product.slotGeneral.annotated"}],staticClass:"form-check-input",attrs:{"id":"radio_y-annotated","type":"radio","name":"annotated","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.annotated,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "annotated", "yes")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_y-annotated"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.annotated),expression:"product.slotGeneral.annotated"}],staticClass:"form-check-input",attrs:{"id":"radio_n-annotated","type":"radio","name":"annotated","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.annotated,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "annotated", "no")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_n-annotated"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"follow-up-input"}},[_vm._v("Follow Up ?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"radio radio-css radio-success pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.followUp),expression:"product.slotGeneral.followUp"}],staticClass:"form-check-input",attrs:{"id":"radio_y-follow","type":"radio","name":"followUp","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.followUp,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "followUp", "yes")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_y-follow"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.followUp),expression:"product.slotGeneral.followUp"}],staticClass:"form-check-input",attrs:{"id":"radio_n-follow","type":"radio","name":"followUp","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.followUp,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "followUp", "no")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_n-follow"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"outcomes-input"}},[_vm._v("Outcomes")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"radio radio-css radio-success pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.outcomes),expression:"product.slotGeneral.outcomes"}],staticClass:"form-check-input",attrs:{"id":"radio_y-outcomes","type":"radio","name":"outcomes","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.outcomes,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "outcomes", "yes")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_y-outcomes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.outcomes),expression:"product.slotGeneral.outcomes"}],staticClass:"form-check-input",attrs:{"id":"radio_n-outcomes","type":"radio","name":"outcomes","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.outcomes,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "outcomes", "no")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_n-outcomes"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"multi-device-input"}},[_vm._v("Multi Device ?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"radio radio-css radio-success pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.multiDevice),expression:"product.slotGeneral.multiDevice"}],staticClass:"form-check-input",attrs:{"id":"radio_y-device","type":"radio","name":"multiDevice","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.multiDevice,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "multiDevice", "yes")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_y-device"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.multiDevice),expression:"product.slotGeneral.multiDevice"}],staticClass:"form-check-input",attrs:{"id":"radio_n-device","type":"radio","name":"multiDevice","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.multiDevice,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "multiDevice", "no")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_n-device"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label"},[_vm._v("Device")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.device),expression:"product.slotGeneral.device"}],staticClass:"form-check-input",attrs:{"id":"GE","type":"checkbox","value":"GE"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.device)?_vm._i(_vm.product.slotGeneral.device,"GE")>-1:(_vm.product.slotGeneral.device)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.device,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="GE",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.device=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.device=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "device", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"GE"}},[_vm._v("GE")])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.device),expression:"product.slotGeneral.device"}],staticClass:"form-check-input",attrs:{"id":"philips","type":"checkbox","value":"philips"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.device)?_vm._i(_vm.product.slotGeneral.device,"philips")>-1:(_vm.product.slotGeneral.device)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.device,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="philips",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.device=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.device=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "device", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"philips"}},[_vm._v("Philips")])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.device),expression:"product.slotGeneral.device"}],staticClass:"form-check-input",attrs:{"id":"siemens","type":"checkbox","value":"siemens"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.device)?_vm._i(_vm.product.slotGeneral.device,"siemens")>-1:(_vm.product.slotGeneral.device)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.device,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="siemens",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.device=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.device=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "device", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"siemens"}},[_vm._v("Siemens")])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.device),expression:"product.slotGeneral.device"}],staticClass:"form-check-input",attrs:{"id":"canon","type":"checkbox","value":"canon"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.device)?_vm._i(_vm.product.slotGeneral.device,"canon")>-1:(_vm.product.slotGeneral.device)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.device,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="canon",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.device=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.device=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "device", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"canon"}},[_vm._v("Canon")])])])]),_vm._v(" "),_c('div',[_c('small',{staticClass:"form-text text-muted"},[_vm._v("Select catalog's Device")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"country-input"}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 mb-2"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-globe"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.country),expression:"product.slotGeneral.country"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"country-input","placeholder":"Country"},domProps:{"value":(_vm.product.slotGeneral.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotGeneral, "country", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label"},[_vm._v("Format")]),_vm._v(" "),_c('div',{staticClass:"col-lg-2"},[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.formats),expression:"product.slotGeneral.formats"}],staticClass:"form-check-input",attrs:{"id":"dicom","type":"checkbox","value":"dicom"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.formats)?_vm._i(_vm.product.slotGeneral.formats,"dicom")>-1:(_vm.product.slotGeneral.formats)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.formats,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="dicom",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.formats=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.formats=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "formats", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"dicom"}},[_vm._v("Dicom")])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.formats),expression:"product.slotGeneral.formats"}],staticClass:"form-check-input",attrs:{"id":"json","type":"checkbox","value":"json"},domProps:{"checked":Array.isArray(_vm.product.slotGeneral.formats)?_vm._i(_vm.product.slotGeneral.formats,"json")>-1:(_vm.product.slotGeneral.formats)},on:{"change":function($event){var $$a=_vm.product.slotGeneral.formats,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="json",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotGeneral.formats=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotGeneral.formats=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotGeneral, "formats", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":"json"}},[_vm._v("Json")])])]),_vm._v(" "),_c('div',[_c('small',{staticClass:"form-text text-muted"},[_vm._v("Select catalog's format")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"patient-textarea"}},[_vm._v("Number of studies"),_c('i',{staticStyle:{"color":"#ed6666"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.patient),expression:"product.slotGeneral.patient"}],staticClass:"form-control",attrs:{"type":"text","rows":"5","id":"patient-textarea"},domProps:{"value":(_vm.product.slotGeneral.patient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotGeneral, "patient", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"age-textarea"}},[_vm._v("Age"),_c('i',{staticStyle:{"color":"#ed6666"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.age),expression:"product.slotGeneral.age"}],staticClass:"form-control",attrs:{"type":"text","rows":"5","id":"age-textarea"},domProps:{"value":(_vm.product.slotGeneral.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotGeneral, "age", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"gender-input"}},[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"radio radio-css radio-success pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.gender),expression:"product.slotGeneral.gender"}],staticClass:"form-check-input",attrs:{"id":"radio_m","type":"radio","name":"gender","value":"M"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.gender,"M")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "gender", "M")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_m"}},[_vm._v("M")])]),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.gender),expression:"product.slotGeneral.gender"}],staticClass:"form-check-input",attrs:{"id":"radio_f","type":"radio","name":"gender","value":"F"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.gender,"F")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "gender", "F")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_f"}},[_vm._v("F")])]),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.gender),expression:"product.slotGeneral.gender"}],staticClass:"form-check-input",attrs:{"id":"radio_all","type":"radio","name":"gender","value":"All inclusive"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.gender,"All inclusive")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "gender", "All inclusive")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_all"}},[_vm._v("All inclusive")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"link-external-distributed-input"}},[_vm._v("Is your catalog already\n              distributed online?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"radio radio-css radio-success pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.externaldistributed),expression:"product.slotGeneral.externaldistributed"}],staticClass:"form-check-input",attrs:{"id":"radio_y","type":"radio","name":"externaldistributed","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.externaldistributed,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "externaldistributed", "yes")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_y"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.externaldistributed),expression:"product.slotGeneral.externaldistributed"}],staticClass:"form-check-input",attrs:{"id":"radio_n","type":"radio","name":"externaldistributed","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotGeneral.externaldistributed,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotGeneral, "externaldistributed", "no")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_n"}},[_vm._v("No")])]),_vm._v(" "),_c('div',{staticClass:"form-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotGeneral.externalLinkDist),expression:"product.slotGeneral.externalLinkDist"}],staticClass:"form-control",attrs:{"id":"is-already-distributed-input","placeholder":"","type":"url"},domProps:{"value":(_vm.product.slotGeneral.externalLinkDist)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotGeneral, "externalLinkDist", $event.target.value)}}})]),_vm._v(" "),(_vm.$v.product.slotGeneral.externalLinkDist.$error)?_c('div',{class:{ 'invalid-feedback': _vm.$v.product.slotGeneral.externalLinkDist.$error }},[_vm._v("This field is\n                required.\n                Please be sure to check.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("If yes add internet link here (required)")])])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"slotImages"},slot:"slotImages"},[_c('div',{staticClass:"row m-0 p-0 b-1"},[_c('div',{staticClass:"col-12 p-20"},[_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label"},[_vm._v("App logo"),_c('i',{staticStyle:{"color":"#ed6666"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"logo card text-center"},[_c('img',{attrs:{"src":_vm.imgLogoData.src}}),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('a',{staticClass:"btn btn-link",on:{"click":_vm.showToUploadLogo}},[_vm._v(_vm._s((_vm.imgLogoData.hasImg) ? 'Change Catalog logo' : 'Set Catalog logo'))])])]),_vm._v(" "),_c('media-file-input',{staticClass:"app-media",attrs:{"field":"app-logo","width":575,"height":430,"url":_vm.uploadUrl,"no-circle":true,"lang-type":"en","headers":_vm.headers,"img-format":"png"},on:{"crop-success":_vm.cropLogoSuccess,"crop-upload-success":_vm.cropLogoUploadSuccess},model:{value:(_vm.showLogoInput),callback:function ($$v) {_vm.showLogoInput=$$v},expression:"showLogoInput"}}),_vm._v(" "),(_vm.$v.product.slotImages.logo.$error)?_c('div',{class:{ 'invalid-feedback': _vm.$v.product.slotImages.logo.$error }},[_vm._v("This field is required. Please be\n                sure to check.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Upload the logo of your catalog (required)")])],1)]),_vm._v(" "),(_vm.product.slotImages.screenshots)?_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label"},[_vm._v("Screenshots ("+_vm._s(_vm.product.slotImages.screenshots.length)+")")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('div',{staticClass:"screenshots-list"},[_vm._l((_vm.product.slotImages.screenshots),function(image,imageIndex){return _c('div',{key:image.slug,staticClass:"screenshots m-r-5"},[_c('img',{staticClass:"d-block img-thumbnail",attrs:{"src":_vm._f("media")(image.slug,{ width: '150' })}}),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-block",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.product.slotImages.screenshots.splice(imageIndex, 1)}}},[_vm._v("Remove")])])}),_vm._v(" "),_c('div',{staticClass:"card add-screenshot text-muted"},[_c('a',{staticClass:"btn",on:{"click":_vm.showToUploadScreens}},[_c('i',{staticClass:"fa fa-4x fa-plus"})]),_vm._v(" "),_c('p',{staticClass:"text-muted m-2"},[_vm._v(" Add screenshot ")])]),_vm._v(" "),_c('media-file-input',{staticClass:"app-media",attrs:{"field":"app-screenshots","width":1024,"height":768,"url":_vm.uploadUrl,"no-circle":true,"lang-type":"en","headers":_vm.headers},on:{"crop-upload-success":_vm.cropScreensUploadSuccess},model:{value:(_vm.showScreensInput),callback:function ($$v) {_vm.showScreensInput=$$v},expression:"showScreensInput"}})],2),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Upload screenshots of your catalog")])])]):_vm._e()])])]),_vm._v(" "),_c('div',{attrs:{"slot":"slotDetails"},slot:"slotDetails"},[_c('div',{staticClass:"row m-0 p-0 b-1"},[_c('div',{staticClass:"col-md-12 p-20"},[_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"overview-textarea"}},[_vm._v("Overview"),_c('i',{staticStyle:{"color":"#ed6666"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.overview),expression:"product.slotDetails.overview"}],staticClass:"form-control",attrs:{"type":"text","rows":"5","id":"overview-textarea"},domProps:{"value":(_vm.product.slotDetails.overview)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotDetails, "overview", $event.target.value)}}}),_vm._v(" "),(_vm.$v.product.slotDetails.overview.$error)?_c('div',{class:{ 'invalid-feedback': _vm.$v.product.slotDetails.overview.$error }},[_vm._v("This field is required. Please\n                be sure to check.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted",attrs:{"id":"emailHelp"}},[_vm._v("Summarize your catalog (required, 20-600\n                characters)")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"description-textarea"}},[_vm._v("Description"),_c('i',{staticStyle:{"color":"#ed6666"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.description),expression:"product.slotDetails.description"}],staticClass:"form-control",attrs:{"type":"text","rows":"5","id":"description-textarea"},domProps:{"value":(_vm.product.slotDetails.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.slotDetails, "description", $event.target.value)}}}),_vm._v(" "),(_vm.$v.product.slotDetails.description.$error)?_c('div',{class:{ 'invalid-feedback': _vm.$v.product.slotDetails.description.$error }},[_vm._v("This field is required. Please\n                be sure to check.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted",attrs:{"id":"emailHelp"}},[_vm._v("Summarize your catalog (required, 20-600\n                characters)")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-lg-3 col-form-label"},[_vm._v("Categories :")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3"}),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('div',{staticClass:"form-group row mb-1"},[_c('div',{staticClass:"col-lg-6"},[_c('label',{staticClass:" col-form-label"},[_vm._v("Modality")]),_vm._v(" "),_c('div',{staticClass:"py-2 pt-0 mb-2"},_vm._l((_vm.modalities),function(mod){return _c('div',{key:mod,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"id":("mod_" + mod),"type":"checkbox"},domProps:{"value":mod,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,mod)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=mod,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold text-capitalize",attrs:{"for":("mod_" + mod)}},[_vm._v(_vm._s(mod))])])})),_vm._v(" "),_c('label',{staticClass:" col-form-label"},[_vm._v("Pathologies")]),_vm._v(" "),_c('div',{staticClass:"py-2 mb-2 pt-0"},_vm._l((_vm.pathologies),function(pathology){return _c('div',{key:pathology,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"id":("pat_" + pathology),"type":"checkbox"},domProps:{"value":pathology,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,pathology)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=pathology,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold text-capitalize",attrs:{"for":("pat_" + pathology)}},[_vm._v(_vm._s(pathology))])])})),_vm._v(" "),_c('label',{staticClass:" col-form-label"},[_vm._v("MRI Protocols")]),_vm._v(" "),_c('div',{staticClass:"py-2 mb-2 pt-0"},_vm._l((_vm.protocolMri),function(prmri){return _c('div',{key:prmri,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"id":("prmri_" + prmri),"type":"checkbox"},domProps:{"value":prmri,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,prmri)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=prmri,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold text-capitalize",attrs:{"for":("prmri_" + prmri)}},[_vm._v(_vm._s(prmri))])])})),_vm._v(" "),_c('label',{staticClass:"col-form-label"},[_vm._v("Orientation")]),_vm._v(" "),_c('div',{staticClass:"py-2 mb-2 pt-0"},_vm._l((_vm.orientation),function(orientation){return _c('div',{key:orientation,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"id":("orientation_" + orientation),"type":"checkbox"},domProps:{"value":orientation,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,orientation)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=orientation,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold text-capitalize",attrs:{"for":("orientation_" + orientation)}},[_vm._v(_vm._s(orientation))])])})),_vm._v(" "),_c('label',{staticClass:"col-form-label"},[_vm._v("Types")]),_vm._v(" "),_c('div',{staticClass:"py-2 mb-2 pt-0"},_vm._l((_vm.types),function(type){return _c('div',{key:type,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"id":("type_" + type),"type":"checkbox"},domProps:{"value":type,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,type)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=type,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold",attrs:{"for":("type_" + type)}},[_vm._v(_vm._s(type))])])}))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('label',{staticClass:" col-form-label"},[_vm._v("Organ")]),_vm._v(" "),_c('div',{staticClass:"py-2 mb-2 pt-0"},_vm._l((_vm.organs),function(organ){return _c('div',{key:organ,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"id":("organ_" + organ),"type":"checkbox"},domProps:{"value":organ,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,organ)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=organ,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold text-capitalize",attrs:{"for":("organ_" + organ)}},[_vm._v(_vm._s(organ))])])})),_vm._v(" "),_c('label',{staticClass:" col-form-label"},[_vm._v("Body Region")]),_vm._v(" "),_c('div',{staticClass:"py-2 mb-2 pt-0"},_vm._l((_vm.bodyRegions),function(bodyRegion){return _c('div',{key:bodyRegion,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"id":("br_" + bodyRegion),"type":"checkbox"},domProps:{"value":bodyRegion,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,bodyRegion)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=bodyRegion,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold text-capitalize",attrs:{"for":("br_" + bodyRegion)}},[_vm._v(_vm._s(bodyRegion))])])})),_vm._v(" "),_c('label',{staticClass:"col-form-label"},[_vm._v("CT Protocols")]),_vm._v(" "),_c('div',{staticClass:"py-2 mb-2 pt-0"},_vm._l((_vm.protocolCT),function(prct){return _c('div',{key:prct,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.categories),expression:"product.slotDetails.categories"}],staticClass:"form-check-input",attrs:{"id":("prct_" + prct),"type":"checkbox"},domProps:{"value":prct,"checked":Array.isArray(_vm.product.slotDetails.categories)?_vm._i(_vm.product.slotDetails.categories,prct)>-1:(_vm.product.slotDetails.categories)},on:{"change":function($event){var $$a=_vm.product.slotDetails.categories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=prct,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.product.slotDetails.categories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.product.slotDetails.categories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.product.slotDetails, "categories", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"fs-13px fw-bold text-capitalize",attrs:{"for":("prct_" + prct)}},[_vm._v(_vm._s(prct))])])})),_vm._v(" "),_c('label',{staticClass:"col-form-label"},[_vm._v("Contrast Enhanced")]),_vm._v(" "),_c('div',{staticClass:"py-2 mb-2 pt-0"},[_c('div',{staticClass:"form-check mb-1"},[_c('div',{staticClass:"radio radio-css radio-success pe-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.contrastEnhanced),expression:"product.slotDetails.contrastEnhanced"}],staticClass:"form-check-input",attrs:{"id":"radio_y-contrast","type":"radio","name":"contrastEnhanced","value":"yes"},domProps:{"checked":_vm._q(_vm.product.slotDetails.contrastEnhanced,"yes")},on:{"change":function($event){_vm.$set(_vm.product.slotDetails, "contrastEnhanced", "yes")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_y-contrast"}},[_vm._v("Yes")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"radio radio-css radio-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.slotDetails.contrastEnhanced),expression:"product.slotDetails.contrastEnhanced"}],staticClass:"form-check-input",attrs:{"id":"radio_n-contrast","type":"radio","name":"contrastEnhanced","value":"no"},domProps:{"checked":_vm._q(_vm.product.slotDetails.contrastEnhanced,"no")},on:{"change":function($event){_vm.$set(_vm.product.slotDetails, "contrastEnhanced", "no")}}}),_vm._v(" "),_c('label',{attrs:{"for":"radio_n-contrast"}},[_vm._v("No")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"systemrequirement-textarea"}},[_vm._v("Your Business Model ?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('vue-editor',{attrs:{"id":"systemRequirement","editorToolbar":_vm.customToolbar},model:{value:(_vm.product.slotDetails.systemRequirement),callback:function ($$v) {_vm.$set(_vm.product.slotDetails, "systemRequirement", $$v)},expression:"product.slotDetails.systemRequirement"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"lastupdates-textarea"}},[_vm._v("Your business Milestones ?")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('vue-editor',{attrs:{"id":"lastUpdates","editorToolbar":_vm.customToolbar},model:{value:(_vm.product.slotDetails.lastUpdates),callback:function ($$v) {_vm.$set(_vm.product.slotDetails, "lastUpdates", $$v)},expression:"product.slotDetails.lastUpdates"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Describe the last updates you do on this catalog")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"video-url-input"}},[_vm._v("Add videos")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_vm._l((_vm.product.slotDetails.videos),function(vid,index){return _c('div',{key:vid.src,staticClass:"form-row m-b-5"},[_c('div',{staticClass:"col-lg-5 m-r-5 p-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(vid.title),expression:"vid.title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Title"},domProps:{"value":(vid.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(vid, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 m-r-5 p-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(vid.src),expression:"vid.src"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"Link"},domProps:{"value":(vid.src)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(vid, "src", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.product.slotDetails.videos.splice(index, 1)}}},[_c('i',{staticClass:"fa fa-minus text-white",attrs:{"aria-hidden":"true"}})])])])}),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-lg-5 m-r-5 p-3px"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.video.title),expression:"video.title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Title"},domProps:{"value":(_vm.video.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.video, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 m-r-5 p-3px"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.video.src),expression:"video.src"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"Link"},domProps:{"value":(_vm.video.src)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.video, "src", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-primary get-started rounded-pill",attrs:{"disabled":!_vm.video.src || !_vm.video.title},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.addVideo($event)}}},[_c('i',{staticClass:"fa fa-plus text-white",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Give the iframe url of a youtube video")])],2)])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"slotPublications"},slot:"slotPublications"},[_c('div',{staticClass:"row m-0 p-0 b-1"},[_c('div',{staticClass:"col-md-12 p-20"},[_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label"},[_vm._v("Catalog related to the same studies ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_vm._l((_vm.product.slotPublications.publications),function(pub,index){return _c('div',{key:pub.link,staticClass:"form-row m-b-5"},[_c('div',{staticClass:"col-lg-5 m-r-5 p-0 mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(pub.title),expression:"pub.title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Title"},domProps:{"value":(pub.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pub, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 m-r-5 p-0 mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(pub.link),expression:"pub.link"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"Link"},domProps:{"value":(pub.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pub, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col mb-2"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.product.slotPublications.publications.splice(index, 1)}}},[_c('i',{staticClass:"fa fa-minus text-white",attrs:{"aria-hidden":"true"}})])])])}),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-lg-5 m-r-5 p-3px"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.publication.title),expression:"publication.title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Title"},domProps:{"value":(_vm.publication.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.publication, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 m-r-5 p-3px"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.publication.link),expression:"publication.link"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"Link"},domProps:{"value":(_vm.publication.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.publication, "link", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-primary get-started rounded-pill",attrs:{"disabled":!_vm.publication.link || !_vm.publication.title},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.addPublication($event)}}},[_c('i',{staticClass:"fa fa-plus text-white",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Add related catalog")])],2)])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"slotSubmit"},slot:"slotSubmit"},[_c('div',{staticClass:"row m-0 p-0 b-1"},[_c('div',{staticClass:"col-md-12 p-20"},[_c('div',{staticClass:"jumbotron m-b-0 text-center"},[_c('h2',{staticClass:"text-inverse"},[_vm._v("Ready to Submit")]),_vm._v(" "),_c('p',{staticClass:"m-b-30 f-s-16"},[_vm._v("Your catalog is ready to be submitted to womia.io. You may change the metadata and\n              binary until you click Submit Catalog")])])])])])]),_vm._v(" "),_c('div',{staticClass:"confirm-app-modal"},[(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirm")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Please note that after submission, you can not modify your catalog until it has been validated by the\n        administrator.\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" Do you confirm the submission?\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('a',{staticClass:"btn btn-white router-link-active",staticStyle:{"border-radius":"20px"},attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary get-started rounded-pill",staticStyle:{"border-radius":"20px"},attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.submit()}}},[_vm._v("Submit")])])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"info-app-modal"},[(_vm.showModalInfo)?_c('modal',{on:{"close":function($event){_vm.showModalInfo = false}}},[_c('h3',{staticClass:"text-muted",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-2x fa-info-circle"}),_vm._v(" Information")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Currently, we manage free Catalogs only. Please "),_c('a',{attrs:{"href":"/beta/contact-us"}},[_vm._v("contact us")]),_vm._v(" if you have\n        other requirements.")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('a',{staticClass:"btn btn-outline-info",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalInfo = false}}},[_vm._v("Continue")])])]):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EC1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSubscribers_vue__ = __webpack_require__("7FLw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6334983c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSubscribers_vue__ = __webpack_require__("5cG8");
function injectStyle (ssrContext) {
  __webpack_require__("/9kV")
  __webpack_require__("DjJ3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6334983c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSubscribers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6334983c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSubscribers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EdZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row gx-lg-5"},[_c('div',{staticClass:"col-lg-5 mb-4 mb-lg-0"},[_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('h4',{staticClass:"footer-title"},[_vm._v("Subscribe")]),_vm._v(" "),_c('div',{attrs:{"id":"subscribe"}},[_c('div',{staticClass:"input-group position-relative mb-2 w-50"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control rounded-pill-start border-0 fw-normal px-3",staticStyle:{"background-color":"rgb(233 235 236)"},attrs:{"type":"text","placeholder":"Enter email address"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn text-dark icon-bell ",staticStyle:{"background-color":"rgb(233 235 236)"},attrs:{"type":"button"},on:{"click":function($event){_vm.subscribe()}}},[_c('i',{staticClass:"fa fa-send"})])]),_vm._v(" "),(_vm.message.text)?_c('small',{staticClass:"alert text-center m-0 justify-content-center d-flex",class:_vm.message.alert,staticStyle:{"width":"50%"},attrs:{"role":"alert"}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.message = {}}}},[_vm._v("×")]),_vm._v("\n                "+_vm._s(_vm.message.text)+"\n              ")]):_vm._e()])]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_vm._m(5,false,false)]),_vm._v(" "),_vm._m(6,false,false)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section section-blue"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-md-12 justify-content-center mb-3",staticStyle:{"display":"flex"}},[_c('h3',{staticClass:"text-white"},[_vm._v("\n              Unleash The Power Of Your Medical Data With Womia "),_c('br'),_vm._v(" "),_c('div',{staticClass:"sparator mt-4",staticStyle:{"border-bottom":"1px solid rgba(255, 255, 255, 0.2)","margin":"0 -80px"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 justify-content-center",staticStyle:{"display":"flex","font-size":"20px"}},[_c('div',{staticClass:"social subscription"},[_c('div',{staticClass:"social-list"},[_c('a',{attrs:{"href":"/beta/contact-us"}},[_c('i',{staticClass:"fa fa-envelope",staticStyle:{"font-size":"smaller"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.facebook.com/profile.php?id=100092753127914"}},[_c('i',{staticClass:"fa fa-facebook"})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/company/womia-io/"}},[_c('i',{staticClass:"fa fa-linkedin"})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.youtube.com/@womia4930"}},[_c('i',{staticClass:"fa fa-youtube-play"})])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-logo"},[_c('span',{staticClass:"footer-logo-text"},[_vm._v("Womia Box"),_c('small',{staticStyle:{"width":"50px"}},[_vm._v("by WOMIA")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"footer-desc"},[_vm._v("\n            Womia Box helps clinician create and distribute "),_c('br'),_vm._v("their own annotated medical Data catlogs for AI work "),_c('br'),_vm._v(" while preserving data ownership and patient privacy.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 mb-4 mb-lg-0"},[_c('h4',{staticClass:"footer-title"},[_vm._v("Catalogs")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{attrs:{"href":"/index.html#ct"}},[_vm._v("CT")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/index.html#mri"}},[_vm._v("MRI")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/index.html#xray"}},[_vm._v("Xray")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/index.html#dental"}},[_vm._v("Dental")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/index.html#eeg"}},[_vm._v("EEG")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/index.html#ecg"}},[_vm._v("ECG")])])]),_vm._v(" "),_c('hr',{staticClass:"my-4 text-gray-600"}),_vm._v(" "),_c('h4',{staticClass:"footer-title"},[_vm._v("\n            Company\n          ")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{attrs:{"href":"https://www.womia.io/"}},[_vm._v("Womia")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 mb-4 mb-lg-0"},[_c('h4',{staticClass:"footer-title"},[_vm._v("Related Links")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{attrs:{"href":"/index.html"}},[_vm._v("About Womia Box")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/beta/sign-up"}},[_vm._v("Create Account")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/beta/auth"}},[_vm._v("Login")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 mb-4 mb-lg-0"},[_c('h4',{staticClass:"footer-title"},[_vm._v("Contact")]),_vm._v(" "),_c('ul',{staticClass:"footer-link-list"},[_c('li',[_c('a',{attrs:{"href":"mailto:hello@womia.io"}},[_vm._v("Email: hello@womia.io")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/beta/contact-us"}},[_vm._v("Contact Us")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-copyright"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 text-center text-lg-start mb-3 mb-lg-0"},[_c('div',{staticClass:"footer-copyright-text"},[_vm._v("\n              © 2024 womia.io. All rights reserved.\n            ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ej+j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n      List of catalogs\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.isLoading)?_c('span',[_vm._v("Loading..")]):_vm._e(),_vm._v(" "),((!_vm.products || _vm.products.length === 0) && !_vm.isLoading)?_c('span',[_vm._v("No catalogs")]):_vm._e(),_vm._v(" "),(_vm.products && _vm.products.length)?_c('table',{staticClass:"table table-hover table-bordered"},[_vm._m(0,false,false),_vm._v(" "),_vm._l((_vm.products),function(productUpdate){return _c('tbody',_vm._l((productUpdate[1]),function(product,index){return _c('tr',{key:product._id},[_c('td',[(index === 0 || productUpdate[0] === 'undefined')?_c('span',[_vm._v(_vm._s(product.name))]):_c('span',{staticClass:"line-versions"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.technicalDetails.update))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.technicalDetails.version))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.author.nickname))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge",class:product.status.class},[_vm._v(_vm._s(product.status.label))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(product.created,'YYYY-MM-DD')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.price))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'Product', params: { slug: product.slug }}}},[_c('span',{staticClass:"fa fa-eye mr-2"})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Edit App', params: { slug: product.slug }}}},[_c('span',{staticClass:"fa fa-edit mr-2"})]),_vm._v(" "),_c('a',{attrs:{"href":"#delete"},on:{"click":function($event){_vm.deleteAction = { showModal: true, product: product}}}},[_c('span',{staticClass:"fa fa-minus-circle text-danger"})])],1)])}))})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"confirm-app-modal"},[(_vm.deleteAction.showModal)?_c('modal',{on:{"close":function($event){_vm.deleteAction.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirm delete Catalog")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Are you sure you want to delete the selected catalog?")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('a',{staticClass:"btn btn-outline-info",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteAction.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"btn orange-btn-custom",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteProduct(_vm.deleteAction.product)}}},[_vm._v("Delete Catalog")])])]):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Update")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Version")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Owner")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Created")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Price")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ek3L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-2"},[_vm._v("Your purchases")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-list',{attrs:{"products":_vm.products}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Emm+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header header-default"},[_c('div',{staticClass:"container d-flex"},[_c('div',{staticClass:"header-logo"},[_c('a',{staticClass:"logo-link header-nav-link ",attrs:{"href":"/beta"}},[_c('img',{staticStyle:{"width":"45px","margin-right":"5px"},attrs:{"src":"/beta/static/logo.svg"}}),_c('b',{staticClass:"text-womia"},[_vm._v("Womia Box ")])])]),_vm._v(" "),_c('div',{staticClass:"header-nav"},[_c('ul',{staticClass:"nav pull-right"},[_c('li',[_c('a',{staticClass:" nav-item nav-link dropdown-toggle mr-md-2",attrs:{"href":"#","id":"bd-versions","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"user-img",attrs:{"src":"/beta/static/default-user-128.png","width":"128","height":"128","alt":""}}),_vm._v(" "),_c('span',{staticClass:"hidden-md hidden-sm hidden-xs"},[_vm._v("Admin")]),_vm._v(" "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"bd-versions"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"}},[_vm._v("Settings")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"/beta/admin/logout"}},[_vm._v("Log out")])])])])]),_vm._v(" "),_c('button',{staticClass:"header-mobile-nav-toggler",attrs:{"type":"button","data-toggle":"header-mobile-nav"}},[_c('span',{staticClass:"header-mobile-nav-toggler-icon"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F9wz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dialog__ = __webpack_require__("deIM");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListProductAdmin',
  components: { 'modal': __WEBPACK_IMPORTED_MODULE_3__components_Dialog__["a" /* default */] },
  data: function data() {
    return {
      isLoading: true,
      products: null,
      deleteAction: {
        showModal: false,
        product: null
      }
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (products) {
      return _this.products = _this.populateProducts(products);
    });
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].mapGetters(['currentUser'])),
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      return this.$http.get('product/admin').then(function (response) {
        _this2.isLoading = false;
        return response.data;
      }, function () {
        _this2.isLoading = false;
      });
    },
    populateProducts: function populateProducts(products) {
      var viewStatus = {
        'edit': { 'label': 'Editing', 'class': 'badge-warning rounded-pill' },
        'pending': { 'label': 'Waiting for approval', 'class': 'badge-info rounded-pill' },
        'declined': { 'label': 'Declined', 'class': 'badge-danger rounded-pill' },
        'approved': { 'label': 'Approved', 'class': 'badge-success rounded-pill' },
        'closed': { 'label': 'Closed', 'class': 'badge-secondary rounded-pill' }
        // TODO: change this groupBy by lodash way
      };products = products.reduce(function (groups, item) {
        var val = item['slugRef'];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
      }, {});
      // Convert Object To Array and sort it by last update
      products = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(products).map(function (key) {
        products[key] = _.orderBy(products[key], 'technicalDetails.update', 'desc');
        return [key, products[key]];
      });
      // Prepare data for each product update set
      products.forEach(function (productsUpdateSet) {
        productsUpdateSet[1].forEach(function (product) {
          // prepare actions based on status
          product.actions = {
            'edit': product.status === 'edit',
            'update': product.status === 'approved',
            'delete': product.status === 'declined' || product.status === 'closed'
          };
          product.price = product.price || 'Free';
          product.status = viewStatus[product.status];
        });
      });

      return products;
    },
    deleteProduct: function deleteProduct(product) {
      var _this3 = this;

      // Hide Modal
      this.deleteAction.showModal = false;
      this.$http.delete('product/dev/' + product.slug).then(function (response) {
        _this3.fetchData().then(function (products) {
          return _this3.products = _this3.populateProducts(products);
        });
      }, function () {
        // error callback
        _this3.showErrorMessage('Sorry but an error occurred when submitting form');
      });
    }
  }
});

/***/ }),

/***/ "FEoV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FRJg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside'
});

/***/ }),

/***/ "FXTt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FpKu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GH5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Spinner',
  props: { isLoading: { type: Boolean, default: false } }
});

/***/ }),

/***/ "H0PP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthenticated && _vm.currentUser.firstConnection)?_c('div',{staticClass:"welcome-app-modal"},[_c('acceptTermsDlg',{attrs:{"styleContent":"max-width: 750px;width: 100%;position: relative;","styleBody":"overflow-y: scroll; max-height: 300px","styleMask":"background-color: rgba(0, 0, 0, .95)"}},[_c('div',{staticClass:"text-muted",attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("Terms & Conditions")]),_vm._v(" "),_c('small',[_vm._v("Please scroll down and agree to the terms & conditions below to proceed.")])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('h3',[_vm._v(" TERMS OF SERVICE ")]),_vm._v(" "),_c('h4',[_vm._v("OVERVIEW")]),_vm._v(" "),_c('p',[_vm._v("\n        This website is operated by WOMIA. Throughout the site, the terms\n        “we”, “us” and “our” refer to WOMIA. WOMIA offers this website,\n        including all information, tools and services available from this site\n        to you, the user, conditioned upon your acceptance of all terms,\n        conditions, policies and notices stated here. By visiting our site\n        and/ or purchasing something from us, you engage in our “Service” and\n        agree to be bound by the following terms and conditions (“Terms of\n        Service”, “Terms”), including those additional terms and conditions\n        and policies referenced herein and/or available by hyperlink. These\n        Terms of Service apply to all users of the site, including without\n        limitation users who are browsers, customers, merchants, and/ or\n        developer. Please read these Terms of Service carefully before\n        accessing or using our website. By accessing or using any part of the\n        site, you agree to be bound by these Terms of Service. If you do not\n        agree to all the terms and conditions of this agreement, then you may\n        not access the website or use any services. If these Terms of Service\n        are considered as an offer, acceptance is expressly limited to these\n        Terms of Service. Any new features or tools which are added to the\n        current store shall also be subject to the Terms of Service. You can\n        review the most current version of the Terms of Service at any time on\n        this page. We reserve the right to update, change or replace any part\n        of these Terms of Service by posting updates and/or changes to our\n        website. It is your responsibility to check this page periodically for\n        changes. Your continuous use of or access to the website following the\n        posting of any changes is considered as an acceptance of those\n        changes. Our store is hosted on Clever Cloud.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 1 - ONLINE STORE TERMS")]),_vm._v(" "),_c('p',[_vm._v("\n        This website is operated by WOMIA. Throughout the site, the terms\n        “we”, “us” and “our” refer to WOMIA. WOMIA offers this website,\n        including all information, tools and services available from this site\n        to you, the user, conditioned upon your acceptance of all terms,\n        conditions, policies and notices stated here. By visiting our site\n        and/ or purchasing something from us, you engage in our “Service” and\n        agree to be bound by the following terms and conditions (“Terms of\n        Service”, “Terms”), including those additional terms and conditions\n        and policies referenced herein and/or available by hyperlink. These\n        Terms of Service apply to all users of the site, including without\n        limitation users who are browsers, customers, merchants, and/ or\n        developer. Please read these Terms of Service carefully before\n        accessing or using our website. By accessing or using any part of the\n        site, you agree to be bound by these Terms of Service. If you do not\n        agree to all the terms and conditions of this agreement, then you may\n        not access the website or use any services. If these Terms of Service\n        are considered as an offer, acceptance is expressly limited to these\n        Terms of Service. Any new features or tools which are added to the\n        current store shall also be subject to the Terms of Service. You can\n        review the most current version of the Terms of Service at any time on\n        this page. We reserve the right to update, change or replace any part\n        of these Terms of Service by posting updates and/or changes to our\n        website. It is your responsibility to check this page periodically for\n        changes. Your continuous use of or access to the website following the\n        posting of any changes is considered as an acceptance of those\n        changes. Our store is hosted on Clever Cloud.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 2 - GENERAL CONDITIONS")]),_vm._v(" "),_c('p',[_vm._v("\n        We reserve the right to refuse service to anyone for any reason at any\n        time. You understand that your content (not including credit card\n        information), may be transferred unencrypted and involve: (a)\n        transmissions over various networks; and (b) changes to conform and\n        adapt to technical requirements of connecting networks or devices.\n        Credit card information is always encrypted during transfer over\n        networks. You agree not to reproduce, duplicate, copy, sell, resell or\n        exploit any portion of the Service, use of the Service, or access to\n        the Service or any contact on the website through which the service is\n        provided, without express written permission by us. The headings used\n        in this agreement are included for convenience only and will not limit\n        or otherwise affect these Terms.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("\n        SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We are not responsible if information made available on this site is\n        not accurate, complete or current. The material on this site is\n        provided for general information only and should not be relied upon or\n        used as the sole basis for making decisions without consulting\n        primary, more accurate, more complete or more timely sources of\n        information. Any reliance on the material on this site is at your own\n        risk. This site may contain certain historical information. Historical\n        information, necessarily, is not current and is provided for your\n        reference only. We reserve the right to modify the contents of this\n        site at any time, but we have no obligation to update any information\n        on our site. You agree that it is your responsibility to monitor\n        changes to our site.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES")]),_vm._v(" "),_c('p',[_vm._v("\n        Prices for our products are subject to change without notice. We\n        reserve the right at any time to modify or discontinue the Service (or\n        any part or content thereof) without notice at any time. We shall not\n        be liable to you or to any third-party for any modification, price\n        change, suspension or discontinuance of the Service.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 5 - PRODUCTS OR SERVICES (if applicable)")]),_vm._v(" "),_c('p',[_vm._v("\n        We reserve the right, but are not obligated, to limit the sales of our\n        products or Services to any person, geographic region or jurisdiction.\n        We may exercise this right on a case-by-case basis. We reserve the\n        right to limit the quantities of any products or services that we\n        offer. All descriptions of products or product pricing are subject to\n        change at anytime without notice, at the sole discretion of us. We\n        reserve the right to discontinue any product at any time. Any offer\n        for any product or service made on this site is void when prohibited.\n        We do not warrant that the quality of any products, services,\n        information, or other material purchased or obtained by you will meet\n        your expectations, or that any errors in the Service will be\n        corrected.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION")]),_vm._v(" "),_c('p',[_vm._v("\n        We reserve the right to refuse any order you place with us. We may, in\n        our sole discretion, limit or cancel quantities purchased per person,\n        per household or per order. These restrictions may include orders\n        placed by or under the same customer account, the same credit card,\n        and/or orders that use the same billing and/or shipping address. In\n        the event that we make a change to or cancel an order, we may attempt\n        to notify you by contacting the e-mail and/or billing address/phone\n        number provided. We reserve the right to limit or prohibit orders\n        that, in our sole judgment, appear to be placed by dealers, resellers\n        or distributors. You agree to provide current, complete and accurate\n        purchase and account information for all purchases made at our store.\n        You agree to promptly update your account and other information,\n        including your email address and credit card numbers and expiration\n        dates, so that we can complete your transactions and contact you as\n        needed.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 7 - OPTIONAL TOOLS")]),_vm._v(" "),_c('p',[_vm._v("\n        We may provide you with access to third-party tools over which we\n        neither monitor nor have any control nor input on. You acknowledge and\n        agree to the fact that we provide access to such tools ”as is” and “as\n        available” without any warranties, representations or conditions of\n        any kind and without any endorsement. We shall have no liability\n        whatsoever arising from or relating to your use of optional\n        third-party tools. Any use of optional tools by you, offered through\n        the site, is entirely at your own risk and discretion and you should\n        ensure that you are familiar with and approve of the terms on which\n        tools are provided by the relevant third-party provider(s). We may\n        also, in the future, offer new services and/or features through the\n        website (including, the release of new tools and resources). Such new\n        features and/or services shall also be subject to these Terms of\n        Service.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 8 - THIRD-PARTY LINKS")]),_vm._v(" "),_c('p',[_vm._v("\n        Certain content, products and services available via our Service may\n        include materials from third-parties. Third-party links on this site\n        may direct you to third-party websites that are not affiliated with\n        us. We are not responsible for examining or evaluating the content or\n        accuracy and we do not warrant and will not have any liability or\n        responsibility for any third-party materials or websites, or for any\n        other materials, products, or services of third-parties. We are not\n        liable for any harm or damages related to the purchase or use of\n        goods, services, resources, content, or any other transactions made in\n        connection with any third-party websites. Please review carefully the\n        third-party's policies and practices and make sure you understand them\n        before you engage in any transaction. Complaints, claims, concerns, or\n        questions regarding third-party products should be directed to the\n        third-party.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 9 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS")]),_vm._v(" "),_c('p',[_vm._v("\n        If, at our request, you send certain specific submissions (for example\n        contest entries) or without a request from us you send creative ideas,\n        suggestions, proposals, plans, or other materials, whether online, by\n        email, by postal mail, or otherwise (collectively, 'comments'), you\n        agree that we may, at any time, without restriction, edit, copy,\n        publish, distribute, translate and otherwise use in any medium any\n        comments that you forward to us. We are and shall be under no\n        obligation : (1) maintain any comments in confidence; (2) pay\n        compensation for any comments; or (3) respond to any comments. We may,\n        but have no obligation to, monitor, edit or remove content that we\n        determine in our sole discretion as unlawful, offensive, threatening,\n        libelous, defamatory, pornographic, obscene or otherwise objectionable\n        or violates at any conditions any party’s intellectual property or\n        these Terms of Service. You agree that your comments will not violate\n        any right of any third-party, including copyright, trademark, privacy,\n        personality or other personal or proprietary right. You further agree\n        that your comments will not contain libelous or otherwise unlawful,\n        abusive or obscene material, or contain any computer virus or other\n        malware that could in any way affect the operation of the Service or\n        any related website. You may not use a false e-mail address, pretend\n        to be someone other than yourself, or otherwise mislead us or\n        third-parties as to the origin of any comments. You are solely\n        responsible for any comments you make and their accuracy. We take no\n        responsibility and assume no liability for any comments posted by you\n        or any third-party.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 10 - PERSONAL INFORMATION")]),_vm._v(" "),_c('p',[_vm._v("\n        Your submission of personal information through the store is governed\n        by our Privacy Policy.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 11 - ERRORS, INACCURACIES AND OMISSIONS")]),_vm._v(" "),_c('p',[_vm._v("\n        Occasionally there may be information on our site or in the Service\n        that contains typographical errors, inaccuracies or omissions that may\n        relate to product descriptions, pricing, promotions, offers, product\n        shipping charges, transit times and availability. We reserve the right\n        to correct any errors, inaccuracies or omissions, and to change or\n        update information or cancel orders if any information in the Service\n        or on any related website is inaccurate at any time without prior\n        notice (including after you have submitted your order). We undertake\n        no obligation to update, amend or clarify information in the Service\n        or on any related website, including without limitation, pricing\n        information, except as required by law. No specified update or refresh\n        date applied in the Service or on any related website, should be taken\n        to indicate that all information in the Service or on any related\n        website has been modified or updated.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 12 - PROHIBITED USES")]),_vm._v(" "),_c('p',[_vm._v("\n        In addition to other prohibitions as set forth in the Terms of\n        Service, you are prohibited from using the site or its content: (a)\n        for any unlawful purpose; (b) to solicit others to perform or\n        participate in any unlawful acts; (c) to violate any international,\n        federal, provincial or state regulations, rules, laws, or local\n        ordinances; (d) to infringe upon or violate our intellectual property\n        rights or the intellectual property rights of others; (e) to harass,\n        abuse, insult, harm, defame, slander, disparage, intimidate, or\n        discriminate based on gender, sexual orientation, religion, ethnicity,\n        race, age, national origin, or disability; (f) to submit false or\n        misleading information; (g) to upload or transmit viruses or any other\n        type of malicious code that will or may be used in any way that will\n        affect the functionality or operation of the Service or of any related\n        website, other websites, or the Internet; (h) to collect or track the\n        personal information of others; (i) to spam, phish, pharm, pretext,\n        spider, crawl, or scrape; (j) for any obscene or immoral purpose; or\n        (k) to interfere with or circumvent the security features of the\n        Service or any related website, other websites, or the Internet. We\n        reserve the right to terminate your use of the Service or any related\n        website for violating any of the prohibited uses.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 13 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY")]),_vm._v(" "),_c('p',[_vm._v("\n        We do not guarantee, represent or warrant that your use of our service\n        will be uninterrupted timely, secure or error-free. We do not warrant\n        that the results that may be obtained from the use of the service will\n        be accurate or reliable. You agree that from time to time we may\n        remove the service for indefinite periods of time or cancel the\n        service at any time, without notice to you. You expressly agree that\n        your use of, or inability to use, the service is at your sole risk.\n        The service and all products and services delivered to you through the\n        service are (except as expressly stated by us) provided 'as is' and\n        'as available' for your use, without any representation, warranties or\n        conditions of any kind, either express or implied, including all\n        implied warranties or conditions of merchantability, merchantable\n        quality, fitness for a particular purpose, durability, title, and\n        non-infringement. In no case shall WOMIA, our directors, officers,\n        employees, affiliates, agents, contractors, interns, suppliers,\n        service providers or licensors be liable for any injury, loss, claim,\n        or any direct, indirect, incidental, punitive, special, or\n        consequential damages of any kind, including, without limitation lost\n        profits, lost revenue, lost savings, loss of data, replacement costs,\n        or any similar damages, whether based in contract, tort (including\n        negligence), strict liability or otherwise, arising from your use of\n        any of the service or any products procured using the service, or for\n        any other claim related in any way to your use of the service or any\n        product, including, but not limited to, any errors or omissions in any\n        content, or any loss or damage of any kind incurred as a result of the\n        use of the service or any content (or product) posted, transmitted, or\n        otherwise made available via the service, even if advised of their\n        possibility. Because some states or jurisdictions do not allow the\n        exclusion or the limitation of liability for consequential or\n        incidental damages, in such states or jurisdictions, our liability\n        shall be limited to the maximum extent permitted by law.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 14 - INDEMNIFICATION")]),_vm._v(" "),_c('p',[_vm._v("\n        You agree to indemnify, defend and hold harmless WOMIA and our parent,\n        subsidiaries, affiliates, partners, officers, directors, agents,\n        contractors, licensors, service providers, subcontractors, suppliers,\n        interns and employees, harmless from any claim or demand, including\n        reasonable attorneys’ fees, made by any third-party due to or arising\n        out of your breach of these Terms of Service or the documents they\n        incorporate by reference, or your violation of any law or the rights\n        of a third-party.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 15 - SEVERABILITY")]),_vm._v(" "),_c('p',[_vm._v("\n        In the event that any provision of these Terms of Service is\n        determined to be unlawful, void or unenforceable, such provision shall\n        nonetheless be enforceable to the fullest extent permitted by\n        applicable law, and the unenforceable portion shall be deemed to be\n        severed from these Terms of Service, such determination shall not\n        affect the validity and enforceability of any other remaining\n        provisions.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 16 - TERMINATION")]),_vm._v(" "),_c('p',[_vm._v("\n        The obligations and liabilities of the parties incurred prior to the\n        termination date shall survive the termination of this agreement for\n        all purposes. These Terms of Service are effective unless and until\n        terminated by either you or us. You may terminate these Terms of\n        Service at any time by notifying us that you no longer wish to use our\n        Services, or when you cease using our site. If in our sole judgment\n        you fail, or we suspect that you have failed, to comply with any term\n        or provision of these Terms of Service, we also may terminate this\n        agreement at any time without notice and you will remain liable for\n        all amounts due up to and including the date of termination; and/or\n        accordingly may deny you access to our Services (or any part thereof).\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 17 - ENTIRE AGREEMENT")]),_vm._v(" "),_c('p',[_vm._v("\n        The failure of us to exercise or enforce any right or provision of\n        these Terms of Service shall not constitute a waiver of such right or\n        provision. These Terms of Service and any policies or operating rules\n        posted by us on this site or in respect to The Service constitutes the\n        entire agreement and understanding between you and us and governs\n        therefore your use of the Service, superseding any prior or\n        contemporaneous agreements, communications and proposals, whether oral\n        or written, between you and us (including, but not limited to, any\n        prior versions of the Terms of Service). Any ambiguities in the\n        interpretation of these Terms of Service shall not be construed\n        against the drafting party.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 18 - GOVERNING LAW")]),_vm._v(" "),_c('p',[_vm._v("\n        These Terms of Service and any separate agreements whereby we provide\n        you Services shall be governed by and construed in accordance with the\n        laws of 14 rue Charles 5, Paris, J, 75004, France.\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 19 - CHANGES TO TERMS OF SERVICE")]),_vm._v(" "),_c('p',[_vm._v("\n        You can review the most current version of the Terms of Service at any\n        time at this page. We reserve the right, at our sole discretion, to\n        update, change or replace any part of these Terms of Service by\n        posting updates and changes to our website. It is your responsibility\n        to check our website periodically for changes. Your continued use of\n        or access to our website or the Service following the posting of any\n        changes to these Terms of Service\n      ")]),_vm._v(" "),_c('h4',[_vm._v("SECTION 20 - CONTACT INFORMATION")]),_vm._v(" "),_c('p',[_vm._v("\n        Questions about the Terms of Service should be sent to us at\n        hello@womia.io .\n      ")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticStyle:{"position":"absolute","left":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acceptTerms),expression:"acceptTerms"}],attrs:{"id":"acceptTerms","type":"checkbox","name":"acceptTerms"},domProps:{"checked":Array.isArray(_vm.acceptTerms)?_vm._i(_vm.acceptTerms,null)>-1:(_vm.acceptTerms)},on:{"change":function($event){var $$a=_vm.acceptTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acceptTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acceptTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acceptTerms=$$c}}}}),_vm._v(" "),_c('label',{staticStyle:{"position":"relative","top":"-5px"},attrs:{"for":"acceptTerms"}},[_vm._v("I accept the terms & conditions")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-white rounded-pill",attrs:{"data-dismiss":"modal"},on:{"click":function($event){_vm.logoutAndGotoLogin()}}},[_vm._v("Decline")]),_vm._v(" "),(_vm.acceptTerms)?_c('button',{staticClass:"btn btn-primary get-started rounded-pill",attrs:{"data-dismiss":"modal"},on:{"click":function($event){_vm.acceptTermsConditions({ accept: _vm.acceptTerms })}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(!_vm.acceptTerms)?_c('button',{staticClass:"btn btn-primary get-started rounded-pill",attrs:{"disabled":""}},[_vm._v("Submit")]):_vm._e()])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H5e6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"vue-image-crop-upload"},[_c('div',{staticClass:"vicp-wrap"},[_c('div',{staticClass:"vicp-close",on:{"click":_vm.off}},[_c('i',{staticClass:"vicp-icon4"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step == 1),expression:"step == 1"}],staticClass:"vicp-step1"},[_c('div',{staticClass:"vicp-drop-area",on:{"dragleave":_vm.preventDefault,"dragover":_vm.preventDefault,"dragenter":_vm.preventDefault,"click":_vm.handleClick,"drop":_vm.handleChange}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading != 1),expression:"loading != 1"}],staticClass:"vicp-icon1"},[_c('i',{staticClass:"vicp-icon1-arrow"}),_vm._v(" "),_c('i',{staticClass:"vicp-icon1-body"}),_vm._v(" "),_c('i',{staticClass:"vicp-icon1-bottom"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading !== 1),expression:"loading !== 1"}],staticClass:"vicp-hint"},[_vm._v(_vm._s(_vm.lang.hint))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSupported),expression:"!isSupported"}],staticClass:"vicp-no-supported-hint"},[_vm._v(_vm._s(_vm.lang.noSupported))]),_vm._v(" "),(_vm.step == 1)?_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"fileinput",attrs:{"type":"file"},on:{"change":_vm.handleChange}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError),expression:"hasError"}],staticClass:"vicp-error"},[_c('i',{staticClass:"vicp-icon2"}),_vm._v(" "+_vm._s(_vm.errorMsg)+"\r\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"vicp-operate"},[_c('a',{on:{"click":_vm.off,"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.off))])])]),_vm._v(" "),(_vm.step == 2)?_c('div',{staticClass:"vicp-step2"},[_c('div',{staticClass:"vicp-crop"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"vicp-crop-left"},[_c('div',{staticClass:"vicp-img-container"},[_c('img',{ref:"img",staticClass:"vicp-img",style:(_vm.sourceImgStyle),attrs:{"src":_vm.sourceImgUrl,"draggable":"false"},on:{"drag":_vm.preventDefault,"dragstart":_vm.preventDefault,"dragend":_vm.preventDefault,"dragleave":_vm.preventDefault,"dragover":_vm.preventDefault,"dragenter":_vm.preventDefault,"drop":_vm.preventDefault,"touchstart":_vm.imgStartMove,"touchmove":_vm.imgMove,"touchend":_vm.createImg,"touchcancel":_vm.createImg,"mousedown":_vm.imgStartMove,"mousemove":_vm.imgMove,"mouseup":_vm.createImg,"mouseout":_vm.createImg}}),_vm._v(" "),_c('div',{staticClass:"vicp-img-shade vicp-img-shade-1",style:(_vm.sourceImgShadeStyle)}),_vm._v(" "),_c('div',{staticClass:"vicp-img-shade vicp-img-shade-2",style:(_vm.sourceImgShadeStyle)})]),_vm._v(" "),_c('div',{staticClass:"vicp-range"},[_c('input',{attrs:{"type":"range","step":"1","min":"0","max":"100"},domProps:{"value":_vm.scale.range},on:{"mousemove":_vm.zoomChange}}),_vm._v(" "),_c('i',{staticClass:"vicp-icon5",on:{"mousedown":_vm.startZoomSub,"mouseout":_vm.endZoomSub,"mouseup":_vm.endZoomSub}}),_vm._v(" "),_c('i',{staticClass:"vicp-icon6",on:{"mousedown":_vm.startZoomAdd,"mouseout":_vm.endZoomAdd,"mouseup":_vm.endZoomAdd}})]),_vm._v(" "),(!_vm.noRotate)?_c('div',{staticClass:"vicp-rotate"},[_c('i',{on:{"click":_vm.rotateImg}},[_vm._v("↻")])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"vicp-crop-right"},[_c('div',{staticClass:"vicp-preview"},[(!_vm.noSquare)?_c('div',{staticClass:"vicp-preview-item"},[_c('img',{style:(_vm.previewStyle),attrs:{"src":_vm.createImgUrl}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.preview))])]):_vm._e(),_vm._v(" "),(!_vm.noCircle)?_c('div',{staticClass:"vicp-preview-item vicp-preview-item-circle"},[_c('img',{style:(_vm.previewStyle),attrs:{"src":_vm.createImgUrl}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.preview))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"vicp-operate"},[_c('a',{on:{"click":function($event){_vm.setStep(1)},"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.back))]),_vm._v(" "),_c('a',{staticClass:"vicp-operate-btn",on:{"click":_vm.prepareUpload,"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.save))])])]):_vm._e(),_vm._v(" "),(_vm.step == 3)?_c('div',{staticClass:"vicp-step3"},[_c('div',{staticClass:"vicp-upload"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading === 1),expression:"loading === 1"}],staticClass:"vicp-loading"},[_vm._v(_vm._s(_vm.lang.loading))]),_vm._v(" "),_c('div',{staticClass:"vicp-progress-wrap"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading === 1),expression:"loading === 1"}],staticClass:"vicp-progress",style:(_vm.progressStyle)})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError),expression:"hasError"}],staticClass:"vicp-error"},[_c('i',{staticClass:"vicp-icon2"}),_vm._v(" "+_vm._s(_vm.errorMsg)+"\r\n\t\t\t\t")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading === 2),expression:"loading === 2"}],staticClass:"vicp-success"},[_c('i',{staticClass:"vicp-icon3"}),_vm._v(" "+_vm._s(_vm.lang.success)+"\r\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"vicp-operate"},[_c('a',{on:{"click":function($event){_vm.setStep(2)},"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.back))]),_vm._v(" "),_c('a',{on:{"click":_vm.off,"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.close))])])]):_vm._e(),_vm._v(" "),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"canvas",attrs:{"width":_vm.width,"height":_vm.height}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HFPF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("oZw9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638cb77b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("f246");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638cb77b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HIE2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_image_crop_upload__ = __webpack_require__("uUvf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProfile',
  components: { 'avatar-upload': __WEBPACK_IMPORTED_MODULE_2_vue_image_crop_upload__["a" /* default */] },
  data: function data() {
    return {
      user: {},
      professionalActivities: ['physician', 'radiologist', 'researcher', 'software developper'],
      modalities: ['mri', 'ultrasound', 'xray', 'ct', 'pet', 'EEG', 'ECG'],
      clinicalAreas: ['cardiology', 'vascular', 'neurology', 'oncology', 'dental'],
      message: null,
      show: false,
      headers: {
        smail: '*_~'
      },
      uploadUrl: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root + '/media',
      imgData: {
        src: '/beta/static/default-user-128.png',
        hasAvatar: false
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_vuelidate__["validationMixin"]],
  validations: {
    user: {
      nickname: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["minLength"])(5)
      },
      lastName: {
        alpha: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["alpha"]
      },
      firstName: {
        alpha: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["alpha"]
      },
      country: {
        alpha: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["alpha"]
      },
      city: {
        alpha: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["alpha"]
      }
    }
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.$http.get('user/me').then(function (response) {
        _this.user = response.data;
        if (_this.user.picture) _this.imgData = { src: _this.$options.filters.media(_this.user.picture.slug, { width: '150' }), hasAvatar: true };
      }, function (err) {
        // error callback
        _this.showErrorMessage('Sorry but an error occurred when retrieving your profile information :(');
        console.log(err);
      });
    },
    hideErrorMessage: function hideErrorMessage() {
      this.message = null;
    },
    showErrorMessage: function showErrorMessage(message) {
      this.message = message;
    },
    deletePicture: function deletePicture() {
      this.user.picture = null;
      this.imgData = { src: '/beta/static/default-user-128.png', hasAvatar: false };
    },
    save: function save() {
      var _this2 = this;

      this.hideErrorMessage();
      if (!this.$v.$invalid) {
        this.$http.post('user/me', this.user).then(function (response) {
          _this2.user = response.data;
          _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["a" /* default */].USER_LOADED, response.data);
          _this2.$router.push({ name: 'Profile' });
        }, function (err) {
          // error callback
          _this2.showErrorMessage('Sorry but an error occurred when submitting form');
          console.log(err);
        });
      } else {
        this.showErrorMessage('Form is not valid, please fill all fields following requirements');
      }
    },
    toggleShow: function toggleShow() {
      this.show = !this.show;
    },
    cropSuccess: function cropSuccess(imgDataUrl, field) {
      this.imgData = { src: imgDataUrl, hasAvatar: true };
    },
    cropUploadSuccess: function cropUploadSuccess(jsonData, field) {
      this.user.picture = jsonData;
    },
    cropUploadFail: function cropUploadFail(status, field) {
      console.log(status);
    }
  }
});

/***/ }),

/***/ "HfpE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IK9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ViewProfile',
  data: function data() {
    return {
      user: {}
    };
  },

  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.$http.get('user/me').then(function (response) {
        _this.user = response.data;
      }, function (err) {
        // error callback
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_flash__ = __webpack_require__("Kra8");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

var state = {
  loading: false
};
var actions = {
  startLoading: function startLoading(_ref) {
    var state = _ref.state,
        commit = _ref.commit;

    commit('LOADING', true);
  },
  endLoading: function endLoading(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit;

    commit('LOADING', false);
  }
};

var mutations = {
  LOADING: function LOADING(state, payload) {
    state.loading = payload;
  }
};

var getters = {
  isLoading: function isLoading(state) {
    return state.loading;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    flash: __WEBPACK_IMPORTED_MODULE_3__modules_flash__["a" /* default */]
  },
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters,
  strict: debug
}));

/***/ }),

/***/ "If1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",staticStyle:{"user-select":"auto","cursor":"auto","padding-right":"17px"},attrs:{"id":(_vm.id + "-modal"),"tabindex":"-1","role":"dialog","aria-labelledby":"uploadModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(!_vm.isLoading)?_c('form',{staticClass:"modal-form"},[_c('div',{staticClass:"custom-file text-center"},[_c('input',{staticClass:"custom-file-input",attrs:{"type":"file","id":"file"},on:{"change":_vm.fileChanged}}),_vm._v(" "),(_vm.image)?_c('img',{staticClass:"m-auto img-thumbnail custom-file-control",attrs:{"height":"100","src":_vm.image}}):_vm._e()]),_vm._v(" "),(_vm.type === 'file' && _vm.fileToUpload)?_c('div',{staticClass:"custom-file-control m-auto"},[_vm._v("\n                "+_vm._s([
                    _vm.fileToUpload.name,
                    _vm.fileToUpload.type,
                    _vm.fileToUpload.size
                  ].join(" - "))+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center my-5"},[_vm._v("\n              Loading...\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary rounded-pill",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              Close\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary get-started rounded-pill",class:{ disabled: !_vm.fileToUpload },attrs:{"type":"button","disabled":!_vm.fileToUpload},on:{"click":function($event){_vm.upload()}}},[_vm._v("\n              Upload\n            ")])])])])]),_vm._v(" "),(_vm.type === 'image')?_c('div',{staticClass:"box text-center",style:({ width: _vm.width, 'min-height': _vm.height }),on:{"click":function($event){_vm.actionModal('show')}}},[(!(_vm.show && _vm.value))?_c('span',{staticClass:"box-action-icon",style:({ 'line-height': _vm.height })},[_c('i',{staticClass:"fa fa-plus fa-2x ",staticStyle:{"color":"#E95913"},attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.value)?_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm._f("media")(_vm.value.slug,{ width: _vm.width })}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.type === 'file')?_c('div',{staticClass:"box text-center",style:({ width: _vm.width, 'min-height': _vm.height }),on:{"click":function($event){_vm.actionModal('show')}}},[(!(_vm.show && _vm.value && _vm.value.slug))?_c('span',{staticClass:"box-action-icon",style:({ 'line-height': _vm.height })},[_c('i',{staticClass:"fa fa-file fa-2x",staticStyle:{"color":"#E95913"},attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.value)?_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Name")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.value.name))]),_vm._v(" "),_c('dt',[_vm._v("Type")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.value.type))])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"uploadModalLabel"}},[_vm._v("\n              Select a file to upload\n            ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iu79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light"},[_c('div',{staticClass:"has-bg section-container",attrs:{"id":"about-us-cover"}},[_c('div',{staticClass:"cover-bg"},[_c('img',{attrs:{"src":"/beta/static/img/tech-bg/techno.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-us text-center"},[_c('h1',[_vm._v("womia platform")])])])]),_vm._v(" "),_c('div',{staticClass:"section-container bg-white",attrs:{"id":"about-us-content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-us-content"},[_c('h2',{staticClass:"title text-center"},[_vm._v("Apps sharing platform for medical images analysis")]),_vm._v(" "),_c('p',{staticClass:"desc text-center"},[_vm._v("\n                  womia centralizes and classifies medical imaging Apps in one place enabling physicians a fast connection "),_c('br'),_vm._v(" \n                  the Apps they need and developers a seamless distribution of their Apps. \n                  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-shopping-cart"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("womia store")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Connect to a collection of innovative medical imaging Apps: Physicians buy and download the Apps they need developed by third-party providers from all around the world.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("womia APIs")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Build and Monetize medical imaging Apps: Developers and researchers monetize their Apps and target the right customers using womia APIs and web services.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-users"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("womia services")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Technical and clinical evaluation of medical imaging App: womia Assists developers in the evaluation of their Apps through independent experts without exposing intellectual property.")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JKY3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_language_js__ = __webpack_require__("74/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mimes_js__ = __webpack_require__("Bb9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_data2blob_js__ = __webpack_require__("g3c9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_effectRipple_js__ = __webpack_require__("eyka");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		// 域，上传文件name，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
		field: {
			type: String,
			'default': 'avatar'
		},
		// 原名key，类似于id，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
		ki: {
			'default': 0
		},
		// 显示该控件与否
		value: {
			'default': true
		},
		// 上传地址
		url: {
			type: String,
			'default': ''
		},
		// 其他要上传文件附带的数据，对象格式
		params: {
			type: Object,
			'default': null
		},
		//Add custom headers
		headers: {
			type: Object,
			'default': null
		},
		// 剪裁图片的宽
		width: {
			type: Number,
			default: 200
		},
		// 剪裁图片的高
		height: {
			type: Number,
			default: 200
		},
		// 不显示旋转功能
		noRotate: {
			type: Boolean,
			default: true
		},
		// 不预览圆形图片
		noCircle: {
			type: Boolean,
			default: false
		},
		// 不预览方形图片
		noSquare: {
			type: Boolean,
			default: false
		},
		// 单文件大小限制
		maxSize: {
			type: Number,
			'default': 10240
		},
		// 语言类型
		langType: {
			type: String,
			'default': 'zh'
		},
		// 语言包
		langExt: {
			type: Object,
			'default': null
		},
		// 图片上传格式
		imgFormat: {
			type: String,
			'default': 'png'
		},
		// 图片背景 jpg情况下生效
		imgBgc: {
			type: String,
			'default': '#fff'
		},
		// 是否支持跨域
		withCredentials: {
			type: Boolean,
			'default': false
		},
		method: {
			type: String,
			'default': 'POST'
		}
	},
	data: function data() {
		var that = this,
		    imgFormat = that.imgFormat,
		    langType = that.langType,
		    langExt = that.langExt,
		    width = that.width,
		    height = that.height,
		    isSupported = true,
		    allowImgFormat = ['jpg', 'png'],
		    tempImgFormat = allowImgFormat.indexOf(imgFormat) === -1 ? 'jpg' : imgFormat,
		    lang = __WEBPACK_IMPORTED_MODULE_4__utils_language_js__["a" /* default */][langType] ? __WEBPACK_IMPORTED_MODULE_4__utils_language_js__["a" /* default */][langType] : __WEBPACK_IMPORTED_MODULE_4__utils_language_js__["a" /* default */]['en'],
		    mime = __WEBPACK_IMPORTED_MODULE_5__utils_mimes_js__["a" /* default */][tempImgFormat];
		// 规范图片格式
		that.imgFormat = tempImgFormat;

		if (langExt) {
			__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(lang, langExt);
		}
		if (typeof FormData != 'function') {
			isSupported = false;
		}
		return {
			// 图片的mime
			mime: mime,

			// 语言包
			lang: lang,

			// 浏览器是否支持该控件
			isSupported: isSupported,
			// 浏览器是否支持触屏事件
			isSupportTouch: document.hasOwnProperty("ontouchstart"),

			// 步骤
			step: 1, //1选择文件 2剪裁 3上传

			// 上传状态及进度
			loading: 0, //0未开始 1正在 2成功 3错误
			progress: 0,

			// 是否有错误及错误信息
			hasError: false,
			errorMsg: '',

			// 需求图宽高比
			ratio: width / height,

			// 原图地址、生成图片地址
			sourceImg: null,
			sourceImgUrl: '',
			createImgUrl: '',

			// 原图片拖动事件初始值
			sourceImgMouseDown: {
				on: false,
				mX: 0, //鼠标按下的坐标
				mY: 0,
				x: 0, //scale原图坐标
				y: 0
			},

			// 生成图片预览的容器大小
			previewContainer: {
				width: 100,
				height: 100
			},

			// 原图容器宽高
			sourceImgContainer: { // sic
				width: 240,
				height: 184 // 如果生成图比例与此一致会出现bug，先改成特殊的格式吧，哈哈哈
			},

			// 原图展示属性
			scale: {
				zoomAddOn: false, //按钮缩放事件开启
				zoomSubOn: false, //按钮缩放事件开启
				range: 1, //最大100

				x: 0,
				y: 0,
				width: 0,
				height: 0,
				maxWidth: 0,
				maxHeight: 0,
				minWidth: 0, //最宽
				minHeight: 0,
				naturalWidth: 0, //原宽
				naturalHeight: 0
			}
		};
	},

	computed: {
		// 进度条样式
		progressStyle: function progressStyle() {
			var progress = this.progress;

			return {
				width: progress + '%'
			};
		},

		// 原图样式
		sourceImgStyle: function sourceImgStyle() {
			var scale = this.scale,
			    sourceImgMasking = this.sourceImgMasking,
			    top = scale.y + sourceImgMasking.y + 'px',
			    left = scale.x + sourceImgMasking.x + 'px';

			return {
				top: top,
				left: left,
				width: scale.width + 'px',
				height: scale.height + 'px' // 兼容 Opera
			};
		},

		// 原图蒙版属性
		sourceImgMasking: function sourceImgMasking() {
			var width = this.width,
			    height = this.height,
			    ratio = this.ratio,
			    sourceImgContainer = this.sourceImgContainer,
			    sic = sourceImgContainer,
			    sicRatio = sic.width / sic.height,
			    x = 0,
			    y = 0,
			    w = sic.width,
			    h = sic.height,
			    scale = 1;

			if (ratio < sicRatio) {
				scale = sic.height / height;
				w = sic.height * ratio;
				x = (sic.width - w) / 2;
			}
			if (ratio > sicRatio) {
				scale = sic.width / width;
				h = sic.width / ratio;
				y = (sic.height - h) / 2;
			}
			return {
				scale: scale, // 蒙版相对需求宽高的缩放
				x: x,
				y: y,
				width: w,
				height: h
			};
		},

		// 原图遮罩样式
		sourceImgShadeStyle: function sourceImgShadeStyle() {
			var sourceImgMasking = this.sourceImgMasking,
			    sourceImgContainer = this.sourceImgContainer,
			    sic = sourceImgContainer,
			    sim = sourceImgMasking,
			    w = sim.width == sic.width ? sim.width : (sic.width - sim.width) / 2,
			    h = sim.height == sic.height ? sim.height : (sic.height - sim.height) / 2;

			return {
				width: w + 'px',
				height: h + 'px'
			};
		},
		previewStyle: function previewStyle() {
			var width = this.width,
			    height = this.height,
			    ratio = this.ratio,
			    previewContainer = this.previewContainer,
			    pc = previewContainer,
			    w = pc.width,
			    h = pc.height,
			    pcRatio = w / h;

			if (ratio < pcRatio) {
				w = pc.height * ratio;
			}
			if (ratio > pcRatio) {
				h = pc.width / ratio;
			}
			return {
				width: w + 'px',
				height: h + 'px'
			};
		}
	},
	watch: {
		value: function value(newValue) {
			if (newValue && this.loading != 1) {
				this.reset();
			}
		}
	},
	methods: {
		// 点击波纹效果
		ripple: function ripple(e) {
			Object(__WEBPACK_IMPORTED_MODULE_7__utils_effectRipple_js__["a" /* default */])(e);
		},

		// 关闭控件
		off: function off() {
			var _this = this;

			setTimeout(function () {
				_this.$emit('input', false);
				if (_this.step == 3 && _this.loading == 2) {
					_this.setStep(1);
				}
			}, 200);
		},

		// 设置步骤
		setStep: function setStep(no) {
			var _this2 = this;

			// 延时是为了显示动画效果呢，哈哈哈
			setTimeout(function () {
				_this2.step = no;
			}, 200);
		},


		/* 图片选择区域函数绑定
   ---------------------------------------------------------------*/
		preventDefault: function preventDefault(e) {
			e.preventDefault();
			return false;
		},
		handleClick: function handleClick(e) {
			if (this.loading !== 1) {
				if (e.target !== this.$refs.fileinput) {
					e.preventDefault();
					if (document.activeElement !== this.$refs) {
						this.$refs.fileinput.click();
					}
				}
			}
		},
		handleChange: function handleChange(e) {
			e.preventDefault();
			if (this.loading !== 1) {
				var files = e.target.files || e.dataTransfer.files;
				this.reset();
				if (this.checkFile(files[0])) {
					this.setSourceImg(files[0]);
				}
			}
		},

		/* ---------------------------------------------------------------*/

		// 检测选择的文件是否合适
		checkFile: function checkFile(file) {
			var that = this,
			    lang = that.lang,
			    maxSize = that.maxSize;
			// 仅限图片
			if (file.type.indexOf('image') === -1) {
				that.hasError = true;
				that.errorMsg = lang.error.onlyImg;
				return false;
			}

			// 超出大小
			if (file.size / 1024 > maxSize) {
				that.hasError = true;
				that.errorMsg = lang.error.outOfSize + maxSize + 'kb';
				return false;
			}
			return true;
		},

		// 重置控件
		reset: function reset() {
			var that = this;
			that.loading = 0;
			that.hasError = false;
			that.errorMsg = '';
			that.progress = 0;
		},

		// 设置图片源
		setSourceImg: function setSourceImg(file) {
			this.$emit('src-file-set', file.name, file.type, file.size);
			var that = this,
			    fr = new FileReader();
			fr.onload = function (e) {
				that.sourceImgUrl = fr.result;
				that.startCrop();
			};
			fr.readAsDataURL(file);
		},

		// 剪裁前准备工作
		startCrop: function startCrop() {
			var that = this,
			    width = that.width,
			    height = that.height,
			    ratio = that.ratio,
			    scale = that.scale,
			    sourceImgUrl = that.sourceImgUrl,
			    sourceImgMasking = that.sourceImgMasking,
			    lang = that.lang,
			    sim = sourceImgMasking,
			    img = new Image();

			img.src = sourceImgUrl;
			img.onload = function () {
				var nWidth = img.naturalWidth,
				    nHeight = img.naturalHeight,
				    nRatio = nWidth / nHeight,
				    w = sim.width,
				    h = sim.height,
				    x = 0,
				    y = 0;
				// 图片像素不达标
				if (nWidth < width || nHeight < height) {
					that.hasError = true;
					that.errorMsg = lang.error.lowestPx + width + '*' + height;
					return false;
				}
				if (ratio > nRatio) {
					h = w / nRatio;
					y = (sim.height - h) / 2;
				}
				if (ratio < nRatio) {
					w = h * nRatio;
					x = (sim.width - w) / 2;
				}
				scale.range = 0;
				scale.x = x;
				scale.y = y;
				scale.width = w;
				scale.height = h;
				scale.minWidth = w;
				scale.minHeight = h;
				scale.maxWidth = nWidth * sim.scale;
				scale.maxHeight = nHeight * sim.scale;
				scale.naturalWidth = nWidth;
				scale.naturalHeight = nHeight;
				that.sourceImg = img;
				that.createImg();
				that.setStep(2);
			};
		},

		// 鼠标按下图片准备移动
		imgStartMove: function imgStartMove(e) {
			e.preventDefault();
			// 支持触摸事件，则鼠标事件无效
			if (this.isSupportTouch && !e.targetTouches) {
				return false;
			}
			var et = e.targetTouches ? e.targetTouches[0] : e,
			    sourceImgMouseDown = this.sourceImgMouseDown,
			    scale = this.scale,
			    simd = sourceImgMouseDown;

			simd.mX = et.screenX;
			simd.mY = et.screenY;
			simd.x = scale.x;
			simd.y = scale.y;
			simd.on = true;
		},

		// 鼠标按下状态下移动，图片移动
		imgMove: function imgMove(e) {
			e.preventDefault();
			// 支持触摸事件，则鼠标事件无效
			if (this.isSupportTouch && !e.targetTouches) {
				return false;
			}
			var et = e.targetTouches ? e.targetTouches[0] : e,
			    _sourceImgMouseDown = this.sourceImgMouseDown,
			    on = _sourceImgMouseDown.on,
			    mX = _sourceImgMouseDown.mX,
			    mY = _sourceImgMouseDown.mY,
			    x = _sourceImgMouseDown.x,
			    y = _sourceImgMouseDown.y,
			    scale = this.scale,
			    sourceImgMasking = this.sourceImgMasking,
			    sim = sourceImgMasking,
			    nX = et.screenX,
			    nY = et.screenY,
			    dX = nX - mX,
			    dY = nY - mY,
			    rX = x + dX,
			    rY = y + dY;

			if (!on) return;
			if (rX > 0) {
				rX = 0;
			}
			if (rY > 0) {
				rY = 0;
			}
			if (rX < sim.width - scale.width) {
				rX = sim.width - scale.width;
			}
			if (rY < sim.height - scale.height) {
				rY = sim.height - scale.height;
			}
			scale.x = rX;
			scale.y = rY;
		},

		// 顺时针旋转图片
		rotateImg: function rotateImg(e) {
			var sourceImg = this.sourceImg,
			    _scale = this.scale,
			    naturalWidth = _scale.naturalWidth,
			    naturalHeight = _scale.naturalHeight,
			    width = naturalHeight,
			    height = naturalWidth,
			    canvas = this.$refs.canvas,
			    ctx = canvas.getContext('2d');

			canvas.width = width;
			canvas.height = height;
			ctx.clearRect(0, 0, width, height);

			ctx.fillStyle = 'rgba(0,0,0,0)';
			ctx.fillRect(0, 0, width, height);

			ctx.translate(width, 0);
			ctx.rotate(Math.PI * 90 / 180);

			ctx.drawImage(sourceImg, 0, 0, naturalWidth, naturalHeight);
			var imgUrl = canvas.toDataURL(__WEBPACK_IMPORTED_MODULE_5__utils_mimes_js__["a" /* default */]['png']);

			this.sourceImgUrl = imgUrl;
			this.startCrop();
		},


		// 按钮按下开始放大
		startZoomAdd: function startZoomAdd(e) {
			var that = this,
			    scale = that.scale;

			scale.zoomAddOn = true;

			function zoom() {
				if (scale.zoomAddOn) {
					var range = scale.range >= 100 ? 100 : ++scale.range;
					that.zoomImg(range);
					setTimeout(function () {
						zoom();
					}, 60);
				}
			}
			zoom();
		},

		// 按钮松开或移开取消放大
		endZoomAdd: function endZoomAdd(e) {
			this.scale.zoomAddOn = false;
		},

		// 按钮按下开始缩小
		startZoomSub: function startZoomSub(e) {
			var that = this,
			    scale = that.scale;

			scale.zoomSubOn = true;

			function zoom() {
				if (scale.zoomSubOn) {
					var range = scale.range <= 0 ? 0 : --scale.range;
					that.zoomImg(range);
					setTimeout(function () {
						zoom();
					}, 60);
				}
			}
			zoom();
		},

		// 按钮松开或移开取消缩小
		endZoomSub: function endZoomSub(e) {
			var scale = this.scale;

			scale.zoomSubOn = false;
		},
		zoomChange: function zoomChange(e) {
			this.zoomImg(e.target.value);
		},

		// 缩放原图
		zoomImg: function zoomImg(newRange) {
			var that = this,
			    sourceImgMasking = this.sourceImgMasking,
			    sourceImgMouseDown = this.sourceImgMouseDown,
			    scale = this.scale,
			    maxWidth = scale.maxWidth,
			    maxHeight = scale.maxHeight,
			    minWidth = scale.minWidth,
			    minHeight = scale.minHeight,
			    width = scale.width,
			    height = scale.height,
			    x = scale.x,
			    y = scale.y,
			    range = scale.range,
			    sim = sourceImgMasking,
			    sWidth = sim.width,
			    sHeight = sim.height,
			    nWidth = minWidth + (maxWidth - minWidth) * newRange / 100,
			    nHeight = minHeight + (maxHeight - minHeight) * newRange / 100,
			    nX = sWidth / 2 - nWidth / width * (sWidth / 2 - x),
			    nY = sHeight / 2 - nHeight / height * (sHeight / 2 - y);

			// 判断新坐标是否超过蒙版限制
			if (nX > 0) {
				nX = 0;
			}
			if (nY > 0) {
				nY = 0;
			}
			if (nX < sWidth - nWidth) {
				nX = sWidth - nWidth;
			}
			if (nY < sHeight - nHeight) {
				nY = sHeight - nHeight;
			}

			// 赋值处理
			scale.x = nX;
			scale.y = nY;
			scale.width = nWidth;
			scale.height = nHeight;
			scale.range = newRange;
			setTimeout(function () {
				if (scale.range == newRange) {
					that.createImg();
				}
			}, 300);
		},

		// 生成需求图片
		createImg: function createImg(e) {
			var that = this,
			    imgFormat = that.imgFormat,
			    imgBgc = that.imgBgc,
			    mime = that.mime,
			    sourceImg = that.sourceImg,
			    _that$scale = that.scale,
			    x = _that$scale.x,
			    y = _that$scale.y,
			    width = _that$scale.width,
			    height = _that$scale.height,
			    scale = that.sourceImgMasking.scale,
			    canvas = that.$refs.canvas,
			    ctx = canvas.getContext('2d');

			if (e) {
				// 取消鼠标按下移动状态
				that.sourceImgMouseDown.on = false;
			}
			canvas.width = that.width;
			canvas.height = that.height;
			ctx.clearRect(0, 0, that.width, that.height);

			if (imgFormat == 'png') {
				ctx.fillStyle = 'rgba(0,0,0,0)';
			} else {
				// 如果jpg 为透明区域设置背景，默认白色
				ctx.fillStyle = imgBgc;
			}
			ctx.fillRect(0, 0, that.width, that.height);

			ctx.drawImage(sourceImg, x / scale, y / scale, width / scale, height / scale);
			that.createImgUrl = canvas.toDataURL(mime);
		},
		prepareUpload: function prepareUpload() {
			var url = this.url,
			    createImgUrl = this.createImgUrl,
			    field = this.field,
			    ki = this.ki;

			this.$emit('crop-success', createImgUrl, field, ki);
			if (typeof url == 'string' && url) {
				this.upload();
			} else {
				this.off();
			}
		},

		// 上传图片
		upload: function upload() {
			var that = this,
			    lang = this.lang,
			    imgFormat = this.imgFormat,
			    mime = this.mime,
			    url = this.url,
			    params = this.params,
			    headers = this.headers,
			    field = this.field,
			    ki = this.ki,
			    createImgUrl = this.createImgUrl,
			    withCredentials = this.withCredentials,
			    method = this.method,
			    fmData = new FormData();

			fmData.append(field, Object(__WEBPACK_IMPORTED_MODULE_6__utils_data2blob_js__["a" /* default */])(createImgUrl, mime), field + '.' + imgFormat);

			// 添加其他参数
			if ((typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(params)) == 'object' && params) {
				__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
					fmData.append(k, params[k]);
				});
			}

			// 监听进度回调
			var uploadProgress = function uploadProgress(event) {
				if (event.lengthComputable) {
					that.progress = 100 * Math.round(event.loaded) / event.total;
				}
			};

			// 上传文件
			that.reset();
			that.loading = 1;
			that.setStep(3);
			new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var client = new XMLHttpRequest();
				client.open(method, url, true);
				client.withCredentials = withCredentials;
				client.onreadystatechange = function () {
					if (this.readyState !== 4) {
						return;
					}
					if (this.status === 200 || this.status === 201) {
						resolve(JSON.parse(this.responseText));
					} else {
						reject(this.status);
					}
				};
				client.upload.addEventListener("progress", uploadProgress, false); //监听进度
				// 设置header
				if ((typeof headers === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(headers)) == 'object' && headers) {
					__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(headers).forEach(function (k) {
						client.setRequestHeader(k, headers[k]);
					});
				}
				client.send(fmData);
			}).then(
			// 上传成功
			function (resData) {
				if (that.value) {
					that.loading = 2;
					that.$emit('crop-upload-success', resData, field, ki);
				}
			},
			// 上传失败
			function (sts) {
				if (that.value) {
					that.loading = 3;
					that.hasError = true;
					that.errorMsg = lang.fail;
					that.$emit('crop-upload-fail', sts, field, ki);
				}
			});
		}
	},
	created: function created() {
		var _this3 = this;

		// 绑定按键esc隐藏此插件事件
		document.addEventListener('keyup', function (e) {
			if (_this3.value && (e.key == 'Escape' || e.keyCode == 27)) {
				_this3.off();
			}
		});
	}
});

/***/ }),

/***/ "JLFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditReviewProfile',
  data: function data() {
    return {
      purchase: null,
      review: { rate: null, comment: null, date: new Date() },
      isNew: true,
      successfeedback: false
    };
  },

  components: { 'star-rating': __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  validations: {
    review: {
      rate: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      comment: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      }
    }
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.$http.get('purchase/' + this.$route.params.id, {
        params: { populate: 'product' }
      }).then(function (response) {
        _this.purchase = response.data;
        if (_this.purchase.review) {
          _this.review = _this.purchase.review;
          _this.isNew = !_this.review.comment && !_this.review.rate;
        }
      }, function (err) {
        // error callback
        console.log(err);
      });
    },
    save: function save() {
      var _this2 = this;

      if (!this.$v.$invalid) {
        var promise = null;
        if (this.isNew) {
          promise = this.$http.put('purchase/' + this.$route.params.id + '/review', {
            review: this.review
          });
        } else {
          promise = this.$http.post('purchase/' + this.$route.params.id + '/review', {
            review: this.review
          });
        }

        promise.then(function (response) {
          if (_this2.purchase.review) {
            _this2.review = _this2.purchase.review;
            _this2.isNew = false;
            _this2.successfeedback = true;
          }
        }, function (err) {
          // error callback
          console.log(err);
        });
      } else {
        this.$v.review.comment.$touch();
      }
    }
  }
});

/***/ }),

/***/ "Ju25":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K5ke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav navbar-right"},[_c('li',{staticClass:"dropdown navbar-user"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:;","data-toggle":"dropdown"}},[_c('img',{staticClass:"img-avatar",attrs:{"src":"/beta/static/img/admin/avatars/default-user-64.png","alt":"admin"}}),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline"},[_vm._v("Admin")]),_vm._v(" "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:;"}},[_vm._v("Setting")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"/beta/admin/logout"}},[_vm._v("Log Out")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KV4/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KfXE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactDeveloper_vue__ = __webpack_require__("inBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01754cec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactDeveloper_vue__ = __webpack_require__("lMIr");
function injectStyle (ssrContext) {
  __webpack_require__("6RSC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01754cec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactDeveloper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01754cec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactDeveloper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kra8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var state = {
  notifications: []
};

var actions = {
  flash: function flash(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].FLASH, {
      message: payload.message,
      type: payload.type
      // typeObject: this.classes(this.types, payload.type),
      // iconObject: this.classes(this.icons, payload.type)
    });
    // setTimeout(this.hide, this.timeout)
  },
  unflash: function unflash(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].UNFLASH, payload);
  }
};

var getters = {
  notifications: function notifications(state) {
    return state.notifications;
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].FLASH, function (state, payload) {
  state.notifications.push(payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* default */].UNFLASH, function (state, payload) {
  state.notifications.splice(payload, 1);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "KuFQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dialog__ = __webpack_require__("deIM");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListCustomersAdmin',
  components: { 'modal': __WEBPACK_IMPORTED_MODULE_2__components_Dialog__["a" /* default */] },
  data: function data() {
    return {
      isLoading: true,
      customers: null,
      deleteAction: {
        showModal: false,
        customer: null
      }
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (customers) {
      return _this.customers = _this.populatecustomers(customers);
    });
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(['currentcustomer'])),
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      return this.$http.get('purchase').then(function (response) {
        _this2.isLoading = false;
        return response.data;
      }, function () {
        _this2.isLoading = false;
      });
    },
    populatecustomers: function populatecustomers(customers) {
      // Prepare data for each customer update set
      return customers;
    },
    deletecustomer: function deletecustomer(customer) {
      var _this3 = this;

      // Hide Modal
      console.log(customer._id);
      this.deleteAction.showModal = false;
      this.$http.delete('purchase/admin/' + user._id).then(function (response) {
        _this3.fetchData().then(function (customers) {
          return _this3.customers = _this3.populatecustomers(customers);
        });
      }, function () {
        // error callback
        _this3.showErrorMessage('Sorry but an error occurred when submitting form');
      });
    }
  }
});

/***/ }),

/***/ "L7wV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LAbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("9z4z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f74a954_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("kQz6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f74a954_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "LTvh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/medical-banner.d32c052.jpeg";

/***/ }),

/***/ "LbO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review-rate me-1"},[_c('ul',{staticClass:"review-star"},[_vm._l((_vm.fullStars),function(x){return _c('li',{key:x,staticClass:"active"},[_c('i',{staticClass:"fa fa-star"})])}),_vm._v(" "),_vm._l((_vm.emptyStars),function(x){return _c('li',{key:x},[_c('i',{staticClass:"fa fa-star-o"})])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1ddd21_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("L7wV");
function injectStyle (ssrContext) {
  __webpack_require__("du15")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1ddd21_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MLVc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "navbar"
});

/***/ }),

/***/ "MNJn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N4ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard sw-main sw-theme-default"},[_c('ul',{staticClass:"nav nav-tabs step-anchor"},_vm._l((_vm.steps),function(step,index){return _c('li',{class:{'active': _vm.currentStep >= index, 'active tab': _vm.modeWizard === 'tab'},style:({ width: 100/_vm.steps.length + '%' })},[_c('a',{attrs:{"href":("#step" + (index+1))},on:{"click":function($event){_vm.goPage(index)}}},[(_vm.modeWizard !== 'tab')?_c('span',{staticClass:"number"},[_vm._v(_vm._s(index+1))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"info text-ellipsis"},[_vm._v(_vm._s(step.label)+"\n          "),_c('small',[_vm._v(_vm._s(step.description))])])])])})),_vm._v(" "),_c('div',{staticClass:"sw-container tab-content"},[_vm._t(_vm.currentSlot)],2),_vm._v(" "),_c('nav',{staticClass:"navbar btn-toolbar sw-toolbar sw-toolbar-bottom"},[(_vm.modeWizard !== 'tab')?_c('div',{staticClass:"btn-group pull-right",attrs:{"role":"group"}},[_c('a',{staticClass:"pull-right btn btn-primary get-started rounded-pill",class:{ 'disabled': !_vm.backEnabled },staticStyle:{"border-radius":"20px"},attrs:{"href":"#previous","tabindex":"-1"},on:{"click":function($event){_vm.goBack()}}},[_vm._v("❮ Previous")]),_vm._v(" "),(!_vm.isFinalStep)?_c('a',{staticClass:"pull-right btn btn-primary get-started rounded-pill",staticStyle:{"border-radius":"20px"},attrs:{"href":"#next"},on:{"click":function($event){_vm.goNext()}}},[_vm._v("Save & Next ❯")]):_vm._e(),_vm._v(" "),(_vm.isFinalStep)?_c('a',{staticClass:"btn btn-primary get-started rounded-pill",staticStyle:{"border-radius":"20px"},attrs:{"href":"#submit"},on:{"click":function($event){_vm.doSubmit()}}},[_c('i',{staticClass:"fa fa-check-circle pe-2",attrs:{"aria-hidden":"true"}}),_vm._v("Submit Catalog")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.modeWizard === 'tab')?_c('div',{staticClass:"btn-group  pull-right"},[(_vm.isFinalStep)?_c('a',{staticClass:"btn btn-primary get-started rounded-pill",staticStyle:{"border-radius":"20px"},attrs:{"href":"#next"},on:{"click":function($event){_vm.doSave()}}},[_vm._v("Save")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap__ = __webpack_require__("gNGx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import Vuex from 'vuex'









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = "production" === 'production';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = "https://app-bcbc6e14-34fc-4792-b999-af070ceae2e9.cleverapps.io";

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  // read token en put in request
  // TODO: si pas de token essayer de le récupérer ?
  var token = localStorage.getItem('authToken');

  // modify headers
  request.headers.set('X-CSRF-TOKEN', token);
  request.headers.set('Authorization', 'Bearer ' + token);

  // continue to next interceptor
  next(function (res) {
    // Unauthorized Access
    if (res.status === 401) {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('flash', {
        message: 'Sorry, you are not autorized to do this action',
        type: 'warning'
      });
    } else if (res.status === 500) {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('flash', {
        message: 'Sorry we encountered an internal error with the server, please try again later',
        type: 'error'
      });
    }
  });
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('checkAuth').finally(function () {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
  });
});

/***/ }),

/***/ "NnwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light"},[_c('div',{staticClass:"has-bg section-container",attrs:{"id":"about-us-cover"}},[_c('div',{staticClass:"cover-bg"},[_c('img',{attrs:{"src":"/beta/static/img/about-bg/slider-xray-2.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-us text-center"},[_c('h1',[_vm._v("about womia")])])])]),_vm._v(" "),_c('div',{staticClass:"section-container bg-white",attrs:{"id":"about-us-content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-us-content"},[_c('h2',{staticClass:"title text-center"},[_vm._v("What we do?")]),_vm._v(" "),_c('p',{staticClass:"desc text-center"},[_vm._v("\n                    womia is democratizing the medical imaging applications market. "),_c('br'),_vm._v(" It provides a new way for distributing, monetizing and evaluating medical imaging solutions.\n                  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa   fa-user-md"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('p',{staticClass:"desc"},[_vm._v("We believe physicians can use one preferred platform for visualizing all their medical images and find third-party Apps that fulfill their needs.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-laptop"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('p',{staticClass:"desc"},[_vm._v("We believe all good medical imaging Apps built by researchers and developers deserve a chance for success.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-globe"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('p',{staticClass:"desc"},[_vm._v("We believe in a worldwide community of users and developers of medical imaging Apps that will create improve patient care and empower independent app developers.")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NphM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NxHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel slide",attrs:{"id":"carouselExampleSlidesOnly","data-ride":"carousel"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item active"},[_c('img',{staticClass:"d-block w-100",attrs:{"alt":"First slide [800x400]","src":__webpack_require__("LTvh")}})])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#carouselExampleControls","role":"button","data-slide":"prev"}},[_c('span',{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-next",attrs:{"href":"#carouselExampleControls","role":"button","data-slide":"next"}},[_c('span',{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OANO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OiSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-3"},[_c('h3',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('div',[_c('rating',{staticClass:"pull-left m-r-10 ",attrs:{"rate":_vm.product.stats.rate}}),_vm._v(" "),_c('b',[(_vm.product.stats.rate)?_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v(_vm._s(_vm.product.stats.rate)+" out of 5 |")]):_vm._e(),_vm._v(" "+_vm._s(_vm.product.stats.reviews)+"\n            review"+_vm._s(_vm.product.stats.reviews > 1 ? 's' : '')+" | "+_vm._s(_vm.product.stats.users)+" user"+_vm._s(_vm.product.stats.users
            > 1 ?
            's' : ''))])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.product.reviews),function(review,index){return _c('div',{key:index,staticClass:"col-lg-12"},[_c('div',[_c('div',{staticClass:"card-body"},[_c('review',{attrs:{"item":review}})],1)])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P7ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-wrap"},[_c('transition-group',{attrs:{"name":_vm.transition,"tag":"div"}},_vm._l((_vm.notifications),function(item,index){return _c('div',{key:index,class:_vm.classes(_vm.types, item.type),attrs:{"role":"alert"}},[(_vm.displayIcons)?_c('span',{class:_vm.classes(_vm.icons, item.type)}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.message)}})])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PZPT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q0bI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light section-container p-t-20"},[_c('div',{staticClass:"container to-resp"},[_c('div',{staticClass:"account-container",staticStyle:{"min-height":"600px"}},[_c('div',{staticClass:"account-sidebar"},[_c('div',{staticClass:"account-sidebar-cover"}),_vm._v(" "),_c('div',{staticClass:"account-sidebar-content"},[_c('h4',[_vm._v("Data Provider Account")]),_vm._v(" "),_c('ul',{staticClass:"nav nav-list"},[_c('li',[_c('router-link',{staticClass:"nav-link hover-orange",attrs:{"to":{ name: 'DashboardDeveloper'}}},[_vm._v("Dashboard")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"nav-link hover-orange",attrs:{"to":{ name: 'ListProductDeveloper'}}},[_vm._v("My catalogs")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"nav-link hover-orange",attrs:{"to":{ name: 'CreateProductDeveloper'}}},[_vm._v("Add catalog")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"account-body"},[_c('router-view')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q1v4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBuildYourApp_vue__ = __webpack_require__("uLLs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cf87ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBuildYourApp_vue__ = __webpack_require__("x/RL");
function injectStyle (ssrContext) {
  __webpack_require__("3djO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36cf87ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBuildYourApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cf87ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBuildYourApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q9bD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      isOpen: false,
      isExpanded: false,
      isTitleVisible: false,
      selectedIndex: null
    };
  },

  methods: {
    selectItem: function selectItem(index) {
      this.selectedIndex = index;
      this.$router.push(this.navItems[index].url);
    },
    showFullSidebar: function showFullSidebar() {
      this.isOpen = true;
      this.isExpanded = true;
      this.emitResizeEvent();
    },
    hideFullSidebar: function hideFullSidebar() {
      this.isOpen = false;
      this.isExpanded = false;
      this.emitResizeEvent();
    },
    emitResizeEvent: function emitResizeEvent() {
      this.$emit('sidebar-resize', this.getSidebarWidth());
    },
    handleTransitionEnd: function handleTransitionEnd() {
      this.isTitleVisible = this.isExpanded;
    },
    getSidebarWidth: function getSidebarWidth() {
      return this.isExpanded ? 300 : 120;
    }
  },
  mounted: function mounted() {
    this.$el.addEventListener('transitionend', this.handleTransitionEnd);
    this.emitResizeEvent();
  },
  beforeDestroy: function beforeDestroy() {
    this.$el.removeEventListener('transitionend', this.handleTransitionEnd);
  }
});

/***/ }),

/***/ "QoCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.products),function(product){return _c('app-card',{key:product.slug,attrs:{"product":product}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RLqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignUp',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(6) },
    confirmPassword: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], sameAsPassword: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["sameAs"])('password') }
  },
  data: function data() {
    return {
      message: {
        success: false,
        error: false
      },
      ok: null,
      email: null,
      password: null,
      confirmPassword: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapActions(['signUp', 'startLoading', 'endLoading']), {
    hideErrorMessage: function hideErrorMessage() {
      this.message.error = null;
    },
    showErrorMessage: function showErrorMessage(message) {
      this.message.error = message;
    },
    showSuccessMessage: function showSuccessMessage(message) {
      this.message.success = message;
    },

    sendSignUp: function sendSignUp() {
      var _this = this;

      this.hideErrorMessage();
      var self = this;
      if (!this.$v.$invalid) {
        this.startLoading();
        this.signUp({
          email: this.email,
          password: this.password
        }).then(function () {
          self.showSuccessMessage('Thanks for signing up. Please check your email for confirmation!');
        }).catch(function (err) {
          try {
            var errMsgObj = JSON.parse(err.message);

            if (errMsgObj.message === 'signUp.email.alreadyUsed') {
              errMsgObj.messageText = 'The email address you have entered is already registered';
            } else {
              errMsgObj.messageText = 'Sorry but an error occurred when submitting form';
            }
            _this.showErrorMessage(errMsgObj.messageText);
          } catch (error) {
            console.log(error);
          }
        }).finally(function () {
          _this.endLoading();
        });
      } else {
        this.showErrorMessage('Form is not valid, please fill all fields following requirements');
      }
    }
  })
});

/***/ }),

/***/ "RMYu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("VwAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c4252e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("jHf7");
function injectStyle (ssrContext) {
  __webpack_require__("V1Ay")
  __webpack_require__("KV4/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59c4252e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c4252e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rkxk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ro9n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("peAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01bf11bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("TEO6");
function injectStyle (ssrContext) {
  __webpack_require__("h9+g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01bf11bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ry68":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S8ER":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AcceptTermsConditions__ = __webpack_require__("4unu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterBrand__ = __webpack_require__("ul0S");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PublicLayout',
  components: {
    'nav-bar': __WEBPACK_IMPORTED_MODULE_0__components_Navbar__["a" /* default */],
    'accept-terms': __WEBPACK_IMPORTED_MODULE_1__components_AcceptTermsConditions__["a" /* default */],
    'footer-brand': __WEBPACK_IMPORTED_MODULE_2__components_FooterBrand__["a" /* default */]
  },
  created: function created() {
    /* remove classes added with admin theme */
    document.body.classList.remove('app', 'header-fixed', 'sidebar-fixed', 'aside-menu-fixed', 'aside-menu-hidden');
  }
});

/***/ }),

/***/ "SXmG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditReviewProfile_vue__ = __webpack_require__("JLFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b51799c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditReviewProfile_vue__ = __webpack_require__("BmoL");
function injectStyle (ssrContext) {
  __webpack_require__("uMnI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditReviewProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b51799c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditReviewProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SZ+K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SoFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Edit Customer'
});

/***/ }),

/***/ "SrnL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListUser_vue__ = __webpack_require__("8vMr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7034b3f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListUser_vue__ = __webpack_require__("7+SM");
function injectStyle (ssrContext) {
  __webpack_require__("CtQy")
  __webpack_require__("B9yL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7034b3f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7034b3f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SywA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("MLVc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0ee2436_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("Emm+");
function injectStyle (ssrContext) {
  __webpack_require__("w/lO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0ee2436"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0ee2436_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TEO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-2"},[_vm._v("Dashboard")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('div',{staticClass:"widget widget-stats bg-gradient-green"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"stats-content"},[_c('div',{staticClass:"stats-title"},[_vm._v("PAGE VIEWS")]),_vm._v(" "),_c('div',{staticClass:"stats-number"},[_vm._v(_vm._s(_vm.stats.pageViews))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('div',{staticClass:"widget widget-stats bg-gradient-blue"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"stats-content"},[_c('div',{staticClass:"stats-title"},[_vm._v("CUSTOMERS")]),_vm._v(" "),_c('div',{staticClass:"stats-number"},[_vm._v(_vm._s(_vm.stats.customers))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('div',{staticClass:"widget widget-stats bg-gradient-purple"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"stats-content"},[_c('div',{staticClass:"stats-title"},[_vm._v("DOWNLOADS")]),_vm._v(" "),_c('div',{staticClass:"stats-number"},[_vm._v(_vm._s(_vm.stats.downloads))])])])])]),_vm._v(" "),_c('div',{staticClass:"row m-0 p-0"},[((!_vm.products || _vm.products.length === 0) && !_vm.isLoading)?_c('div',{staticClass:"note note-purple m-b-15"},[_c('p',{staticClass:"p-0 m-0"},[_vm._v("There are no approved Catalogs.")])]):_vm._e(),_vm._v(" "),(_vm.products.length)?_c('div',{staticClass:"panel"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"panel-body p-t-0"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-b-0 table-valign-middle"},[_vm._m(4,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product._id},[_c('td',[_c('p',[_vm._v(_vm._s(product.name))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(product.stats.pageViews))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(product.stats.users))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(product.stats.downloads))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"btn btn-sm btn-primary get-started rounded-pill",staticStyle:{"width":"max-content"},attrs:{"to":{ name: 'Product', params: { slug: product.slug }}}},[_vm._v("Catalog")])],1)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"btn btn-sm btn-primary get-started rounded-pill",attrs:{"to":{ name: 'DashboardReviewAdmin', params: { slug: product.slug }}}},[_vm._v("Reviews")])],1)])])}))])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-icon stats-icon-lg"},[_c('i',{staticClass:"fa fa-globe fa-fw"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-icon stats-icon-lg"},[_c('i',{staticClass:"fa fa-users fa-fw"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-icon stats-icon-lg"},[_c('i',{staticClass:"fa fa-cloud-download fa-fw"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading bg-light"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Catalogs Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"label"},[_vm._v(" Catalog Name")])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('span',{staticClass:"label bg-gradient-green"},[_vm._v("Total Page Views")])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('span',{staticClass:"label bg-gradient-blue"},[_vm._v("Total Customers")])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('span',{staticClass:"label bg-gradient-purple"},[_vm._v("Total Downloads")])]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TMHx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__("rxOV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec9ad58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__("WMRe");
function injectStyle (ssrContext) {
  __webpack_require__("PZPT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec9ad58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TQxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light section-container p-t-20",attrs:{"id":"product"}},[_c('div',{staticClass:"container"},[(_vm.purchase)?_c('div',{staticClass:"checkout"},[_c('div',{staticClass:"checkout-body"},[_c('div',{staticClass:"checkout-message "},[_c('h1',{staticClass:"d-flex justify-content-center"},[_vm._v("Access Request")]),_vm._v(" "),_c('div',{staticClass:"fs-20px fw-bold text-gray-600 d-flex justify-content-center mb-4"},[_vm._v("\n            Confirm your request by using the link below to download our Womia card\n          ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive2"},[_c('table',{staticClass:"table table-payment-summary"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Name")]),_vm._v(" "),_c('td',{staticClass:"value"},[_vm._v(_vm._s(_vm.purchase.product.name))])]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Ask access")]),_vm._v(" "),_c('td',{staticClass:"value"},[_c('a',{staticClass:"btn-link",attrs:{"href":(_vm.baseUrl + "/purchase/" + (_vm.purchase._id) + "/download?authToken=" + _vm.authToken)}},[_vm._v("Confirm access request")])])])])])])]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary get-started rounded-pill",staticStyle:{"margin":"auto","display":"table"},attrs:{"href":"/beta/profile/purchase"}},[_vm._v("My\n          Requests")])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"field"},[_vm._v("Transaction Status")]),_vm._v(" "),_c('td',{staticClass:"value"},[_vm._v("Success")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"field"},[_vm._v("Payment Amount")]),_vm._v(" "),_c('td',{staticClass:"value"},[_vm._v("Free")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TWxd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb pull-right"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TaMM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rating_vue__ = __webpack_require__("hAsA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeac7bc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rating_vue__ = __webpack_require__("LbO/");
function injectStyle (ssrContext) {
  __webpack_require__("Wc7c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rating_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeac7bc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rating_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tqus":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardDeveloper_vue__ = __webpack_require__("9XK0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0563fec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardDeveloper_vue__ = __webpack_require__("4LUo");
function injectStyle (ssrContext) {
  __webpack_require__("c57S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardDeveloper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0563fec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardDeveloper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U+Dp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Rating__ = __webpack_require__("TaMM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RatingStats__ = __webpack_require__("8ZpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Review__ = __webpack_require__("jKoA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gallery__ = __webpack_require__("I4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Product",
  data: function data() {
    return {
      product: null,
      images: [],
      index: null,
      purchase: null,
      hoveredItems: {},
      classList: ["bg-primary-200 text-theme-800", "bg-indigo-200 text-indigo-800", "bg-aqua-200 text-aqua-800", "bg-red-200 text-red-800", "bg-green-200 text-green-800"],
      classIndex: 0,
      categories: {
        modality: ["mri", "xray", "ct", "eeg", "ecg"],
        organ: ["lung", "heart", "liver", "arteries", "trachea", "spine", "pancreas", "spleen", "kidneys", "intestines", "bone", "breast", "teeth", "other"],
        bodyRegion: ["chest", "abdominal", "pelvic", "head", "cervical", "whole-body", "chest abdominal", "chest abdominal pelvic", "cervical chest abdominal pelvic", "chest abdominal pelvic head"],
        pathology: ["healthy", "covid", "nodule", "masse", "fibrosis", "emphysma", "pulmonary interstitial disease", "dilated heart", "thormbus", "atheroma", "dissection", "aneurysm", "pulmonary disease", "arterial disease", "heart disease"],
        orientation: ["axial", "coronal", "sagittal", "short-axis", "long-axis-2-cavities", "long-axis-3-cavities", "long-axis-4-cavities", "multiplanar", "multiplanar-radial", "multiplanar-short-axis"],
        type: ["2D", "2D+T", "2D+t", "3D", "3D+T", "3D+t", "none"],
        age: ["20-30", "30-40", "40-50", "50-60", "60-70", "70-80"],
        protocol: ["chest-", "abdominal-", "pelvic-", "cerebral", "cervical-", "whole-body", "chest-abdominal", "chest-abdominal-pelvic", "cervical-chest-abdominal-pelvic", "chest-abdominal-pelvic-cerebral", "abdominal-pelvic", "cervical spine", "Aortic-Angiography", "thoracic-angiography", "supra-aortic-trunks-angiography", "lower-extremity-angiography", "cerebral-angiography", "abdominal-angiography", "thoracic-spine", "lumbar-spine", "coronary", "flow-2D", "flow-3D", "cine SSFP", "cardiac-function", "anatomy", "perfusion", "enhancement", "tagging", "angiography", "t1-mapping", "t2-mapping", "t2* mapping", "dixon"]

      }

    };
  },

  components: {
    gallery: __WEBPACK_IMPORTED_MODULE_5_vue_gallery___default.a,
    rating: __WEBPACK_IMPORTED_MODULE_2__components_Rating__["a" /* default */],
    review: __WEBPACK_IMPORTED_MODULE_4__components_Review__["a" /* default */],
    "rating-stats": __WEBPACK_IMPORTED_MODULE_3__components_RatingStats__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */].mapGetters(["isAuthenticated", "authToken"]), {
    filteredCategories: function filteredCategories() {
      var _this = this;

      if (!this.product || !this.product.categories) return {};

      var filtered = {};

      // Remove the conversion to lowercase here
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.categories).forEach(function (key) {
        filtered[key] = _this.product.categories.filter(function (cat) {
          return _this.categories[key].includes(cat);
        });
      });

      return filtered;
    },
    splitCountries: function splitCountries() {
      return this.product.country.split('#').map(function (country) {
        return country.trim();
      });
    }
  }),

  created: function created() {
    this.fetchData();
  },

  watch: {
    product: function product(val) {
      if (this.isAuthenticated) {
        this.checkPurchase();
      }
    }
  },
  beforeCreate: function beforeCreate() {
    window.scrollTo(0, 0);
  },
  beforeMount: function beforeMount() {
    window.scrollTo(0, 0);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$nextTick(function () {
        window.scrollTo(0, 0);
      });
    });
  },

  methods: {
    checkPurchase: function checkPurchase() {
      var _this2 = this;

      this.$http.get("purchase", {
        params: {
          conditions: { product: this.product._id }
        }
      }).then(function (response) {
        _this2.purchase = response.data[0];
      }, function (error) {
        console.log(error);
      });
    },
    getClass: function getClass(index) {
      var classIndex = index % this.classList.length;
      return this.classList[classIndex];
    },
    fetchData: function fetchData() {
      var _this3 = this;

      var viewStatus = {
        edit: { label: "Editing", class: "badge-warning" },
        pending: { label: "Waiting for approval", class: "badge-info" },
        declined: { label: "Declined", class: "badge-danger" },
        approved: { label: "Approved", class: "badge-success" },
        closed: { label: "Closed", class: "badge-default" }
      };

      var productUri = "product/public/";
      /* if (this.isAuthenticated) {
        productUri = 'product/dev/'
      } */
      this.$http.get("" + productUri + this.$route.params.slug, {
        params: { populate: "author" }
      }).then(function (response) {
        _this3.product = response.body;
        _this3.images = (_this3.product.screenshots || []).map(function (it) {
          return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].filter("media")(it.slug, {});
        });
        // formating app status
        _this3.product.status = viewStatus[_this3.product.status];
        _this3.product.logo = _this3.product.logo || {};
        _this3.product.videos = _this3.product.videos || [];
        _this3.product.reviews = _this3.product.reviews || [];
      }, function (response) {
        console.log(response);
      });
    },
    formatCategoryTitle: function formatCategoryTitle(title) {
      return title.split(/(?=[A-Z])/).join(' ').replace(/-/g, ' ').replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
    },
    formatCategoryItem: function formatCategoryItem(categoryKey, item) {
      if (categoryKey === 'type') {
        return item;
      }
      return item.split(/(?=[A-Z])/).join(' ').replace(/-/g, ' ').replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
    },
    install: function install() {
      var _this4 = this;

      if (!this.isAuthenticated) {
        this.$router.push({
          name: "Login",
          query: { redirect: this.$route.path, section: "askDemoSection" }
        });
      } else {
        this.$http.put("purchase", { product: this.product._id }).then(function (response) {
          var purchase = response.data;
          if (purchase.status === "paid") {
            _this4.$router.push({
              name: "Install",
              params: { id: purchase._id }
            });
          }
          if (purchase.status === "init") {
            console.log("Paid product");
          }
        }, function (error) {
          console.log(error);
        });
      }
    },
    setHovered: function setHovered(pubLink, value) {
      this.$set(this.hoveredItems, pubLink, value);
    },
    isHovered: function isHovered(pubLink) {
      return this.hoveredItems[pubLink] || false;
    }
  }
});

/***/ }),

/***/ "U0xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__ = __webpack_require__("HIE2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2265f52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__ = __webpack_require__("pld8");
function injectStyle (ssrContext) {
  __webpack_require__("zGew")
  __webpack_require__("AR0e")
  __webpack_require__("tQJA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2265f52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2265f52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U241":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ud8+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V1Ay":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VYwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Rating__ = __webpack_require__("TaMM");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Review",
  props: ["item"],
  data: function data() {
    return {
      showFullComment: false
    };
  },

  computed: {
    truncatedComment: function truncatedComment() {
      return this.item.comment.slice(0, 120);
    }
  },
  methods: {
    toggleFullComment: function toggleFullComment() {
      this.showFullComment = !this.showFullComment;
    }
  },
  components: { rating: __WEBPACK_IMPORTED_MODULE_0__components_Rating__["a" /* default */] }
});

/***/ }),

/***/ "VwAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Banner__ = __webpack_require__("98WO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppList__ = __webpack_require__("iRIX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sidebar__ = __webpack_require__("lZ5c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBuildYourApp__ = __webpack_require__("Q1v4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterSubscribe__ = __webpack_require__("ajOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Search__ = __webpack_require__("/KFX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    search: __WEBPACK_IMPORTED_MODULE_6__components_Search__["a" /* default */],
    banner: __WEBPACK_IMPORTED_MODULE_1__components_Banner__["a" /* default */],
    "app-list": __WEBPACK_IMPORTED_MODULE_2__components_AppList__["a" /* default */],
    sidebar: __WEBPACK_IMPORTED_MODULE_3__components_Sidebar__["a" /* default */],
    "footer-build-your-app": __WEBPACK_IMPORTED_MODULE_4__components_FooterBuildYourApp__["a" /* default */],
    "footer-subscribe": __WEBPACK_IMPORTED_MODULE_5__components_FooterSubscribe__["a" /* default */]
  },
  name: "Home",

  data: function data() {
    return {
      conditions: {},
      currentFilter: 'all',
      currentAnnotatedFilter: { annotated: 'all' },
      filteredProducts: [],
      searchProducts: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */].mapGetters(["isAuthenticated"])),

  watch: {
    $route: function $route(to, from) {
      var _this = this;

      // react to route changes...
      if (to.query.search !== from.query.search && to.query.search) {
        this.loadMyApps();
      } else {
        this.fetchData().then(function (products) {
          return _this.searchProducts = products;
        });
      }
    },

    searchProducts: function searchProducts(val) {
      this.$emit('searchText', val);
    }
  },

  created: function created() {
    var _this2 = this;

    this.products = [];
    if (this.isAuthenticated && this.$route.query.search === "MyApps") {
      this.loadMyApps();
    } else {
      this.fetchData().then(function (products) {
        _this2.products = products;
        _this2.searchProducts = products;
      });
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */].mapActions(["startLoading", "endLoading"]), {
    loadMyApps: function loadMyApps() {
      var _this3 = this;

      this.startLoading();
      this.$http.get("purchase", { params: { populate: "product" } }).then(function (response) {
        // transform into products
        _this3.searchProducts = response.data.map(function (purchase) {
          return purchase.product;
          // To avoid error when App is no longer in the App Store (Deleted)
        }).filter(function (product) {
          return product;
        });
      }, function (response) {
        // error callback
        console.log(response);
      }).finally(function () {
        _this3.endLoading();
      });
    },
    searchText: function searchText(text) {
      var _this4 = this;

      if (text) {
        var filteredData = this.searchProducts.filter(function (product) {
          return product.name.toLowerCase().includes(text.toLowerCase());
        });
        this.searchProducts = filteredData;
      } else {
        this.fetchData().then(function (products) {
          return _this4.searchProducts = products;
        });
      }
    },
    categoryFilter: function categoryFilter(conditions) {
      var _this5 = this;

      this.categoriesConditions = conditions;
      this.fetchData({ conditions: conditions }).then(function (products) {
        return _this5.searchProducts = products;
      });
    },
    fetchData: function fetchData(params) {
      var _this6 = this;

      this.startLoading();
      params = params || {};
      params.populate = "author";
      return this.$http.get("product/public", {
        params: params
      }).then(function (response) {
        return response.data;
      }, function (err) {
        // error callback
        console.log(err);
      }).finally(function () {
        _this6.endLoading();
      });
    },
    applyFilter: function applyFilter(filter) {
      var _this7 = this;

      this.currentFilter = filter;

      var conditions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.categoriesConditions);

      if (filter === 'annotated') {
        conditions.annotated = 'yes';
      } else if (filter === 'all') {
        delete conditions.annotated;
      }

      this.fetchData({ conditions: conditions }).then(function (products) {
        return _this7.searchProducts = products;
      });
    }
  })
});

/***/ }),

/***/ "W54i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WMRe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app page-sidebar-fixed page-header-fixed"},[_c('nav-bar',{staticClass:"navbar-fixed"}),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('Sidebar',{ref:"sidebarRef",attrs:{"navItems":_vm.nav},on:{"sidebar-resize":_vm.updateSidebarWidth}}),_vm._v(" "),_c('div',{staticClass:"content",style:({ paddingLeft: _vm.sidebarWidth + 'px' }),attrs:{"id":"content"}},[_c('router-view')],1)],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WYVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wc7c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XkKU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light"},[_c('div',{staticClass:"has-bg section-container",attrs:{"id":"about-us-cover"}},[_c('div',{staticClass:"cover-bg"},[_c('img',{attrs:{"src":"/beta/static/img/apps-user/slider-xray-1.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-us text-center"},[_c('h1',[_vm._v("womia for apps user")])])])]),_vm._v(" "),_c('div',{staticClass:"section-container bg-white",attrs:{"id":"about-us-content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-us-content"},[_c('h2',{staticClass:"title text-center"},[_vm._v("What womia provides to the Apps User ?")]),_vm._v(" "),_c('p',{staticClass:"desc text-center"},[_vm._v("\n                    Access to high value medical imaging Apps with transparent quality.\n                ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-6"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa  fa-clock-o"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Find the right App in a few Clicks")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Rapid access to a collection of innovative medical imaging applications\n                                    in a one stop shop.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa  fa-usd"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Purchase only Apps that you need")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Save thousands of dollars versus OEM packages imaging software. Need\n                                    based model : You pay for what you need.")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-6"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-check-circle"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Get accurate perception of the Apps quality")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("See parmeters that shows the quality of the Apps in terms of\n                                    reliability, accuracy and rapidity.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa  fa-cogs"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Optimize your process")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Save time by using one preferred platform for visualizing all your\n                                    medical images and empower it with the third-party Apps that you need.")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XunF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd25f2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("NnwS");
function injectStyle (ssrContext) {
  __webpack_require__("WYVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fd25f2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd25f2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_public_PublicLayout__ = __webpack_require__("4gdP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_public_Home__ = __webpack_require__("RMYu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_public_Contact_vue__ = __webpack_require__("2+Hi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_public_ContactDeveloper_vue__ = __webpack_require__("KfXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_public_Product__ = __webpack_require__("sUWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_public_Install__ = __webpack_require__("9PtS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_public_About__ = __webpack_require__("XunF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_public_Tech__ = __webpack_require__("gS5s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_public_AppsUser__ = __webpack_require__("vsSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_public_AppsDev__ = __webpack_require__("606M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_developer_DeveloperLayout__ = __webpack_require__("mIRV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_developer_DashboardDeveloper__ = __webpack_require__("Tqus");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_developer_EditProductDeveloper__ = __webpack_require__("bLnG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_developer_ListProductDeveloper__ = __webpack_require__("dgq0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_developer_WithdrawDeveloper__ = __webpack_require__("8jHW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_developer_DashboardReview__ = __webpack_require__("C+oc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__admin_containers_Full__ = __webpack_require__("TMHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__admin_views_Dashboard__ = __webpack_require__("Ro9n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__admin_views_product_ListApp__ = __webpack_require__("oAGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__admin_views_product_EditApp__ = __webpack_require__("hmwb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__admin_views_user_ListUser__ = __webpack_require__("SrnL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__admin_views_user_EditUser__ = __webpack_require__("4b9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__admin_views_subscriber_ListSubscribers__ = __webpack_require__("EC1K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__admin_components_Logout__ = __webpack_require__("psjl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__admin_views_DashboardReviewAdmin_vue__ = __webpack_require__("f65y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__admin_views_customer_ListCustomer__ = __webpack_require__("8O9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__admin_views_customer_EditCustomer__ = __webpack_require__("fFXq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_profile_ProfileLayout__ = __webpack_require__("ifR8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_profile_ViewProfile__ = __webpack_require__("oNML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_profile_EditProfile__ = __webpack_require__("U0xg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_profile_EditPasswordProfile__ = __webpack_require__("vOA6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_profile_ProductsProfile__ = __webpack_require__("8l7o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_profile_Purchases__ = __webpack_require__("1juY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_profile_EditReviewProfile__ = __webpack_require__("SXmG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_auth_AuthLayout__ = __webpack_require__("fk+t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_auth_Login__ = __webpack_require__("hV0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_auth_SignUp__ = __webpack_require__("hCa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_auth_ConfirmEmail__ = __webpack_require__("fDWE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_auth_ForgotPassword__ = __webpack_require__("BekM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_auth_ResetPassword__ = __webpack_require__("fLTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__store__ = __webpack_require__("IcnI");


















































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [
  // App store / Developer Dasboard
  {
    path: '/beta',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_public_PublicLayout__["a" /* default */],
    children: [{
      path: '/',
      name: 'Home',
      component: __WEBPACK_IMPORTED_MODULE_3__pages_public_Home__["a" /* default */]
    }, {
      path: '/beta/about-us',
      name: 'About Us',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_public_About__["a" /* default */]
    }, {
      path: '/beta/tech',
      name: 'tech',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_public_Tech__["a" /* default */]
    }, {
      path: '/beta/apps-user',
      name: 'Apps User',
      component: __WEBPACK_IMPORTED_MODULE_10__pages_public_AppsUser__["a" /* default */]
    }, {
      path: '/beta/apps-developer',
      name: 'Apps Developer',
      component: __WEBPACK_IMPORTED_MODULE_11__pages_public_AppsDev__["a" /* default */]
    }, {
      path: '/beta/contact-us',
      name: 'Contact Us',
      component: __WEBPACK_IMPORTED_MODULE_4__pages_public_Contact_vue__["a" /* default */]
    }, {
      path: '/beta/contact-us-developer',
      name: 'Contact Us Developer',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_public_ContactDeveloper_vue__["a" /* default */]
    }, {
      path: '/beta/product/:slug',
      name: 'Product',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_public_Product__["a" /* default */]
    }, {
      path: '/beta/purchase/:id/install',
      name: 'Install',
      component: __WEBPACK_IMPORTED_MODULE_7__pages_public_Install__["a" /* default */],
      meta: { requiresAuth: true }
    }, {
      path: '/beta/developer',
      component: __WEBPACK_IMPORTED_MODULE_12__pages_developer_DeveloperLayout__["a" /* default */],
      meta: { requiresAuth: true },
      children: [{
        path: 'dashboard',
        name: 'DashboardDeveloper',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_developer_DashboardDeveloper__["a" /* default */]
      }, {
        path: 'product/:slug/review',
        name: 'DashboardReview',
        component: __WEBPACK_IMPORTED_MODULE_17__pages_developer_DashboardReview__["a" /* default */]
      }, {
        path: 'product/:slug/edit',
        name: 'EditProductDeveloper',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_developer_EditProductDeveloper__["a" /* default */]
      }, {
        path: 'product/create',
        name: 'CreateProductDeveloper',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_developer_EditProductDeveloper__["a" /* default */]
      }, {
        path: 'product/',
        name: 'ListProductDeveloper',
        component: __WEBPACK_IMPORTED_MODULE_15__pages_developer_ListProductDeveloper__["a" /* default */]
      }, {
        path: 'withdraw',
        name: 'WithdrawDeveloper',
        component: __WEBPACK_IMPORTED_MODULE_16__pages_developer_WithdrawDeveloper__["a" /* default */]
      }]
    }, {
      path: '/beta/profile',
      component: __WEBPACK_IMPORTED_MODULE_29__pages_profile_ProfileLayout__["a" /* default */],
      meta: { requiresAuth: true },
      children: [{
        path: '/',
        name: 'Profile',
        component: __WEBPACK_IMPORTED_MODULE_30__pages_profile_ViewProfile__["a" /* default */]
      }, {
        path: 'apps',
        name: 'MyApp',
        component: __WEBPACK_IMPORTED_MODULE_33__pages_profile_ProductsProfile__["a" /* default */]
      }, {
        path: 'purchase',
        name: 'MyPurchases',
        component: __WEBPACK_IMPORTED_MODULE_34__pages_profile_Purchases__["a" /* default */]
      }, {
        path: 'purchase/:id/review',
        name: 'EditReviewProfile',
        component: __WEBPACK_IMPORTED_MODULE_35__pages_profile_EditReviewProfile__["a" /* default */]
      }, {
        path: 'edit',
        name: 'EditProfile',
        component: __WEBPACK_IMPORTED_MODULE_31__pages_profile_EditProfile__["a" /* default */]
      }, {
        path: 'password',
        name: 'EditPasswordProfile',
        component: __WEBPACK_IMPORTED_MODULE_32__pages_profile_EditPasswordProfile__["a" /* default */]
      }]
    }]
  }, {
    path: '/beta/auth',
    component: __WEBPACK_IMPORTED_MODULE_36__pages_auth_AuthLayout__["a" /* default */],
    children: [{
      path: '/',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_37__pages_auth_Login__["a" /* default */]
    }, {
      path: '/beta/sign-up',
      name: 'Signup',
      component: __WEBPACK_IMPORTED_MODULE_38__pages_auth_SignUp__["a" /* default */]
    }, {
      path: '/beta/confirm-email',
      name: 'ConfirmEmail',
      component: __WEBPACK_IMPORTED_MODULE_39__pages_auth_ConfirmEmail__["a" /* default */]
    }, {
      path: '/beta/forgot-password',
      name: 'ForgotPassword',
      component: __WEBPACK_IMPORTED_MODULE_40__pages_auth_ForgotPassword__["a" /* default */]
    }, {
      path: '/beta/reset-password',
      name: 'ResetPassword',
      component: __WEBPACK_IMPORTED_MODULE_41__pages_auth_ResetPassword__["a" /* default */]
    }]
  },
  // Admin Dashboard
  {
    path: '/beta/admin',
    redirect: '/beta/admin/dashboard',
    component: __WEBPACK_IMPORTED_MODULE_18__admin_containers_Full__["a" /* default */],
    name: 'Admin Home',
    meta: { requiresAuth: true },
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_19__admin_views_Dashboard__["a" /* default */]
    }, {
      path: 'product/:slug/review',
      name: 'DashboardReviewAdmin',
      component: __WEBPACK_IMPORTED_MODULE_26__admin_views_DashboardReviewAdmin_vue__["a" /* default */]
    }, {
      path: 'product/',
      name: 'App Management',
      component: __WEBPACK_IMPORTED_MODULE_20__admin_views_product_ListApp__["a" /* default */]
    }, {
      path: 'product/:slug/manage',
      name: 'Edit App',
      component: __WEBPACK_IMPORTED_MODULE_21__admin_views_product_EditApp__["a" /* default */]
    }, {
      path: 'user/',
      name: 'List of users',
      component: __WEBPACK_IMPORTED_MODULE_22__admin_views_user_ListUser__["a" /* default */]
    }, {
      path: 'user/:_id/edit',
      name: 'Edit user',
      component: __WEBPACK_IMPORTED_MODULE_23__admin_views_user_EditUser__["a" /* default */]
    }, {
      path: 'customer/',
      name: 'List of Customers',
      component: __WEBPACK_IMPORTED_MODULE_27__admin_views_customer_ListCustomer__["a" /* default */]
    }, {
      path: 'customer/:_id/edit',
      name: 'Edit customer',
      component: __WEBPACK_IMPORTED_MODULE_28__admin_views_customer_EditCustomer__["a" /* default */]
    }, {
      path: 'subscribers',
      name: 'List of Subscribers',
      component: __WEBPACK_IMPORTED_MODULE_24__admin_views_subscriber_ListSubscribers__["a" /* default */]
    }, {
      path: 'logout',
      component: __WEBPACK_IMPORTED_MODULE_25__admin_components_Logout__["a" /* default */]
    }]
  }, {
    path: '*',
    redirect: '/beta/'
  }]
});
// Check authentication
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_42__store__["a" /* default */].getters.isAuthenticated) {
      next({
        path: '/beta/auth/',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
// Check admin Role
router.beforeEach(function (to, from, next) {
  if (to.path === '/beta/' && __WEBPACK_IMPORTED_MODULE_42__store__["a" /* default */].getters.hasRole(['admin'])) {
    next({
      path: '/beta/admin'
    });
  } else {
    next();
  }
});
// Check roles
router.beforeEach(function (to, from, next) {
  var routeMatched = to.matched.find(function (record) {
    return record.meta.requiresRole;
  });
  if (routeMatched && !__WEBPACK_IMPORTED_MODULE_42__store__["a" /* default */].getters.hasRole(routeMatched.meta.requiresRole)) {
    __WEBPACK_IMPORTED_MODULE_42__store__["a" /* default */].dispatch('flash', {
      message: 'Sorry, you are not autorized to access to this page',
      type: 'warning'
    });
    next({
      name: 'Home'
    });
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Ys4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProfile',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  validations: {
    password: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(6)
    },
    confirmPassword: {
      sameAsPassword: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password')
    }
  },
  data: function data() {
    return {
      password: null,
      confirmPassword: null,
      message: {}
    };
  },

  methods: {
    hideMessage: function hideMessage() {
      this.message = {};
    },
    showMessage: function showMessage(message) {
      this.message = message;
    },

    save: function save() {
      var _this = this;

      this.hideMessage();
      if (!this.$v.confirmPassword.$invalid && !this.$v.password.$invalid) {
        this.$http.post('user/me/reset-password', { password: this.password }).then(function (response) {
          _this.showMessage({ text: 'Your password has been changed successfully', alert: 'alert-info' });
        }, function (err) {
          // error callback
          console.log(err);
          _this.showMessage({ text: 'Sorry, your password was not changed, please try again', alert: 'alert-danger' });
        });
      } else {
        this.showMessage({ text: 'Password is required and must be at least 6 characters long', alert: 'alert-danger' });
      }
    }
  }
});

/***/ }),

/***/ "ZbTt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('p',{staticClass:"text-info"},[_vm._v("Dashboard page")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aZuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "ContactUs",
    created: function created() {
        this.fetchCountries();
    },
    data: function data() {
        return {
            userContact: {
                youare: "",
                ineedto: "",
                fullname: "",
                email: "",
                institution: "",
                country: "",
                message: ""
            },
            message: {},
            countries: []
        };
    },

    methods: {
        showMessage: function showMessage(message) {
            this.message = message;
        },
        sendContactUsMsg: function sendContactUsMsg() {
            var _this = this;

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.userContact).some(function (key) {
                return !_this.userContact[key];
            })) {
                this.showMessage({ text: "Please fill in all required fields", alert: "alert-danger" });
                return;
            }
            this.$http.post("contact/contact-us", this.userContact).then(function (response) {
                _this.showMessage({ text: "Your message has been successfully sent", alert: "alert-success" });
                _this.userContact = { youare: "", ineedto: "", fullname: "", email: "", institution: "", country: "", message: "" }; // Reset form
            }).catch(function (err) {
                console.error(err);
                _this.showMessage({ text: "Sorry, your message was not sent. Please try again later.", alert: "alert-danger" });
            });
        },
        fetchCountries: function fetchCountries() {
            var _this2 = this;

            fetch("https://restcountries.com/v3.1/all").then(function (response) {
                return response.json();
            }).then(function (data) {
                _this2.countries = data.map(function (country) {
                    return { name: country.name.common, value: country.cca2 }; // cca2 is the country code
                }).sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            }).catch(function (error) {
                return console.error("Error fetching countries:", error);
            });
        }
    }
});

/***/ }),

/***/ "ajOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterSubscribe_vue__ = __webpack_require__("1Vsk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_843df9cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterSubscribe_vue__ = __webpack_require__("9RSy");
function injectStyle (ssrContext) {
  __webpack_require__("FXTt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-843df9cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterSubscribe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_843df9cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterSubscribe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aptH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "atJ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b5BU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"gallery-item archFx product-link",attrs:{"to":{ name: 'Product', params: { slug: _vm.product.slug } }}},[_c('div',{staticClass:"archFx item-content"},[_c('div',{staticClass:"appCover custom archFx",style:(_vm.backgroundStyle)})]),_vm._v(" "),_c('div',{staticClass:"archFx item-header card-container"},[_c('h3',{staticClass:"archTitle"},[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('div',{staticClass:"tag card-container"},[_vm._l((_vm.filteredCategories),function(category){return _c('span',{key:category,staticClass:"tag-item"},[_c('div',{staticClass:"fas fa-circle custom"},[_vm._v("\n          "+_vm._s(category)+"\n        ")])])}),_vm._v(" "),(_vm.product.annotated=='yes')?_c('span',{staticClass:"tag-item"},[_c('div',{staticClass:"fas fa-circle custom"},[_vm._v("Annotated ")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"gallery-container solutions archTeaser"},[_c('p',{staticClass:"text-justify word-wrap no-h1-h2-h3 product-overview",domProps:{"innerHTML":_vm._s(_vm.product.overview.length > 50
    ? _vm.product.overview.slice(0, 100) + '...'
    : _vm.product.overview
  )}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bLnG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProductDeveloper_vue__ = __webpack_require__("E67x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9ceb61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProductDeveloper_vue__ = __webpack_require__("E9BO");
function injectStyle (ssrContext) {
  __webpack_require__("r1sl")
  __webpack_require__("jSB3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f9ceb61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProductDeveloper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9ceb61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProductDeveloper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bw+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c57S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cH25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppCard__ = __webpack_require__("/B7D");
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { 'app-card': __WEBPACK_IMPORTED_MODULE_0__components_AppCard__["a" /* default */] },
  name: 'AppList',
  props: ['products']
});

/***/ }),

/***/ "cO4W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('h3',{staticClass:"mb-2"},[_vm._v("Change Password")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.message.text)?_c('div',{staticClass:"alert",class:_vm.message.alert,attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.message.text)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"password-input"}},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.$v.password.$error},attrs:{"type":"password","id":"password-input"},domProps:{"value":(_vm.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},function($event){_vm.$v.password.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.password.$error)?_c('div',{class:{'invalid-feedback': !_vm.$v.password.minLength}},[_vm._v("Password min length is 6")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"confirm-password-input"}},[_vm._v("Confirm password")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.confirmPassword),expression:"confirmPassword",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.$v.confirmPassword.$error},attrs:{"type":"password","id":"confirm-password-input"},domProps:{"value":(_vm.confirmPassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value.trim()},function($event){_vm.$v.confirmPassword.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.confirmPassword.$error)?_c('div',{class:{'invalid-feedback': !_vm.$v.confirmPassword.sameAsPassword}},[_vm._v("Passwords must be identical.")]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group text-center"},[_c('button',{staticClass:"btn btn-primary get-started rounded-pill fix-b",attrs:{"type":"submit"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.save()}}},[_vm._v("Change password")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-white rounded-pill",attrs:{"role":"button","type":"cancel","to":{ name: 'Profile'}}},[_vm._v("Cancel")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cSzW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "csuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.success),expression:"message.success"}],staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.message.success)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.error),expression:"message.error"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.message.error)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.success),expression:"message.success"}],staticClass:"text-center mt-2"},[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":{ name: 'Login'}}},[_vm._v("Go to Login")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d5Qi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"bg-light"},[_c('footer-build-your-app')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-bg section-container",attrs:{"id":"about-us-cover"}},[_c('div',{staticClass:"cover-bg"},[_c('img',{attrs:{"src":"/beta/static/img/apps-dev/cover-3.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-us text-center"},[_c('h1',[_vm._v("womia for apps developer")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-container bg-white",attrs:{"id":"about-us-content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-us-content"},[_c('h2',{staticClass:"title text-center"},[_vm._v("What womia provides to the Apps Developer ?")]),_vm._v(" "),_c('p',{staticClass:"desc text-center"},[_vm._v("\n          Dedicated APIs and web services for building, evaluating and monetizing Apps "),_c('br'),_vm._v(" order to target the right\n          customers.\n\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-institution"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Monetize Apps from your home office")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Make money on the Apps you have developed and follow-up their success using our APIs.\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-dot-circle-o"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Personalized Channel of distribution")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Show up your Apps and connect to targeted customers in one place.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-bar-chart"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Skip the marketing"),_c('br'),_vm._v("process")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Focus on developping Apps and let us take care of the hassle of commercializing and\n                  marketing your research.")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-code"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Build your Apps")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Turn your medical imaging algorithms to a reliable, accurate and rapid Apps using womia\n                  APIs.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-share-alt"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Workflow integration")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Connect your App to well known third-party viewers /Pacs (Osirix & Horos) using womia\n                  APIs.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"icon text-success"},[_c('i',{staticClass:"fa fa-check-square-o"})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title"},[_vm._v("Evaluate your Apps")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Connect to independent experts who assist you in the evaluation of your Apps without\n                  exposing intellectual property.")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dMBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__("FRJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a33a8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__("rfFN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a33a8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "deIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__ = __webpack_require__("p9wl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2c8e30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__ = __webpack_require__("mTLL");
function injectStyle (ssrContext) {
  __webpack_require__("1h55")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2c8e30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dgq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListProductDeveloper_vue__ = __webpack_require__("noEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118d3b80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListProductDeveloper_vue__ = __webpack_require__("w7tA");
function injectStyle (ssrContext) {
  __webpack_require__("ln2N")
  __webpack_require__("Ju25")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-118d3b80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListProductDeveloper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118d3b80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListProductDeveloper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "du15":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dv7q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eBe0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConfirmEmail',
  data: function data() {
    return {
      message: {
        success: false,
        error: false
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$http.post('user/me/activate-account', { hash: 'nothing' }, { params: { authToken: this.$route.query.confirmToken } }).then(function (response) {
      _this.showSuccessMessage('You account is activated successfully!');
    }, function (err) {
      _this.showErrorMessage('Someting is wrong with this activation!');
      console.log(err);
    });
  },

  methods: {
    hideErrorMessage: function hideErrorMessage() {
      this.message.error = false;
    },
    showErrorMessage: function showErrorMessage(message) {
      this.message.error = message;
    },
    showSuccessMessage: function showSuccessMessage(message) {
      this.message.success = message;
    }
  }
});

/***/ }),

/***/ "enFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Rating__ = __webpack_require__("TaMM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RatingStats__ = __webpack_require__("8ZpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Review__ = __webpack_require__("jKoA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gallery__ = __webpack_require__("I4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Product",
    data: function data() {
        return {
            product: null
        };
    },

    components: {
        gallery: __WEBPACK_IMPORTED_MODULE_4_vue_gallery___default.a,
        rating: __WEBPACK_IMPORTED_MODULE_1__components_Rating__["a" /* default */],
        review: __WEBPACK_IMPORTED_MODULE_3__components_Review__["a" /* default */],
        "rating-stats": __WEBPACK_IMPORTED_MODULE_2__components_RatingStats__["a" /* default */]
    },

    created: function created() {
        this.fetchData();
    },
    watch: {
        product: function product(val) {
            if (this.isAuthenticated) {
                this.checkPurchase();
            }
        }
    },
    mounted: function mounted() {
        this.fetchNames();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            var productUri = "product/public/";
            this.$http.get("" + productUri + this.$route.params.slug, {
                params: { populate: "author" }
            }).then(function (response) {
                _this.product = response.body;
                _this.product.reviews = _this.product.reviews || [];
            }, function (response) {
                // error callback
                console.log(response);
            });
        }
    }
});

/***/ }),

/***/ "f246":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"https://womia.io/"}},[_vm._v("womia.io")]),_vm._v(" © 2023")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f3NK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Sidebar",
  props: ["annotatedFilter"],
  data: function data() {
    return {
      categories: [],
      visibleSections: {
        modality: false,
        organ: false,
        pathology: false
      },
      filterSections: {
        modality: "Modality",
        organ: "Organ",
        pathology: "Pathology"
      }
    };
  },

  computed: {
    modalities: function modalities() {
      return ["MRI", "Xray", "CT", "EEG", "ECG"];
    },
    organs: function organs() {
      return ["lung", "heart", "arteries", "trachea"];
    },
    pathologies: function pathologies() {
      return ["pulmonary disease", "arterial disease", "heart disease"];
    }
  },
  methods: {
    toggleSection: function toggleSection(section) {
      this.$set(this.visibleSections, section, !this.visibleSections[section]);
    },
    isSectionVisible: function isSectionVisible(section) {
      return this.visibleSections[section];
    },
    getItems: function getItems(section) {
      switch (section) {
        case "modality":
          return this.modalities;
        case "organ":
          return this.organs;
        case "pathology":
          return this.pathologies;
        default:
          return [];
      }
    },
    buildConditions: function buildConditions() {
      var conditions = {};

      if (this.categories.length > 0) {
        conditions.categories = {
          $in: this.categories.map(function (it) {
            return it.toLowerCase();
          })
        };
      }

      if (this.annotatedFilter && this.annotatedFilter.annotated !== "all") {
        conditions.annotated = this.annotatedFilter.annotated;
      }

      this.$emit("conditionsChange", conditions);
    }
  },
  watch: {
    categories: 'buildConditions'
  }
});

/***/ }),

/***/ "f65y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardReviewAdmin_vue__ = __webpack_require__("uiif");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da1209dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardReviewAdmin_vue__ = __webpack_require__("OiSg");
function injectStyle (ssrContext) {
  __webpack_require__("jZX9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardReviewAdmin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da1209dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardReviewAdmin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fDWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmEmail_vue__ = __webpack_require__("eBe0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e59ae83e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmEmail_vue__ = __webpack_require__("csuJ");
function injectStyle (ssrContext) {
  __webpack_require__("W54i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e59ae83e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fFXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCustomer_vue__ = __webpack_require__("SoFS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7533a5f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCustomer_vue__ = __webpack_require__("hhSy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7533a5f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fHl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__("0QUG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a815d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__("K5ke");
function injectStyle (ssrContext) {
  __webpack_require__("jV4T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a815d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fLTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("iRjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b79f17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("85L4");
function injectStyle (ssrContext) {
  __webpack_require__("2kSP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b79f17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fk+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__ = __webpack_require__("7FLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a446d36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__ = __webpack_require__("jNKN");
function injectStyle (ssrContext) {
  __webpack_require__("9o0M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a446d36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g3/+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gS5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf86efa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tech_vue__ = __webpack_require__("Iu79");
function injectStyle (ssrContext) {
  __webpack_require__("OANO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cf86efa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf86efa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "go7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-2"},[_vm._v("My requests")]),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.purchases || _vm.purchases.length === 0)?_c('span',[_vm._v("No request")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[(_vm.purchases.length > 0)?_c('table',{staticClass:"table table-striped m-b-0"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.purchases),function(purchase,index){return _c('tr',{key:purchase._id},[_c('td',[_c('router-link',{attrs:{"to":{ name: 'Product', params: { slug: purchase.product.slug }}}},[_vm._v(_vm._s(purchase.product.name))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(purchase.created,'YYYY-MM-DD')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((purchase.price === 0) ? 'Free' : purchase.price))]),_vm._v(" "),_c('td',{staticClass:"with-btn",attrs:{"nowrap":""}},[_c('router-link',{staticClass:"btn btn-sm btn-primary get-started rounded-pill",attrs:{"to":{ name: 'EditReviewProfile', params: { id: purchase._id }}}},[_vm._v("review")])],1)])}))]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Data catalog")]),_vm._v(" "),_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Price")]),_vm._v(" "),_c('th',{attrs:{"width":"1%"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8St":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FooterBrand",
  data: function data() {
    return {
      email: null,
      message: {}
    };
  },

  methods: {
    showMessage: function showMessage(message) {
      this.message = message;
    },
    subscribe: function subscribe() {
      var _this = this;

      this.message = {};
      this.$http.post("subscription/subscribe", { email: this.email }).then(function (response) {
        _this.showMessage({
          text: "Thank you for subscribing!",
          alert: "alert-success"
        });
        _this.email = null;
      }, function (err) {
        // error callback
        if (err.body && err.body.message === "subscription.email.alreadysubscribed") {
          _this.showMessage({
            text: "Sorry, this email is already subscribed",
            alert: "alert-danger"
          });
        } else {
          _this.showMessage({
            text: "Sorry, your email is not valid",
            alert: "alert-danger"
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "h9+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hAsA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Rating',
  props: { rate: { type: Number, default: 5 } },
  data: function data() {
    return {
      fullStars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.rate),
      emptyStars: 5 - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.rate),
      hasHalfStar: this.rate % 1 >= 0.5
    };
  }
});

/***/ }),

/***/ "hCa+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__("RLqD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb32f2ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__("qFXp");
function injectStyle (ssrContext) {
  __webpack_require__("ukiU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb32f2ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hV0F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("Av2a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_389212bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("t9IL");
function injectStyle (ssrContext) {
  __webpack_require__("8922")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_389212bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hcUC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hhSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('p',{staticClass:"text-info"},[_vm._v("Edit customer page ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hmwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditApp_vue__ = __webpack_require__("mtvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc35b3a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditApp_vue__ = __webpack_require__("DMRL");
function injectStyle (ssrContext) {
  __webpack_require__("4k3W")
  __webpack_require__("7hBx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc35b3a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc35b3a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i3MX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dialog__ = __webpack_require__("deIM");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'welcome',
  components: { acceptTermsDlg: __WEBPACK_IMPORTED_MODULE_2__components_Dialog__["a" /* default */] },
  data: function data() {
    return {
      acceptTerms: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(['isAuthenticated', 'currentUser'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapActions(['acceptTermsConditions', 'logout']), {
    logoutAndGotoLogin: function logoutAndGotoLogin() {
      this.logout();
      this.$router.push({ path: '/auth' });
    }
  })
});

/***/ }),

/***/ "iRIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppList_vue__ = __webpack_require__("cH25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d36cc03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppList_vue__ = __webpack_require__("QoCd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d36cc03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iRjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResetPassword',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  validations: {
    password: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(6)
    },
    confirmPassword: {
      sameAsPassword: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password')
    }
  },
  data: function data() {
    return {
      password: null,
      confirmPassword: null,
      message: {
        error: null,
        success: null
      },
      authToken: this.$route.query.authToken
    };
  },


  methods: {
    hideErrorMessage: function hideErrorMessage() {
      this.message.error = null;
    },
    showErrorMessage: function showErrorMessage(message) {
      this.message.error = message;
    },
    showSuccessMessage: function showSuccessMessage(message) {
      this.message.success = message;
    },

    save: function save() {
      var _this = this;

      if (!this.$v.confirmPassword.$invalid && !this.$v.password.$invalid) {
        this.$http.post('user/me/reset-password', { password: this.password }, { params: { authToken: this.authToken } }).then(function () {
          _this.showSuccessMessage('Your password has been successfully changed, now you can login with the new password.');
        }, function (err) {
          // error callback
          console.log(err);
        });
      } else {
        console.error('Form is not valid, check before submit');
      }
    }
  }
});

/***/ }),

/***/ "ifR8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileLayout_vue__ = __webpack_require__("xHka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2789b32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileLayout_vue__ = __webpack_require__("ya0B");
function injectStyle (ssrContext) {
  __webpack_require__("1ui3")
  __webpack_require__("HfpE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e2789b32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2789b32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "inBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactUsDev',
  data: function data() {
    return {
      userContact: {},
      message: {}
    };
  },

  methods: {
    showMessage: function showMessage(message) {
      this.message = message;
    },
    sendContactUsMsg: function sendContactUsMsg() {
      var _this = this;

      this.$http.post('contact/contact-us', this.userContact).then(function (response) {
        _this.showMessage({ text: 'Your message has been successfully sent', alert: 'alert-success' });
        _this.userContact = {};
      }, function (err) {
        // error callback
        console.log(err);
        _this.showMessage({ text: 'Sorry, your message was not sent. Please fill in all required fields and try again', alert: 'alert-danger' });
      });
    }
  }
});

/***/ }),

/***/ "jHf7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section section-min-blue "},[_c('div',{staticClass:"section-container-for-title logoforapps row d-flex justify-content-center"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:" row d-flex justify-content-center"},[_c('search',{on:{"searchText":_vm.searchText}})],1)])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"section bg-light"},[_c('div',{staticClass:" container"},[_c('div',{staticClass:"button-location"},[_c('button',{staticClass:"custom-button",class:{ 'active': _vm.currentFilter === 'all' },on:{"click":function($event){_vm.applyFilter('all')}}},[_vm._v("All")]),_vm._v(" "),_c('button',{staticClass:"custom-button",class:{ 'active': _vm.currentFilter === 'annotated' },on:{"click":function($event){_vm.applyFilter('annotated')}}},[_vm._v("Annotated")])]),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('sidebar',{attrs:{"annotatedFilter":_vm.currentAnnotatedFilter},on:{"conditionsChange":_vm.categoryFilter}}),_vm._v(" "),_c('div',{staticClass:"archFx solutions gallery-container row p-0 m-0",attrs:{"id":"gallery"}},[_c('app-list',{attrs:{"products":_vm.searchProducts}})],1)],1)])]),_vm._v(" "),_c('footer-build-your-app')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-6 text-center text-white d-flex justify-content-center"},[_c('b',[_vm._v("Data Collection")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jKoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Review_vue__ = __webpack_require__("VYwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53cde730_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Review_vue__ = __webpack_require__("6hd7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Review_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53cde730_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Review_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jNKN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-container"}},[_c('div',{staticClass:"login login-with-news-feed"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"right-content"},[_c('div',{staticClass:"login-header"},[_c('div',{staticClass:"brand"},[_c('router-link',{attrs:{"to":{ name: 'Home'}}},[_c('img',{staticStyle:{"position":"relative","top":"-4px","width":"40px","height":"40px"},attrs:{"src":"/beta/static/logo.svg"}}),_vm._v(" "),_c('b',{staticClass:"text-womia"},[_vm._v("womia")]),_vm._v(".box\n          ")]),_vm._v(" "),_c('small',[_vm._v("Medical Catalogs Sharing Platform")])],1)]),_vm._v(" "),_c('div',{staticClass:"login-content"},[_c('router-view'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"text-center text-grey-darker text-inverse"},[_vm._v("\n          ©2024 womia.io. All Right Reserved\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-feed"},[_c('div',{staticClass:"news-image",staticStyle:{"background-image":"url(/beta/static/img/login-bg/Womia_Box_multiple-box-orange.jpg)"}}),_vm._v(" "),_c('div',{staticClass:"news-caption"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jSB3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jV4T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jZX9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jqmd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kG5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Rating__ = __webpack_require__("TaMM");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AppCard",
  props: ["product"],
  components: { rating: __WEBPACK_IMPORTED_MODULE_2__components_Rating__["a" /* default */] },
  computed: {
    backgroundStyle: function backgroundStyle() {
      var imageUrl = this.$options.filters.media(this.product.logo.slug, {
        width: 700,
        crop: "box"
      });
      return {
        backgroundImage: "url('" + imageUrl + "')"
      };
    },
    filteredCategories: function filteredCategories() {
      var modalities = ['mri', 'xray', 'ct', 'eeg', 'ecg'];
      var organs = ['lung', 'heart', 'liver', 'arteries', 'trachea', 'spine', 'pancreas', 'spleen', 'kidneys', 'intestines', 'bone', 'breast', 'teeth'];
      var pathologies = ['healthy', 'covid', 'nodule', 'masse', 'fibrosis', 'emphysma', 'pulmonary interstitial disease', 'dilated heart', 'thormbus', 'atheroma', 'dissection', 'aneurysm', 'pulmonary disease', 'arterial disease', 'heart disease'];

      var allCategories = this.product.categories;
      var selectedCategories = {
        modalities: null,
        organs: null,
        bodyRegions: null,
        pathologies: []
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(allCategories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var category = _step.value;

          if (modalities.includes(category) && !selectedCategories.modalities) {
            selectedCategories.modalities = category;
          } else if (organs.includes(category) && !selectedCategories.organs) {
            selectedCategories.organs = category;
          } else if (pathologies.includes(category)) {
            selectedCategories.pathologies.push(category);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (selectedCategories.pathologies.length > 3) {
        selectedCategories.pathologies = selectedCategories.pathologies.slice(0, 3);
      }

      return [selectedCategories.modalities, selectedCategories.organs, selectedCategories.bodyRegions].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(selectedCategories.pathologies)).filter(Boolean);
    }
  }
});

/***/ }),

/***/ "kQz6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kTk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Install',
  data: function data() {
    return {
      purchase: null,
      baseUrl: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.options.root
    };
  },

  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(['authToken'])),
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.$http.get('purchase/' + this.$route.params.id, {
        params: { populate: 'product' }
      }).then(function (response) {
        _this.purchase = response.data;
      }, function (error) {
        // error callback
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "kput":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kxzv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lMIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"section-container p-t-20",attrs:{"id":"product"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-space-30"},[_c('div',{staticClass:"col-md-8"},[_c('h4',{staticClass:"m-t-0"},[_vm._v("Build Your Own App")]),_vm._v(" "),_c('p',{staticClass:"m-b-30 f-s-13"},[_vm._v("\n            Contact us to learn how you can take advantage of being a womia partner, and to turn your idea or algorithm into medical imaging App using womia APIs .\n          ")]),_vm._v(" "),(_vm.message.text)?_c('div',{staticClass:"alert text-center",class:_vm.message.alert,attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.message.text)+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.name),expression:"userContact.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.userContact.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userContact, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.email),expression:"userContact.email"}],staticClass:"form-control",attrs:{"type":"text","name":"email"},domProps:{"value":(_vm.userContact.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userContact, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.subject),expression:"userContact.subject"}],staticClass:"form-control",attrs:{"type":"text","name":"subject"},domProps:{"value":(_vm.userContact.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userContact, "subject", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.userContact.message),expression:"userContact.message"}],staticClass:"form-control",attrs:{"rows":"10","name":"message"},domProps:{"value":(_vm.userContact.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userContact, "message", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('button',{staticClass:"btn btn-inverse btn-lg",on:{"click":function($event){_vm.sendContactUsMsg()}}},[_vm._v("Send Message")])])])])]),_vm._v(" "),_vm._m(5,false,false)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-container page-header-container bg-black",attrs:{"id":"page-header"}},[_c('div',{staticClass:"page-header-cover"},[_c('img',{attrs:{"src":"/beta/static/img/contact-bg/contact-dev.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-header"},[_c('b',[_vm._v("Let's be partner")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label col-md-3"},[_vm._v("Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label col-md-3"},[_vm._v("Email "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label col-md-3"},[_vm._v("Subject "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label col-md-3"},[_vm._v("Message "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4"},[_c('div',[_c('b',[_vm._v("Email")])]),_vm._v(" "),_c('p',{staticClass:"m-b-15"},[_c('a',{staticClass:"text-inverse",attrs:{"href":"mailto:hello@womia.io"}},[_vm._v("hello@womia.io")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"text-inverse",attrs:{"href":"mailto:support@womia.io"}},[_vm._v("support@womia.io")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"m-b-5"},[_c('b',[_vm._v("Social Network")])]),_vm._v(" "),_c('p',{staticClass:"m-b-15"},[_c('a',{staticClass:"btn btn-icon btn-white btn-circle",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-facebook"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-icon btn-white btn-circle",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-twitter"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-icon btn-white btn-circle",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-linkedin"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lTTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-container"}},[_c('nav-bar'),_vm._v(" "),_c('accept-terms'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('footer-brand')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lYGf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lZ5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("f3NK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11aa7904_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("1pnX");
function injectStyle (ssrContext) {
  __webpack_require__("5X3c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11aa7904"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11aa7904_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13423c95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("oTaJ");
function injectStyle (ssrContext) {
  __webpack_require__("0qad")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13423c95"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13423c95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ln2N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m4u7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeveloperLayout'
});

/***/ }),

/***/ "mGy3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[(_vm.user.picture)?_c('img',{attrs:{"src":_vm._f("media")(_vm.user.picture.slug,{width: '150'}),"alt":_vm.user.nickname}}):_vm._e(),_vm._v(" "),(!_vm.user.picture)?_c('img',{attrs:{"src":"/beta/static/default-user-128.png","alt":_vm.user.nickname,"width":"150","height":"150"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"media-body"})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',{staticClass:"nav nav-list"},[_c('li',[_c('a',[_c('b',[_vm._v("Username:")]),_vm._v(" "+_vm._s(_vm.user.nickname))])]),_vm._v(" "),_c('li',[_c('a',[_c('b',[_vm._v("First Name:")]),_vm._v(" "+_vm._s(_vm.user.firstName))])]),_vm._v(" "),_c('li',[_c('a',[_c('b',[_vm._v("Last Name:")]),_vm._v(" "+_vm._s(_vm.user.lastName))])]),_vm._v(" "),_c('li',[_c('a',[_c('b',[_vm._v("Email:")]),_vm._v(" "+_vm._s(_vm.user.email))])]),_vm._v(" "),_c('li',[_c('a',[_c('b',[_vm._v("Mobile:")]),_vm._v(" "+_vm._s(_vm.user.phone))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',{staticClass:"nav nav-list"},[_c('li',[_c('a',[_c('b',[_vm._v("Company:")]),_vm._v(" "+_vm._s(_vm.user.company))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.user.website,"target":"_blank"}},[_c('b',[_vm._v("Website:")]),_vm._v(" "+_vm._s(_vm.user.website))])]),_vm._v(" "),_c('li',[_c('a',[_c('b',[_vm._v("Country:")]),_vm._v(" "+_vm._s(_vm.user.country))])]),_vm._v(" "),_c('li',[_c('a',[_c('b',[_vm._v("City:")]),_vm._v(" "+_vm._s(_vm.user.city))])]),_vm._v(" "),_c('li',[_c('a',[_c('b',[_vm._v("ZIP Code:")]),_vm._v(" "+_vm._s(_vm.user.zipCode))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',{staticClass:"nav nav-list"},[(_vm.user.professionalActivities && _vm.user.professionalActivities.length)?_c('li',[_c('a',[_c('b',[_vm._v("Professional Activities:")]),_vm._v(" "),_vm._l((_vm.user.professionalActivities),function(pa,idx){return _c('span',{key:idx,staticClass:"text-capitalize"},[_vm._v(_vm._s(pa)+_vm._s((idx < _vm.user.professionalActivities.length - 1) ? ' / ' : ''))])})],2)]):_vm._e(),_vm._v(" "),(_vm.user.clinicalAreas && _vm.user.clinicalAreas.length)?_c('li',[_c('a',[_c('b',[_vm._v("Clinical Area:")]),_vm._v(" "),_vm._l((_vm.user.clinicalAreas),function(ca,idx){return _c('span',{key:idx,staticClass:"text-capitalize"},[_vm._v(_vm._s(ca)+_vm._s((idx < _vm.user.clinicalAreas.length - 1) ? ' / ' : ''))])})],2)]):_vm._e(),_vm._v(" "),(_vm.user.modalities && _vm.user.modalities.length)?_c('li',[_c('a',[_c('b',[_vm._v("Modality:")]),_vm._v(" "),_vm._l((_vm.user.modalities),function(mod,idx){return _c('span',{key:idx,staticClass:"text-capitalize"},[_vm._v(_vm._s(mod)+_vm._s((idx < _vm.user.modalities.length - 1) ? ' / ' : ''))])})],2)]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mIRV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeveloperLayout_vue__ = __webpack_require__("m4u7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adcb29b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeveloperLayout_vue__ = __webpack_require__("Q0bI");
function injectStyle (ssrContext) {
  __webpack_require__("NphM")
  __webpack_require__("FEoV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-adcb29b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeveloperLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adcb29b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeveloperLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mNxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wizard',
  props: {
    steps: {},
    onNext: {},
    onBack: {},
    onSave: {},
    onSubmit: {},
    modeWizard: {}
  },
  data: function data() {
    return {
      currentStep: 0
    };
  },

  computed: {
    currentSlot: function currentSlot() {
      return this.steps[this.currentStep].slot;
    },
    backEnabled: function backEnabled() {
      return this.currentStep !== 0;
    },
    isFinalStep: function isFinalStep() {
      return this.currentStep === this.steps.length - 1;
    }
  },
  methods: {
    goNext: function goNext(skipFunction) {
      if (!skipFunction && typeof this.onNext === 'function') {
        if (!this.onNext(this.currentStep)) {
          return;
        }
      }
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep++;
      }
    },
    goBack: function goBack(skipFunction) {
      if (!skipFunction && typeof this.onBack === 'function') {
        if (!this.onBack(this.currentStep)) {
          return;
        }
      }
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    goPage: function goPage(pageIndex) {
      if (this.modeWizard !== 'tab') return;
      if (pageIndex !== this.currentStep) {
        this.currentStep = pageIndex;
      }
    },
    doSave: function doSave(skipFunction) {
      if (!skipFunction && typeof this.onSave === 'function') {
        if (!this.onSave(this.currentStep)) {
          return false;
        }
        return true;
      }
    },
    doSubmit: function doSubmit(skipFunction) {
      if (!skipFunction && typeof this.onSubmit === 'function') {
        if (!this.onSubmit(this.currentStep)) {
          return false;
        }
        return true;
      }
    }
  }
});

/***/ }),

/***/ "mTLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",style:(_vm.styleMask)},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",style:(_vm.styleContent)},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_vm._v("default header")])],2),_vm._v(" "),_c('div',{staticClass:"modal-body",style:(_vm.styleBody)},[_vm._t("body",[_vm._v("default body")])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_vm._v("\n            default footer\n            "),_c('button',{staticClass:"modal-default-button",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("OK")])])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mtvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Wizard__ = __webpack_require__("D1Wx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dialog__ = __webpack_require__("deIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__("+qPk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProductAdmin',
  components: { 'vue-editor': __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["a" /* VueEditor */], 'wizard': __WEBPACK_IMPORTED_MODULE_1__components_Wizard__["a" /* default */], 'modal': __WEBPACK_IMPORTED_MODULE_2__components_Dialog__["a" /* default */] },
  computed: {
    displaySize: function displaySize() {
      var sizeBin = this.product.slotGeneral.technicalDetails.size;
      var divid = sizeBin > 1000 * 1000 ? { nb: 1000 * 1000, unit: ' MB' } : { nb: 1000, unit: ' KB' };
      return Math.round(this.product.slotGeneral.technicalDetails.size / divid.nb * Math.pow(10, 1)) / Math.pow(10, 1) + divid.unit;
    }
  },
  data: function data() {
    return {
      message: null,
      showModal: false,
      modeWizard: 'tab',
      steps: [{
        label: 'Details',
        slot: 'page-details'
      }, {
        label: 'Digital content',
        slot: 'page-digit-content'
      }, {
        label: 'Images',
        slot: 'page-images'
      }, {
        label: 'Notifications',
        slot: 'page-notifications'
      }],
      publication: {},
      product: {
        slotGeneral: {
          technicalDetails: {}
        },
        slotImages: {
          logo: {}
        },
        slotDetails: {
          video: {}
        },
        slotPublications: {}
      },

      modalities: ["mri", "xray", "ct", "eeg", "ecg"],
      organs: ["lung", "heart", "liver", "arteries", "trachea", "spine", "pancreas", "spleen", "kidneys", "intestines", "bone", "breast", "teeth", "other"],
      bodyRegions: ["chest", "abdominal", "pelvic", "head", "cervical", "whole body", "chest abdominal", "chest abdominal pelvic", "cervical chest abdominal pelvic", "chest abdominal pelvic head"],
      pathologies: ["healthy", "covid", "nodule", "masse", "fibrosis", "emphysma", "pulmonary interstitial disease", "dilated heart", "thormbus", "atheroma", "dissection", "aneurysm", "pulmonary disease", "arterial disease", "heart disease"],
      orientation: ["axial", "coronal", "sagittal", "short-axis", "long-axis-2-cavities", "long-axis-3-cavities", "long-axis-4-cavities", "multiplanar", "multiplanar-radial", "multiplanar-short-axis"],
      types: ["2D", "2D+T", "2D+t", "3D", "3D+T", "3D+t", "none"],
      age: ["20-30", "30-40", "40-50", "50-60", "60-70", "70-80"],
      protocolMri: ["flow-2D", "flow-3D", "cine SSFP", "cardiac-function", "anatomy", "perfusion", "enhancement", "tagging", "angiography", "t1-mapping", "t2-mapping", "t2* mapping", "dixon"],
      protocolCT: ["chest-", "abdominal-", "pelvic-", "cerebral", "cervical-", "whole-body", "chest-abdominal", "chest-abdominal-pelvic", "cervical-chest-abdominal-pelvic", "chest-abdominal-pelvic-cerebral", "abdominal-pelvic", "cervical spine", "Aortic-Angiography", "thoracic-angiography", "supra-aortic-trunks-angiography", "lower-extremity-angiography", "cerebral-angiography", "abdominal-angiography", "thoracic-spine", "lumbar-spine", "coronary"],
      customToolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], [{ indent: '-1' }, { indent: '+1' }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ align: [] }], ['clean']]
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  validations: {
    product: {
      slotGeneral: {},
      slotImages: {},
      slotDetails: {}
    }
  },
  created: function created() {
    if (this.$route.params.slug) {
      this.fetchData();
    }
  },
  methods: {
    hideMessages: function hideMessages() {
      this.message = null;
    },
    showErrorMessage: function showErrorMessage(message) {
      this.message = message;
    },
    fetchData: function fetchData() {
      var _this = this;

      this.$http.get('product/admin/' + this.$route.params.slug).then(function (response) {
        _this.populateProduct(response.data);
      }, function (err) {
        // error callback
        console.log(err);
      });
    },
    populateProduct: function populateProduct(product) {
      /* set general params */
      this.product._id = product._id;
      this.product.slugRef = product.slugRef;
      var viewStatus = {
        'edit': { 'label': 'Editing', 'class': 'badge-warning rouded-pill' },
        'pending': { 'label': 'Waiting for approval', 'class': 'badge-info rouded-pill' },
        'declined': { 'label': 'Declined', 'class': 'badge-danger rouded-pill' },
        'approved': { 'label': 'Approved', 'class': 'badge-success rouded-pill' },
        'closed': { 'label': 'Closed', 'class': 'badge-secondary rouded-pill' }
      };
      this.product.status = viewStatus[product.status];
      this.product.newStatus = product.status;
      this.product.slotGeneral = {
        name: product.name,
        app: product.app,
        technicalDetails: product.technicalDetails || {},
        certifications: product.certifications,
        formats: product.formats,
        externalLinkDist: product.externalLinkDist,
        price: product.price,
        device: product.device,
        gender: product.gender,
        contrastEnhanced: product.contrastEnhanced,
        multiCentric: product.multiCentric,
        multiDevice: product.multiDevice,
        followUp: product.followUp,
        annotated: product.annotated,
        outcomes: product.outcomes
        /* set images params */
      };this.product.slotImages = {
        logo: product.logo,
        screenshots: product.screenshots
        /* set details params */
      };this.product.slotDetails = {
        overview: product.overview,
        categories: product.categories,
        description: product.description,
        country: product.country,
        age: product.age,
        patient: product.patient,
        systemRequirement: product.systemRequirement,
        lastUpdates: product.lastUpdates,
        videos: product.videos || [],
        userGuide: product.userGuide
        /* set publications params */
      };this.product.slotPublications = {
        publications: product.publications || []
      };
    },
    action: function action(promise) {
      var _this2 = this;

      this.hideMessages();

      if (!this.$v.$invalid) {
        promise.then(function (response) {
          var redirectToAppsList = {
            path: '/admin/product'
          };
          _this2.$router.push(redirectToAppsList);
        }, function (err) {
          // error callback
          _this2.showErrorMessage('Sorry but an error occurred when submitting form');
          console.log(err);
        });
      } else {
        this.showErrorMessage('Please make sure all required fields are filled out correctly');
      }
    },
    updateNewStatus: function updateNewStatus() {
      // TODO use popup for confirmation
      this.action(this.$http.post('product/admin/' + this.$route.params.slug, { '_id': this.product._id, 'status': this.product.newStatus, 'slugRef': this.product.slugRef }));
    },
    saveWizard: function saveWizard(currentPage) {
      this.updateNewStatus();
      return true;
    }
  }
});

/***/ }),

/***/ "nZbe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "noEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dialog__ = __webpack_require__("deIM");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListProductDeveloper',
  components: { 'modal': __WEBPACK_IMPORTED_MODULE_3__components_Dialog__["a" /* default */] },
  data: function data() {
    return {
      products: null,
      countApprovedApps: 0,
      countApprovedFreeApps: 0,
      deleteAction: {
        showModal: false,
        product: null
      },
      updateAction: {
        showModal: false,
        product: null
      }
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (products) {
      _this.products = _this.populateProducts(products);
    }, function () {/* error callback */});
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].mapGetters(['currentUser'])),
  methods: {
    fetchData: function fetchData() {
      return this.$http.get('product/dev').then(function (resp) {
        return resp.data;
      });
    },
    populateProducts: function populateProducts(products) {
      var _this2 = this;

      this.countApprovedApps = 0;
      this.countApprovedFreeApps = 0;
      var viewStatus = {
        'edit': { 'label': 'Editing', 'class': 'label-warning' },
        'pending': { 'label': 'Waiting for approval', 'class': 'label-info' },
        'declined': { 'label': 'Declined', 'class': 'label-danger' },
        'approved': { 'label': 'Approved', 'class': 'label-success' },
        'closed': { 'label': 'Closed', 'class': 'label-danger' }
        // TODO: change this groupBy by lodash way
      };products = products.reduce(function (groups, item) {
        var val = item['slugRef'];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
      }, {});
      // Convert Object To Array and sort it by last update
      products = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(products).map(function (key) {
        products[key] = _.orderBy(products[key], 'technicalDetails.update', 'desc');
        return [key, products[key]];
      });
      // Prepare data for each product update set
      // let skipUpdatedApp
      products.forEach(function (productsUpdateSet) {
        // skipUpdatedApp = false
        productsUpdateSet[1].forEach(function (product) {
          // prepare actions based on status
          product.actions = {
            'edit': product.status === 'edit',
            'update': product.status === 'approved',
            'delete': ['edit', 'declined', 'closed'].indexOf(product.status) > -1
            // get price of the app
          };if (!product.price) {
            product.price = 'Free';
            if (product.status === 'approved') _this2.countApprovedFreeApps++;
          }
          // !skipUpdatedApp &&
          if (product.status === 'approved') {
            _this2.countApprovedApps++;
          }
          // skipUpdatedApp = true
          product.status = viewStatus[product.status];
        });
      });
      return products;
    },
    updateProduct: function updateProduct(product) {
      var _this3 = this;

      this.$http.post('product/dev/' + product.slug + '/update-my-app', { _id: product._id }).then(function (response) {
        _this3.fetchData().then(function (products) {
          return _this3.products = _this3.populateProducts(products);
        });
      }, function () {
        // error callback
        console.log('Sorry but an error occurred when submitting form');
      });
    },
    deleteProduct: function deleteProduct(product) {
      var _this4 = this;

      // Hide Modal
      this.deleteAction.showModal = false;
      this.$http.delete('product/dev/' + product.slug, { _id: product._id }).then(function (response) {
        _this4.fetchData().then(function (products) {
          return _this4.products = _this4.populateProducts(products);
        });
      }, function () {
        // error callback
        console.log('Sorry but an error occurred when submitting form');
      });
    }
  }
});

/***/ }),

/***/ "o2wI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppList__ = __webpack_require__("iRIX");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'app-list': __WEBPACK_IMPORTED_MODULE_0__components_AppList__["a" /* default */]
  },
  name: 'ProductsProfile',
  data: function data() {
    return {
      products: []
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (products) {
      return _this.products = products;
    });
  },
  methods: {
    fetchData: function fetchData(params) {
      params = params || {};
      return this.$http.get('purchase').then(function (response) {
        return response.data;
      }, function (response) {
        // error callback
        console.log(response);
      });
    }
  }
});

/***/ }),

/***/ "oAGO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListApp_vue__ = __webpack_require__("F9wz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76ee03e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListApp_vue__ = __webpack_require__("Ej+j");
function injectStyle (ssrContext) {
  __webpack_require__("aptH")
  __webpack_require__("tfKY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76ee03e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76ee03e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oNML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewProfile_vue__ = __webpack_require__("IK9l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5c1cc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewProfile_vue__ = __webpack_require__("mGy3");
function injectStyle (ssrContext) {
  __webpack_require__("Ry68")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d5c1cc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5c1cc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oTaJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header header-default"},[_c('div',{staticClass:"container d-flex"},[_c('div',{staticClass:"header-logo"},[_c('a',{staticClass:"logo-link header-nav-link ",attrs:{"href":"/beta"}},[_c('img',{staticStyle:{"width":"45px","margin-right":"5px"},attrs:{"src":"/beta/static/logo.svg"}}),(_vm.isAuthenticated)?_c('b',{staticClass:"text-womia"},[_vm._v("Womia Box ")]):_vm._e(),(!_vm.isAuthenticated)?_c('b',{staticClass:"text-womia not-authenticated"},[_vm._v("Womia Box ")]):_vm._e(),_c('small',[_vm._v("By WOMIA")])])]),_vm._v(" "),_c('div',{staticClass:"header-nav nav"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"nav pull-right"},[(!_vm.isAuthenticated)?_c('li',[_vm._m(0,false,false)]):_vm._e(),_vm._v(" "),(!_vm.isAuthenticated)?_c('li',{staticClass:"separator",staticStyle:{"border-left":"1px solid #dbdbdb","margin":"5px 0"}}):_vm._e(),_vm._v(" "),(!_vm.isAuthenticated)?_c('li',[_c('div',{staticClass:"header-nav-item"},[_c('router-link',{staticClass:"header-nav-link",attrs:{"to":{ name: 'Login' }}},[_vm._v("Login")])],1)]):_vm._e(),_vm._v(" "),(_vm.isAuthenticated && !_vm.hasRole(['admin']))?_c('li',[_c('div',{staticClass:"header-nav-item"},[_c('a',{staticClass:" header-nav-link dropdown-toggle mr-md-2",attrs:{"href":"#","id":"bd-versions","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[(!_vm.currentUser.picture)?_c('img',{staticClass:"user-img",attrs:{"src":"/beta/static/default-user-128.png","width":"128","height":"128","alt":""}}):_vm._e(),_vm._v(" "),(_vm.currentUser.picture)?_c('img',{staticClass:"user-img",attrs:{"src":_vm._f("media")(_vm.currentUser.picture.slug,{ width: '128' }),"alt":""}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"hidden-md hidden-sm hidden-xs"},[_vm._v(_vm._s(_vm.currentUser.nickname || _vm.currentUser.email))]),_vm._v(" "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"bd-versions"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{ name: 'Profile' }}},[_vm._v("My Profile")]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{ name: 'Home', query: { search: 'MyApps' } }}},[_vm._v("My Requests")]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{ name: 'DashboardDeveloper' }}},[_vm._v("Data provider")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#logout"},on:{"click":function($event){_vm.logoutGoHome()}}},[_vm._v("Log out")])],1)])]):_vm._e(),_vm._v(" "),(_vm.isAuthenticated && _vm.hasRole(['admin']))?_c('li',[_c('router-link',{staticClass:"btn rounded-pill",staticStyle:{"display":"inline","color":"white"},attrs:{"to":{ path: '/beta/admin/product' }}},[_vm._v("Return to catalog Management")])],1):_vm._e()]),_vm._v(" "),(!_vm.isAuthenticated)?_c('div',[_c('router-link',{staticClass:"btn btn-primary get-started fw-bold rounded-pill",attrs:{"to":{ name: 'Signup' }}},[_vm._v("Create Account")])],1):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-nav-item"},[_c('a',{staticClass:"header-nav-link ",attrs:{"href":"/beta/contact-us"}},[_vm._v("Contact Us")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oZw9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer'
});

/***/ }),

/***/ "olDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'Purchases',
  data: function data() {
    return {
      purchases: []
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (purchases) {
      return _this.purchases = purchases.filter(function (purchase) {
        return purchase.product;
      });
    });
  },
  methods: {
    fetchData: function fetchData() {
      return this.$http.get('purchase', { params: { populate: 'product' } }).then(function (response) {
        return response.data;
      }, function () {});
    }
  }
});

/***/ }),

/***/ "p3FZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-3"},[_c('h3',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('div',[_c('rating',{staticClass:"pull-left m-r-10 ",attrs:{"rate":_vm.product.stats.rate}}),_vm._v(" "),_c('b',[(_vm.product.stats.rate)?_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v(_vm._s(_vm.product.stats.rate)+" out of 5 |")]):_vm._e(),_vm._v(" "+_vm._s(_vm.product.stats.reviews)+"\n            review"+_vm._s(_vm.product.stats.reviews > 1 ? 's' : '')+" | "+_vm._s(_vm.product.stats.users)+" user"+_vm._s(_vm.product.stats.users
            > 1 ?
            's' : ''))])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.product.reviews),function(review,index){return _c('div',{key:index,staticClass:"col-lg-12"},[_c('div',[_c('div',{staticClass:"card-body"},[_c('review',{attrs:{"item":review}})],1)])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p68w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header navbar-default",attrs:{"id":"header"}},[_vm._m(0,false,false),_vm._v(" "),_c('HeaderDropdown')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/beta/admin/dashboard"}},[_c('span',{staticClass:"navbar-logo"}),_vm._v(" "),_c('b',[_vm._v("womia")]),_vm._v(".Box")]),_vm._v(" "),_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-click":"sidebar-toggled"}},[_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p9wl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dialog',
  props: {
    styleContent: {
      default: '',
      type: String
    },
    styleBody: {
      default: '',
      type: String
    },
    styleMask: {
      default: '',
      type: String
    }
  }
});

/***/ }),

/***/ "peAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _ = __webpack_require__("M4fF");
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'dashboard',
  data: function data() {
    return {
      isLoading: true,
      stats: {
        pageViews: 0,
        customers: 0,
        downloads: 0
      },
      products: []
    };
  },

  created: function created() {
    var _this = this;

    this.fetchData().then(function (products) {
      _this.products = products.filter(function (product) {
        return product.status === 'approved';
      });
      _this.calculateStats();
      _this.isLoading = false;
    }, function () {
      _this.isLoading = false;
    });
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(['currentUser'])),
  methods: {
    fetchData: function fetchData() {
      return this.$http.get('product/admin').then(function (resp) {
        return resp.data;
      });
    },
    calculateStats: function calculateStats() {
      this.stats.pageViews = this.products.reduce(function (total, product) {
        return total + product.stats.pageViews;
      }, 0);
      this.stats.customers = this.products.reduce(function (total, product) {
        return total + product.stats.users;
      }, 0);
      this.stats.downloads = this.products.reduce(function (total, product) {
        return total + product.stats.downloads;
      }, 0);
    }
  }
});

/***/ }),

/***/ "pjTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-bottom-0"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.error),expression:"message.error"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.message.error)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.success),expression:"message.success"}],staticClass:"alert alert-success"},[_c('span',{staticClass:"close",attrs:{"data-dismiss":"alert"}},[_vm._v("×")]),_vm._v(" "),_c('strong',[_vm._v("Success!")]),_vm._v("\n    "+_vm._s(_vm.message.success)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"form-group m-b-15"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.$v.email.$error},attrs:{"type":"text","name":"email","id":"email","placeholder":"Enter your Email"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},function($event){_vm.$v.email.$touch()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.ask()}}}),_vm._v(" "),(_vm.$v.email.$error)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("Email is not valid")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"login-buttons"},[_c('button',{staticClass:"btn btn-primary get-started  rounded-pill btn-block",staticStyle:{"width":"100%","padding":"10px 16px","font-size":"18px"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.ask()}}},[_vm._v("Ask")])]),_vm._v(" "),_c('div',{staticClass:"m-t-20 m-b-40 p-b-40 text-inverse"},[_vm._v("\n    Already have an account? Click "),_c('router-link',{staticClass:"text-theme",attrs:{"to":{ name: 'Login'}}},[_vm._v("here")]),_vm._v(" to login.\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pld8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.imgData.src,"width":"150","height":"150"}}),_vm._v(" "),_c('div',{staticClass:"btn-group text-center m-l-40"},[_c('a',{staticClass:"btn btn-primary get-started rounded-pill tores",attrs:{"href":"#"},on:{"click":_vm.toggleShow}},[_vm._v(" Change ")]),_vm._v(" "),(_vm.imgData.hasAvatar)?_c('a',{staticClass:"btn btn-white rounded-pill tores",staticStyle:{"margin-left":"3px"},attrs:{"href":"#"},on:{"click":_vm.deletePicture}},[_vm._v("\n          Delete\n        ")]):_vm._e()])]),_vm._v(" "),_c('avatar-upload',{attrs:{"field":"avatar","width":128,"height":128,"url":_vm.uploadUrl,"lang-type":"en","headers":_vm.headers,"img-format":"png"},on:{"crop-success":_vm.cropSuccess,"crop-upload-success":_vm.cropUploadSuccess,"crop-upload-fail":_vm.cropUploadFail},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"username-input"}},[_vm._v("Username")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.nickname),expression:"user.nickname"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.nickname.$error},attrs:{"type":"text","id":"username-input"},domProps:{"value":(_vm.user.nickname)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "nickname", $event.target.value)},function($event){_vm.$v.user.nickname.$touch()}]}}),_vm._v(" "),(_vm.$v.user.nickname.$error)?_c('div',{class:{'invalid-feedback': _vm.$v.user.nickname.$error}},[_vm._v("This username is not valid, use alphanumeric only and the min length is 5 chars")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"firstname-input"}},[_vm._v("Firstname")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.firstName),expression:"user.firstName"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.firstName.$error},attrs:{"type":"text","id":"firstname-input"},domProps:{"value":(_vm.user.firstName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "firstName", $event.target.value)},function($event){_vm.$v.user.firstName.$touch()}]}}),_vm._v(" "),(_vm.$v.user.firstName.$error)?_c('div',{class:{'invalid-feedback': _vm.$v.user.firstName.$error}},[_vm._v("Firstname is not valid, use alpha only")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"lastname-input"}},[_vm._v("Lastname")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.lastName),expression:"user.lastName"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.lastName.$error},attrs:{"type":"text","id":"lastname-input"},domProps:{"value":(_vm.user.lastName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "lastName", $event.target.value)},function($event){_vm.$v.user.lastName.$touch()}]}}),_vm._v(" "),(_vm.$v.user.lastName.$error)?_c('div',{class:{'invalid-feedback': _vm.$v.user.lastName.$error}},[_vm._v("Lastname is not valid, use alpha only")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"email-input"}},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control",attrs:{"type":"email","id":"email-input","disabled":""},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"phone-input"}},[_vm._v("Mobile")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.phone),expression:"user.phone"}],staticClass:"form-control",attrs:{"type":"tel","id":"phone-input"},domProps:{"value":(_vm.user.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"company-input"}},[_vm._v("Company")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.company),expression:"user.company"}],staticClass:"form-control",attrs:{"type":"text","id":"company-input"},domProps:{"value":(_vm.user.company)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "company", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"website-input"}},[_vm._v("Website")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.website),expression:"user.website"}],staticClass:"form-control",attrs:{"type":"text","id":"website-input"},domProps:{"value":(_vm.user.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "website", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"country-input"}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.country),expression:"user.country"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.country.$error},attrs:{"type":"text","id":"country-input"},domProps:{"value":(_vm.user.country)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "country", $event.target.value)},function($event){_vm.$v.user.country.$touch()}]}}),_vm._v(" "),(_vm.$v.user.country.$error)?_c('div',{class:{'invalid-feedback': _vm.$v.user.country.$error}},[_vm._v("Country is not valid, use alpha only")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"city-input"}},[_vm._v("City")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.city),expression:"user.city"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.city.$error},attrs:{"type":"text","id":"city-input"},domProps:{"value":(_vm.user.city)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "city", $event.target.value)},function($event){_vm.$v.user.city.$touch()}]}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row m-b-15"},[_c('label',{staticClass:"col-lg-3 col-form-label",attrs:{"for":"zipcode-input"}},[_vm._v("ZIP Code")]),_vm._v(" "),_c('div',{staticClass:"col-lg-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.zipCode),expression:"user.zipCode"}],staticClass:"form-control",attrs:{"type":"text","id":"zipcode-input"},domProps:{"value":(_vm.user.zipCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "zipCode", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('b',[_vm._v("Professional Activities")]),_vm._v(" "),_vm._l((_vm.professionalActivities),function(pa){return _c('div',{key:pa,staticClass:"form-check"},[_c('div',{staticClass:"checkbox checkbox-css checkbox-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.professionalActivities),expression:"user.professionalActivities"}],attrs:{"type":"checkbox","id":("cssCheckbox_" + pa)},domProps:{"value":pa,"checked":Array.isArray(_vm.user.professionalActivities)?_vm._i(_vm.user.professionalActivities,pa)>-1:(_vm.user.professionalActivities)},on:{"change":function($event){var $$a=_vm.user.professionalActivities,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=pa,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.user.professionalActivities=$$a.concat([$$v]))}else{$$i>-1&&(_vm.user.professionalActivities=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.user, "professionalActivities", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"text-capitalize",attrs:{"for":("cssCheckbox_" + pa)}},[_vm._v(_vm._s(pa))])])])})],2),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('b',[_vm._v("Clinical Area")]),_vm._v(" "),_vm._l((_vm.clinicalAreas),function(clinicalArea){return _c('div',{key:clinicalArea,staticClass:"form-check"},[_c('div',{staticClass:"checkbox checkbox-css checkbox-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.clinicalAreas),expression:"user.clinicalAreas"}],attrs:{"type":"checkbox","id":("cssCheckbox_" + clinicalArea)},domProps:{"value":clinicalArea,"checked":Array.isArray(_vm.user.clinicalAreas)?_vm._i(_vm.user.clinicalAreas,clinicalArea)>-1:(_vm.user.clinicalAreas)},on:{"change":function($event){var $$a=_vm.user.clinicalAreas,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=clinicalArea,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.user.clinicalAreas=$$a.concat([$$v]))}else{$$i>-1&&(_vm.user.clinicalAreas=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.user, "clinicalAreas", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"text-capitalize",attrs:{"for":("cssCheckbox_" + clinicalArea)}},[_vm._v(_vm._s(clinicalArea))])])])})],2),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('b',[_vm._v("Modality")]),_vm._v(" "),_vm._l((_vm.modalities),function(mod){return _c('div',{key:mod,staticClass:"form-check"},[_c('div',{staticClass:"checkbox checkbox-css checkbox-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.modalities),expression:"user.modalities"}],attrs:{"type":"checkbox","id":("cssCheckbox_" + mod)},domProps:{"value":mod,"checked":Array.isArray(_vm.user.modalities)?_vm._i(_vm.user.modalities,mod)>-1:(_vm.user.modalities)},on:{"change":function($event){var $$a=_vm.user.modalities,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=mod,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.user.modalities=$$a.concat([$$v]))}else{$$i>-1&&(_vm.user.modalities=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.user, "modalities", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"text-capitalize",attrs:{"for":("cssCheckbox_" + mod)}},[_vm._v(_vm._s(mod))])])])})],2)]),_vm._v(" "),_c('hr')],1),_vm._v(" "),_c('div',{staticClass:"form-group m-t-20 text-center col-lg-12"},[_c('button',{staticClass:"btn btn-primary get-started rounded-pill",staticStyle:{"border-radius":"20px"},attrs:{"type":"submit"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.save()}}},[_vm._v("Submit")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-white rounded-pill",staticStyle:{"border-radius":"20px"},attrs:{"role":"button","type":"cancel","to":{ name: 'Profile'}}},[_vm._v("Cancel")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "psjl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("C3za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610726d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("8isX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610726d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pzqv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qFXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.message.success)?_c('div',[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.message.success)+"\n    ")])]):_vm._e(),_vm._v(" "),(!_vm.message.success)?_c('form',{staticClass:"margin-bottom-0",attrs:{"method":"post","action":"#"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.error),expression:"message.error"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.message.error)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-group m-b-15"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.$v.email.$error},attrs:{"type":"text","name":"email","id":"email","placeholder":"Enter your Email"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},function($event){_vm.$v.email.$touch()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.sendSignUp()}}}),_vm._v(" "),(_vm.$v.email.$error)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("Email is not valid.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group m-b-15"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.$v.password.$error},attrs:{"type":"password","name":"password","id":"password","placeholder":"Enter your Password"},domProps:{"value":(_vm.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},function($event){_vm.$v.password.$touch()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.sendSignUp()}}}),_vm._v(" "),(_vm.$v.password.$error)?_c('div',{class:{'invalid-feedback': !_vm.$v.password.minLength}},[_vm._v("Password min length is 6")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group m-b-15"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.$v.confirmPassword.$error},attrs:{"type":"password","name":"confirm","id":"confirm","placeholder":"Confirm your Password"},domProps:{"value":(_vm.confirmPassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value},function($event){_vm.$v.confirmPassword.$touch()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.sendSignUp()}}}),_vm._v(" "),(_vm.$v.confirmPassword.$error)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("This password is not the same.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"login-buttons"},[_c('button',{staticClass:"btn btn-primary get-started  rounded-pill btn-block",staticStyle:{"width":"100%","padding":"10px 16px","font-size":"18px"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.sendSignUp()}}},[_vm._v("Register")])]),_vm._v(" "),_c('div',{staticClass:"m-t-20 m-b-40 p-b-40 text-inverse"},[_vm._v("\n      Already have an account? Click "),_c('router-link',{staticClass:"text-theme",attrs:{"to":{ name: 'Login'}}},[_vm._v("here")]),_vm._v(" to login.\n    ")],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qUbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Rating__ = __webpack_require__("TaMM");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RatingStats',
  props: ['stats'],
  components: { rating: __WEBPACK_IMPORTED_MODULE_0__components_Rating__["a" /* default */] }
});

/***/ }),

/***/ "r1sl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rKME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'banner'
});

/***/ }),

/***/ "rfFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rxOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__("9yGA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__("6yNC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Navbar__ = __webpack_require__("SywA");
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */],
    'nav-bar': __WEBPACK_IMPORTED_MODULE_2__components_Navbar__["a" /* default */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items,
      sidebarWidth: 120
    };
  },

  methods: {
    updateSidebarWidth: function updateSidebarWidth(width) {
      this.sidebarWidth = width;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.updateSidebarWidth(this.$refs.sidebarRef.getSidebarWidth());
    window.addEventListener('resize', function () {
      _this.updateSidebarWidth(_this.$refs.sidebarRef.getSidebarWidth());
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    window.removeEventListener('resize', function () {
      _this2.updateSidebarWidth(_this2.$refs.sidebarRef.getSidebarWidth());
    });
  }
});

/***/ }),

/***/ "sUWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__ = __webpack_require__("U+Dp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d75134_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__ = __webpack_require__("5h2L");
function injectStyle (ssrContext) {
  __webpack_require__("MNJn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24d75134"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d75134_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t9IL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"margin-bottom-0",attrs:{"method":"post","action":"#"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"form-group m-b-15"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.$v.email.$error},attrs:{"type":"text","name":"email","id":"email","placeholder":"Enter your Email"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},function($event){_vm.$v.email.$touch()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.sendLogin()}}}),_vm._v(" "),(_vm.$v.email.$error)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("Email is not valid.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group m-b-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control form-control-lg",class:{'is-invalid': _vm.$v.password.$error},attrs:{"type":"password","name":"password","id":"password","placeholder":"Enter your Password"},domProps:{"value":(_vm.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},function($event){_vm.$v.password.$touch()}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.sendLogin()}}}),_vm._v(" "),(_vm.$v.password.$error)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("Password is not valid.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-inverse pull-right m-b-15"},[_c('router-link',{staticClass:"text-muted",attrs:{"to":{ name: 'ForgotPassword', query: {redirect: _vm.$route.query}}}},[_c('small',[_vm._v("Forgot your password ?")])])],1),_vm._v(" "),_c('div',{staticClass:"login-buttons"},[_c('button',{staticClass:"btn btn-primary get-started rounded-pill btn-block",staticStyle:{"font-size":"18px"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.sendLogin()}}},[_vm._v("Login")])]),_vm._v(" "),_c('div',{staticClass:"m-t-20 m-b-40 p-b-40 text-inverse"},[_vm._v("\n    Not a member yet? Click "),_c('router-link',{staticClass:"text-theme",attrs:{"to":{ name: 'Signup', query: {redirect: _vm.$route.query}}}},[_vm._v("here")]),_vm._v(" to register. "),_c('br')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLSc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__("+jyM");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UploadFileInput",
  components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner__["a" /* default */] },
  props: {
    value: Object,
    type: { type: String, default: "image" },
    width: { default: "auto" },
    height: { default: "100px" },
    id: { type: String, default: "upload-file" },
    show: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      image: null,
      file: null,
      fileToUpload: null,
      isLoading: false
    };
  },

  watch: {
    fileToUpload: function fileToUpload(val) {
      if (this.type === "image") this.createImage(val);
    }
  },
  methods: {
    actionModal: function actionModal() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "show";

      this.fileToUpload = null;
      this.image = null;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + this.id + "-modal").modal(action);
    },
    fileChanged: function fileChanged(e) {
      e.preventDefault();
      this.fileToUpload = e.target.files[0];
      console.log(this.fileToUpload);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.image = e.target.result;
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    upload: function upload() {
      var _this = this;

      this.isLoading = true;
      var formData = new FormData();
      formData.append("file", this.fileToUpload);
      this.$http.post("media", formData).then(function (response) {
        _this.image = null;
        _this.file = response.data;
        _this.$emit("input", response.data);
        // dismiss modal
        _this.actionModal("hide");
        _this.isLoading = false;
      }, function (err) {
        // error callback
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ "tQJA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tR2v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),

/***/ "tfKY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tihL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterBuildYourApp__ = __webpack_require__("Q1v4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'footer-build-your-app': __WEBPACK_IMPORTED_MODULE_0__components_FooterBuildYourApp__["a" /* default */]
  }
});

/***/ }),

/***/ "uLLs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FooterBuildYourApp",
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(["isAuthenticated"]))
});

/***/ }),

/***/ "uMnI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uUvf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_upload_2_vue__ = __webpack_require__("JKY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_aff86978_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_2_vue__ = __webpack_require__("H5e6");
function injectStyle (ssrContext) {
  __webpack_require__("g3/+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_upload_2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_aff86978_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uiif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Rating__ = __webpack_require__("TaMM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RatingStats__ = __webpack_require__("8ZpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Review__ = __webpack_require__("jKoA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gallery__ = __webpack_require__("I4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Product",
    data: function data() {
        return {
            product: null
        };
    },

    components: {
        gallery: __WEBPACK_IMPORTED_MODULE_4_vue_gallery___default.a,
        rating: __WEBPACK_IMPORTED_MODULE_1__components_Rating__["a" /* default */],
        review: __WEBPACK_IMPORTED_MODULE_3__components_Review__["a" /* default */],
        "rating-stats": __WEBPACK_IMPORTED_MODULE_2__components_RatingStats__["a" /* default */]
    },

    created: function created() {
        this.fetchData();
    },
    watch: {
        product: function product(val) {
            if (this.isAuthenticated) {
                this.checkPurchase();
            }
        }
    },
    mounted: function mounted() {
        this.fetchNames();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            var productUri = "product/public/";
            this.$http.get("" + productUri + this.$route.params.slug, {
                params: { populate: "author" }
            }).then(function (response) {
                _this.product = response.body;
                _this.product.reviews = _this.product.reviews || [];
            }, function (response) {
                // error callback
                console.log(response);
            });
        }
    }
});

/***/ }),

/***/ "ukiU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ul0S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBrand_vue__ = __webpack_require__("h8St");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3491b99a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBrand_vue__ = __webpack_require__("EdZe");
function injectStyle (ssrContext) {
  __webpack_require__("99X2")
  __webpack_require__("kxzv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3491b99a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBrand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3491b99a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBrand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vHAx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vOA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPasswordProfile_vue__ = __webpack_require__("Ys4Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a458f98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPasswordProfile_vue__ = __webpack_require__("cO4W");
function injectStyle (ssrContext) {
  __webpack_require__("U241")
  __webpack_require__("Rkxk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a458f98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPasswordProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a458f98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPasswordProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vUmB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__ = __webpack_require__("fHl8");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-header',
  components: {
    HeaderDropdown: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__["a" /* default */]
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),

/***/ "vsSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a6cb72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppsUser_vue__ = __webpack_require__("XkKU");
function injectStyle (ssrContext) {
  __webpack_require__("kput")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08a6cb72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a6cb72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppsUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w/lO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w4Gt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w7bK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w7tA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"btn btn-primary get-started pull-right rounded-pill",attrs:{"to":{ name: 'CreateProductDeveloper'}}},[_c('i',{staticClass:"fa fa-plus-circle p-r-5"}),_vm._v(" "),_c('span',[_vm._v("Add New Catalog")])]),_vm._v(" "),_c('h3',{staticClass:"mb-2"},[_vm._v("My Catalogs")]),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.products || _vm.products.length === 0)?_c('span',[_vm._v("No Catalogs")]):_vm._e(),_vm._v(" "),(_vm.products && _vm.products.length > 0)?_c('div',[_c('div',{staticClass:"note note-purple m-b-15"},[(!_vm.countApprovedApps)?_c('p',{staticClass:"p-0 m-0"},[_vm._v("You don't have an approved Catalog yet.")]):_c('p',{staticClass:"p-0 m-0"},[_vm._v("You have developed "+_vm._s(_vm.countApprovedApps)+" Catalog(s) of which "+_vm._s(_vm.countApprovedFreeApps)+" Free.")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[(_vm.products && _vm.products.length)?_c('table',{staticClass:"table table-hover table-striped m-b-0"},[_vm._m(0,false,false),_vm._v(" "),_vm._l((_vm.products),function(productUpdate){return _c('tbody',{attrs:{"title":productUpdate[0]}},_vm._l((productUpdate[1]),function(product,index){return _c('tr',{key:product._id},[_c('td',[(index === 0)?_c('router-link',{attrs:{"to":{ name: 'Product', params: { slug: product.slug }}}},[_vm._v(_vm._s(product.name))]):_vm._e()],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.technicalDetails.update))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.technicalDetails.version))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label",class:product.status.class},[_vm._v(_vm._s(product.status.label))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(product.created,'YYYY-MM-DD')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.price))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(product.actions.edit)?_c('router-link',{attrs:{"to":{ name: 'EditProductDeveloper', params: { slug: product.slug }}}},[_c('span',{staticClass:"fa fa-edit"})]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-center"},[(product.actions.update)?_c('a',{attrs:{"href":"#update"},on:{"click":function($event){_vm.updateProduct(product)}}},[_c('span',{staticClass:"fa fa-plus-circle"})]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(product.actions.delete)?_c('a',{attrs:{"href":"#delete"},on:{"click":function($event){_vm.deleteAction = { showModal: true, product: product}}}},[_c('span',{staticClass:"fa fa-minus-circle"})]):_vm._e()])])}))})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"confirm-app-modal"},[(_vm.deleteAction.showModal)?_c('modal',{on:{"close":function($event){_vm.deleteAction.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirm delete Catalog")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Are you sure you want to delete the selected catalog?")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('a',{staticClass:"btn btn-outline-info rounded-pill",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteAction.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary get-started rounded-pill",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.deleteProduct(_vm.deleteAction.product)}}},[_vm._v("Delete Catalog")])])]):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Update")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Version")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Created")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Price")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Edit")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Update")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Delete")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "weFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    timeout: {
      type: Number,
      default: 3000
    },
    transition: {
      type: String,
      default: 'slide-fade'
    },
    types: {
      type: Object,
      default: function _default() {
        return {
          base: 'alert',
          success: 'alert-success',
          error: 'alert-danger',
          warning: 'alert-warning',
          info: 'alert-info'
        };
      }
    },
    displayIcons: {
      type: Boolean,
      default: false
    },
    icons: {
      type: Object,
      default: function _default() {
        return {
          base: 'fa',
          error: 'fa-exclamation-circle',
          success: 'fa-check-circle',
          info: 'fa-info-circle',
          warning: 'fa-exclamation-circle'
        };
      }
    }
  },
  /**
  * On creation Flash a message if a message exists otherwise listen for
  * flash event from global event bus
  */
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapGetters(['notifications'])),
  created: function created() {
    var _this = this;

    this.$store.subscribeAction(function (action, state) {
      if (action.type === 'flash') {
        setTimeout(_this.hide, _this.timeout);
      }
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapActions(['unflash']), {
    /**
     * Sets and returns the values needed
     *
     * @param type
     */
    classes: function classes(propObject, type) {
      var classes = {};

      if (propObject.hasOwnProperty('base')) {
        classes[propObject.base] = true;
      }
      if (propObject.hasOwnProperty(type)) {
        classes[propObject[type]] = true;
      }

      return classes;
    },


    /**
    * Hide Our Alert
    *
    * @param item
    */
    hide: function hide() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.notifications[0];

      var key = this.notifications.indexOf(item);
      this.unflash(key);
    }
  })
});

/***/ }),

/***/ "x/RL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-10"},[_c('div',{staticClass:"row gx-lg-5 mb-5"},[_c('div',{staticClass:"col-lg-6 mb-5 mb-lg-0 trait"},[(!_vm.isAuthenticated)?_c('a',{staticClass:"btn w-100 btn-primary get-started rounded-2 fw-bold fs-16px py-3 mb-5",attrs:{"href":"/beta/auth"}},[_vm._v("Distribute Your Data Catalog  ?")]):_c('a',{staticClass:"btn w-100 btn-primary get-started rounded-2 fw-bold fs-16px py-3 mb-5",attrs:{"href":"/beta/developer/dashboard"}},[_vm._v("Distribute Your Data Catalog  ?")])]),_vm._v(" "),_vm._m(1,false,false)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"pt-lg-5 pb-lg-3 text-center"},[_c('b',[_c('div',{staticClass:"display-6 fw-bolder mb-5 d-flex align-items-center justify-content-center colored"},[_vm._v("\n          Let's Work Together\n        ")])]),_vm._v(" "),_c('p',{staticClass:"fs-18px mb-5 text-align-center"},[_vm._v("\n        Womia provides the tools for distributing and annotating your own Data Catalog."),_c('br'),_vm._v(" You can focus on what makes your Data Catalog unique\n      ")]),_vm._v(" "),_c('div',{staticClass:"sparator",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.2)","margin":"0 280px 35px"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-6 trait"},[_c('a',{staticClass:"btn btn-lg d-block w-100 btn-default rounded-2 fw-bold fs-16px py-3 mb-5",attrs:{"href":"/beta/contact-us"}},[_vm._v("Annotate your Data Catalog ?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xHka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile'
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flash__ = __webpack_require__("2Z9n");

//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_moment___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('media', function (value, options) {
  options = options || {};
  var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options).reduce(function (params, key) {
    params.set(key, options[key]);
    return params;
  }, new URLSearchParams()).toString();

  return "https://app-bcbc6e14-34fc-4792-b999-af070ceae2e9.cleverapps.io" + '/media/' + value + '?' + params;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('certifications', function (value) {
  value = value || [];
  if (value.length > 0) {
    value = value.join(', ');
    value = value.toUpperCase();
    return value;
  } else {
    return 'Research use only';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('tooltip', function (el, binding) {
  __WEBPACK_IMPORTED_MODULE_3_jquery___default()(el).tooltip({
    title: binding.value,
    placement: binding.arg,
    trigger: 'hover'
  });
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { flash: __WEBPACK_IMPORTED_MODULE_4__components_Flash__["a" /* default */] }
});

/***/ }),

/***/ "xhzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("Q9bD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b674080_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("5VP9");
function injectStyle (ssrContext) {
  __webpack_require__("99g6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b674080"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b674080_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yERT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ForgotPassword',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] }
  },
  data: function data() {
    return {
      email: null,
      message: {
        error: false,
        success: false
      }
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].mapActions(['renewPassword']), {
    showErrorMessage: function showErrorMessage(message) {
      this.message.error = message;
    },
    showSuccessMessage: function showSuccessMessage(message) {
      this.message.error = null;
      this.message.success = message;
    },

    ask: function ask() {
      var _this = this;

      if (!this.$v.email.$invalid) {
        this.renewPassword({ email: this.email }).then(function () {
          return _this.showSuccessMessage('Please check your email address for password reset instructions');
        }).catch(function (err) {
          var errMsgObj = JSON.parse(err.message);
          if (errMsgObj.message === 'renewPassword.email.notRegistred') {
            errMsgObj.messageText = 'The email address you have entered is not registered';
          } else {
            errMsgObj.messageText = 'Error when asking to change password';
          }
          _this.showErrorMessage(errMsgObj.messageText);
        });
      } else {
        this.$v.email.$touch();
        this.showErrorMessage('Form is not valid, check before submit');
      }
    }
  })
});

/***/ }),

/***/ "yLAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-stats"},_vm._l((_vm.stats),function(value,key){return _c('div',{key:key},[_c('span',{staticClass:"rating-count mr-2"},[_vm._v(_vm._s(value))]),_vm._v(" "),_c('rating',{staticClass:"rating-lg",attrs:{"rate":Number.parseInt(key)}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ya0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light section-container p-t-20"},[_c('div',{staticClass:"container to-resp "},[_c('div',{staticClass:"account-container",staticStyle:{"min-height":"600px"}},[_c('div',{staticClass:"account-sidebar"},[_c('div',{staticClass:"account-sidebar-cover"}),_vm._v(" "),_c('div',{staticClass:"account-sidebar-content"},[_c('h4',[_vm._v("Personal Account")]),_vm._v(" "),_c('ul',{staticClass:"nav nav-list"},[_c('li',[_c('router-link',{staticClass:"nav-link hover-orange",attrs:{"to":{ name: 'Profile'}}},[_vm._v("My profile")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"nav-link hover-orange",attrs:{"to":{ name: 'EditProfile'}}},[_vm._v("Edit profile")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"nav-link hover-orange",attrs:{"to":{ name: 'EditPasswordProfile'}}},[_vm._v("Change password")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"nav-link hover-orange",attrs:{"to":{ name: 'MyPurchases'}}},[_vm._v("My requests")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"account-body"},[_c('router-view',{staticClass:"p-l-40 p-r-40"})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ynBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zGew":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bd6d7ae403996760ae1b.js